// src/components/admin/ProductManagement.tsx (FULLY UPDATED WITH SCROLL FIXES)
import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import 'react-quill/dist/quill.snow.css';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Pagination,
  IconButton,
  Typography,
  Avatar,
  useMediaQuery,
  useTheme,
  Drawer,
  CircularProgress,
  Alert,
  Snackbar,
  Button,
  TextField,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  Card,
  CardContent,
  Chip,
  FormHelperText,
  Tab,
  Tabs,
  Grid,
  List,
  ListItem,
  ListItemText,
  Divider,
  Switch,
  FormControlLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Badge,
  Menu,
  DialogContentText,
  Stack,
  Checkbox,
  ListItemIcon,
  ListItemButton,
  Tooltip,
  FormGroup,
  FormLabel,
  styled,
  Popover,
  OutlinedInput,
  Fab, // Add this for floating action button
} from '@mui/material';
import {
  Delete,
  Edit,
  Add,
  Search,
  Refresh,
  PhotoCamera,
  Close,
  Inventory,
  AttachMoney,
  LocalShipping,
  ExpandMore,
  Palette,
  TrendingUp,
  Category,
  Style,
  Star,
  StarBorder,
  MoreVert,
  LocalOffer,
  CalendarToday,
  ShoppingBasket,
  Person,
  Store,
  Whatshot,
  FilterList,
  ViewColumn,
  ArrowDropDown,
  ArrowBack,
  ArrowForward,
  Inventory2,
  Warning,
  CheckCircle,
  Save,
  AssignmentReturn,
  Info,
  Timer,
  CalendarMonth,
  Check,
  Receipt,
  Percent,
  Shield,
  CardGiftcard,
  FilterAlt,
  Clear,
  Tune,
  Sort,
  UnfoldMore,
  ExpandLess,
  ArrowUpward, // Add this
  ArrowDownward,
  Payments,// Add this
  PlayCircleOutline,
} from '@mui/icons-material';
import { Clear as ClearIcon } from '@mui/icons-material';
import Slidemenu from '../../components/admin/adminSlidemenu.tsx';
import AdminHeader from '../../components/admin/adminHeader.tsx';
import PricePackManager from './PricePackManager.tsx';
import PropertyManager from './PropertyManager.tsx';
import { toast } from 'react-toastify';

// Import all API hooks and types
import {
  useListProductsQuery,
  useDeleteProductMutation,
  useGetProductCountQuery,
  useAddProductMutation,
  useUpdateProductMutation,
  useGetProductDetailQuery,
  useGetAdminProductMediaQuery,
  useGetProductColorsQuery,
  useAddProductColorMutation,
  useUpdateProductColorMutation,
  useDeleteProductColorMutation,
  useGetProductsByCategoryQuery,
  useGetProductsBySubcategoryQuery,
  useGetPopularProductsQuery,
  useSetPopularProductMutation,
  useRemovePopularProductMutation,
  useGetPopularProductsCountQuery,
  Product,
  ProductFormData,
  ProductColor,
  FormErrors,
  SnackbarState,
  API_CONFIG,
  UpdateProductRequest,
  useAddProductImageMutation,
  useDeleteProductImageMutation,
  useUpdateProductImageMutation,
  useGetProductSizesQuery,
  useAddProductSizeMutation,
  useUpdateProductSizeMutation,
  useDeleteProductSizeMutation,
  ProductSize,
  PopularProduct,
  // Bundle imports
  useListBundlesQuery,
  useAddBundleMutation,
  useUpdateBundleMutation,
  useDeleteBundleMutation,
  useGetBundleDetailQuery,
  useGetBundleCountQuery,
  useSetBulkOrderMutation,
  Bundle,
  BundleProduct,
  BundleFormData,
  // Reward imports
  useSetProductRewardMutation,
  useRemoveProductRewardMutation,
  SetProductRewardRequest,
  ProductRewardResponse,
  // Open Box imports
  useSetOpenBoxMutation,
  OpenBoxSettings,
  useUpdateProductDeliveryModelsMutation,
  useLazyGetProductDeliveryModelsQuery,
} from '../../features/admin/productApi.ts';


import {
  useListCategoriesQuery,
} from '../../features/admin/categoryApi.ts';
import {
  useListSubCategoriesQuery,
} from '../../features/admin/subcategoryApi.ts';

// Import Unit Management API from UnitManagement.tsx
import {
  useListUnitsQuery,
} from '../../features/admin/unitApi.ts';

import ColorManager from '../admin/ColorManager.tsx';
import SizeManager from '../admin/SizeManager.tsx';

// Import Flash Sale API
import {
  useAddFlashSaleMutation,
} from '../../features/admin/flashSaleApi.ts';

// Add Deal of the Day API import
import {
  useAddDealMutation,
} from '../../features/admin/dealoftheday.ts';

// Add these imports for Shipping and Delivery Models
import {
  useListShippingChargesQuery,
  ShippingCharge,
} from '../../features/admin/shippingApi.ts';

import {
  useListDeliveryModelsQuery,
  DeliveryModel,
} from '../../features/admin/deliveryApi.ts';

// Import Warehouse API
import {
  useListWarehousesQuery,
  Warehouse,
} from '../../features/admin/warehouseApi.ts';

// Import Product Warehouse Stock API
import {
  useListProductWarehousesQuery,
  useAddProductWarehouseMutation,
  useUpdateProductWarehouseMutation,
  useDeleteProductWarehouseMutation,
  ProductWarehouse,
} from '../../features/admin/productWarehouseApi.ts';

// Import Product Return API for individual product return limits
import {
  useGetProductReturnLimitByIdQuery,
  useSetProductReturnLimitMutation,
  useGetProductTaxQuery,
  useGetProductTaxByIdQuery,
  useSetProductTaxMutation,
} from '../../features/admin/globalSettingsApi.ts';

import {
  useListPaymentMethodsQuery,
  PaymentMethod,
} from '../../features/admin/caseOnDeliveryApi.ts';

// Import Warranty API
import {
  useListWarrantiesByProductQuery,
  useAddWarrantyMutation,
  useUpdateWarrantyMutation,
  useDeleteWarrantyMutation,
  useListAllWarrantiesQuery,
  Warranty,
  WarrantyFormData,
  WARRANTY_PERIOD_OPTIONS,
} from '../../features/admin/warrantyApi.ts';

import ReactQuill from 'react-quill';

// Styled Components for Responsive Design
const ResponsiveTableContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  position: 'relative',
  '&::-webkit-scrollbar': {
    height: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1',
  },
  '&::-webkit-scrollbar-thumb': {
    background: '#888',
    borderRadius: '4px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#555',
  },
  '& .MuiTableCell-root': {
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('md')]: {
      padding: '8px 4px',
      fontSize: '12px',
    },
  },
}));

const FoldableSection = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  marginBottom: theme.spacing(2),
  overflow: 'hidden',
}));

const SectionHeader = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.grey[50],
  padding: theme.spacing(1.5, 2),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  cursor: 'pointer',
  borderBottom: '1px solid transparent',
  '&:hover': {
    backgroundColor: theme.palette.grey[100],
  },
}));

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`product-form-tabpanel-${index}`}
      aria-labelledby={`product-form-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 3 }}>{children}</Box>}
    </div>
  );
}

const getVendorIdFromToken = (): string | null => {
  try {
    const token = localStorage.getItem('vendor_token');
    if (!token) return null;
    const payload = JSON.parse(atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
    const id = payload?.vendor_id ?? payload?.vendorId ?? payload?.id ?? payload?.user_id;
    return id != null ? String(id) : null;
  } catch {
    return null;
  }
};

// ── Product media upload rules (shown to the user + enforced before upload) ──
const PRODUCT_IMAGE_RECOMMENDED = '1000 × 1000 px (square, minimum 800 × 800 px)';
const PRODUCT_IMAGE_MAX_MB = 5;
const PRODUCT_VIDEO_MAX_MB = 100;
const ADDITIONAL_IMAGE_TYPES = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
const ADDITIONAL_VIDEO_TYPES = ['video/mp4', 'video/mpeg', 'video/quicktime', 'video/x-msvideo', 'video/x-matroska'];
const ADDITIONAL_MEDIA_ACCEPT = [
  ...ADDITIONAL_IMAGE_TYPES, ...ADDITIONAL_VIDEO_TYPES, '.mp4', '.mov', '.avi', '.mkv',
].join(',');
const isVideoFilename = (name?: string) => /\.(mp4|mov|avi|mkv|mpeg|mpg)$/i.test(String(name || ''));
const fileSizeLabel = (bytes: number) => `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
// Returns an error message when the file can't be uploaded, otherwise null.
const validateAdditionalMedia = (file: File): string | null => {
  const isVideo = ADDITIONAL_VIDEO_TYPES.includes(file.type) || isVideoFilename(file.name);
  const isImage = ADDITIONAL_IMAGE_TYPES.includes(file.type);
  if (!isVideo && !isImage) {
    return `${file.name}: unsupported file. Use JPG, PNG, WebP images or MP4, MOV, AVI, MKV videos.`;
  }
  const limitMB = isVideo ? PRODUCT_VIDEO_MAX_MB : PRODUCT_IMAGE_MAX_MB;
  if (file.size > limitMB * 1024 * 1024) {
    return `${file.name} is too large (${fileSizeLabel(file.size)}). Max ${limitMB} MB for ${isVideo ? 'videos' : 'images'}.`;
  }
  return null;
};

const ProductManagement: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md'));
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const dispatch = useDispatch();

  // Add scroll state
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showScrollBottom, setShowScrollBottom] = useState(false);
  const tableScrollRef = useRef<HTMLDivElement | null>(null);
  const topScrollRef = useRef<HTMLDivElement | null>(null);
  const topScrollInnerRef = useRef<HTMLDivElement | null>(null);
  const isSyncingScroll = useRef(false);
  const [canScrollLeft, setCanScrollLeft] = useState(false);
  const [canScrollRight, setCanScrollRight] = useState(false);

  // Get user role and vendor ID from Redux store
  const { role: reduxRole, vendorId: reduxVendorId, userName: reduxUserName } = useSelector((state: any) => state.auth);
  // Keep vendor isolation after a hard refresh as well as immediately after login.
  const storedRole = (localStorage.getItem('user_role') || '').toLowerCase().trim();
  const role = reduxRole || storedRole;
  const vendorId = reduxVendorId || localStorage.getItem('vendor_id') || getVendorIdFromToken();
  const userName = reduxUserName || localStorage.getItem('user_name') || 'Vendor';
  const isVendor = role === 'vendor';
  // Normalize vendor ids before comparing them. API responses can return
  // vendor_id as a number while localStorage/Redux commonly stores it as a
  // string. A strict comparison here was incorrectly disabling Edit/Delete
  // for the vendor's own products.
  const normalizedVendorId = vendorId != null && String(vendorId).trim() !== ''
    ? Number(vendorId)
    : null;
  const isOwnVendorProduct = (item: any) => {
    if (!isVendor) return true;
    const itemVendorId = item?.vendor_id ?? item?.seller_id ?? item?.vendorId;
    return itemVendorId != null && normalizedVendorId != null &&
      Number(itemVendorId) === normalizedVendorId;
  };
  const normalizedAdminRole = String(localStorage.getItem('admin_type') || role || '').trim().toLowerCase().replace(/[-_]+/g, ' ');
  const isSuperAdmin = normalizedAdminRole === 'super admin' || normalizedAdminRole === 'superadmin';

  // Live global VAT/tax default (site-wide setting configured by Super Admin
  // under Tax Settings). Vendors and non-Super-Admins never see a hardcoded
  // 0/5 — they always see whatever the admin has configured, auto-fetched,
  // and read-only. Super Admin can still override per product afterwards.
  const { data: globalTaxData } = useGetProductTaxQuery();
  const globalTaxPer = globalTaxData?.tax_per !== undefined && globalTaxData?.tax_per !== null && globalTaxData?.tax_per !== ''
    ? Number(globalTaxData.tax_per)
    : 5;
  const globalTaxName = globalTaxData?.tax_name || 'VAT';

  const [page, setPage] = useState(1);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchStr, setSearchStr] = useState('');
  // Admin-only: search/filter the product list by vendor name or vendor id.
  const [vendorSearchStr, setVendorSearchStr] = useState('');
  const [snackbar, setSnackbar] = useState<SnackbarState>({
    open: false,
    message: '',
    severity: 'success'
  });

  // Product type state (Single vs Bundle)
  const [productType, setProductType] = useState<'single' | 'bundle'>('single');

  // Shopify-style filter states
  const [statusFilter, setStatusFilter] = useState<string>('all');
  const [availabilityFilter, setAvailabilityFilter] = useState<string>('all');
  const [categoryFilter, setCategoryFilter] = useState<string>('all');
  const [subCategoryFilter, setSubCategoryFilter] = useState<string>('all');
  const [sortBy, setSortBy] = useState<string>('newest');
  const [stockFilter, setStockFilter] = useState<string>('all');
  const [discountFilter, setDiscountFilter] = useState<string>('all');
  const [approvalFilter, setApprovalFilter] = useState<string>('all');

  // Category filter states
  const [filterAnchorEl, setFilterAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
  const [selectedSubCategories, setSelectedSubCategories] = useState<number[]>([]);

  // Popular products state
  const [popularProductsView, setPopularProductsView] = useState(false);
  const [popularPage, setPopularPage] = useState(1);
  const [popularSearchStr, setPopularSearchStr] = useState('');

  // Delivery Method Management Dialog State
  const [deliveryMethodDialogOpen, setDeliveryMethodDialogOpen] = useState(false);
  const [selectedProductForDelivery, setSelectedProductForDelivery] = useState<Product | Bundle | null>(null);
  const [selectedDeliveryModels, setSelectedDeliveryModels] = useState<number[]>([]);
  const [availableDeliveryModels, setAvailableDeliveryModels] = useState<DeliveryModel[]>([]);
  const [defaultDeliveryModelId, setDefaultDeliveryModelId] = useState<number | null>(null);
  const [tempDeliveryModels, setTempDeliveryModels] = useState<number[]>([]);
  const [tempBundleDeliveryModels, setTempBundleDeliveryModels] = useState<number[]>([]);

  // Menu state for popular actions
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);
  const [scoreDialogOpen, setScoreDialogOpen] = useState(false);
  const [popularScore, setPopularScore] = useState<number>(100);

  // Flash Sale state
  const [flashSaleDialogOpen, setFlashSaleDialogOpen] = useState(false);
  const [selectedProductForFlashSale, setSelectedProductForFlashSale] = useState<Product | null>(null);
  const [flashSaleFormData, setFlashSaleFormData] = useState({
    start_date: '',
    end_date: '',
    active: true,
  });
  const [flashSaleFormErrors, setFlashSaleFormErrors] = useState<{
    start_date?: string;
    end_date?: string;
  }>({});

  const [codEnabled, setCodEnabled] = useState<0 | 1>(0);
  const [codCharge, setCodCharge] = useState<string>('0');
  const [codFormErrors, setCodFormErrors] = useState<{
    cod_charge?: string;
  }>({});

  const { data: paymentMethodsResponse, refetch: refetchPaymentMethods } = useListPaymentMethodsQuery();

  // Warehouse stock management state
  const [warehouseStockDialogOpen, setWarehouseStockDialogOpen] = useState(false);
  const [selectedProductForWarehouse, setSelectedProductForWarehouse] = useState<Product | null>(null);
  const [warehouseStocks, setWarehouseStocks] = useState<{ warehouse_id: number, available_quantity: number }[]>([]);
  const [selectedWarehouseId, setSelectedWarehouseId] = useState<string>('');

  // Product Return Limit state
  const [productReturnLimit, setProductReturnLimit] = useState<string>('0');
  const [selectedProductForReturnLimit, setSelectedProductForReturnLimit] = useState<Product | null>(null);
  const [returnLimitDialogOpen, setReturnLimitDialogOpen] = useState(false);
  const [returnLimitSnackbar, setReturnLimitSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' as 'success' | 'error'
  });

  // Product Tax Management State
  const [productTaxDialogOpen, setProductTaxDialogOpen] = useState(false);
  const [selectedProductForTax, setSelectedProductForTax] = useState<Product | null>(null);
  const [productTaxName, setProductTaxName] = useState('VAT');
  const [productTaxPercentage, setProductTaxPercentage] = useState('5');
  const [productTaxCurrency, setProductTaxCurrency] = useState('AED');
  const [productTaxSnackbar, setProductTaxSnackbar] = useState({
    open: false,
    message: '',
    severity: 'success' as 'success' | 'error'
  });

  // Warranty Management State
  const [warrantyDialogOpen, setWarrantyDialogOpen] = useState(false);
  const [selectedProductForWarranty, setSelectedProductForWarranty] = useState<Product | null>(null);
  const [editingWarranty, setEditingWarranty] = useState<Warranty | null>(null);
  const [warrantyFormData, setWarrantyFormData] = useState<WarrantyFormData>({
    product_id: 0,
    warranty_name: '',
    warranty_period: 'month',
    no_of_period: 6,
    description: '',
    features: '',
    price: 0,
    additional_cost: 0,
  });
  const [warrantyFormErrors, setWarrantyFormErrors] = useState<{ [key: string]: string }>({});
  const [warranties, setWarranties] = useState<Warranty[]>([]);
  const [selectedWarrantyIds, setSelectedWarrantyIds] = useState<number[]>([]);

  // Reward Product Dialog State
  const [rewardDialogOpen, setRewardDialogOpen] = useState(false);
  const [selectedProductForReward, setSelectedProductForReward] = useState<Product | null>(null);
  const [rewardFormData, setRewardFormData] = useState({
    is_reward: 0 as 0 | 1,
    reward_points: 0,
  });
  const [rewardFormErrors, setRewardFormErrors] = useState<{
    reward_points?: string;
  }>({});

  // Open Box Delivery Dialog State
  const [openBoxDialogOpen, setOpenBoxDialogOpen] = useState(false);
  const [selectedProductForOpenBox, setSelectedProductForOpenBox] = useState<Product | null>(null);
  const [openBoxFormData, setOpenBoxFormData] = useState({
    open_box_delivery: 0 as 0 | 1,
    open_box_charge: 0,
  });
  const [openBoxFormErrors, setOpenBoxFormErrors] = useState<{
    open_box_charge?: string;
  }>({});

  // Add state for filter menu
  const [columnAnchorEl, setColumnAnchorEl] = useState<null | HTMLElement>(null);

  // Deal of the Day state
  const [dealOfTheDayDialogOpen, setDealOfTheDayDialogOpen] = useState(false);
  const [selectedProductForDeal, setSelectedProductForDeal] = useState<Product | null>(null);
  const [dealFormData, setDealFormData] = useState({
    start_date: '',
    end_date: '',
    discount: '',
    status: 1,
  });
  const [dealFormErrors, setDealFormErrors] = useState<{
    start_date?: string;
    end_date?: string;
    discount?: string;
  }>({});

  // Form related states
  const [formOpen, setFormOpen] = useState(false);
  const [detailOpen, setDetailOpen] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  // Admin product ownership tabs: all products, Fortune Five/own products, vendor products.
  const [productScope, setProductScope] = useState<'all' | 'own' | 'vendor'>('all');
  const [editingProduct, setEditingProduct] = useState<Product | null>(null);
  const [editingBundle, setEditingBundle] = useState<Bundle | null>(null);
  const [selectedProductId, setSelectedProductId] = useState<number | null>(null);

  // Updated formData with delivery model handling
  const [formData, setFormData] = useState<any>({
    product_name: '',
    product_short_name: '',
    product_desc: '',
    status: 1,
    product_unit: 'pcs',
    product_quantity: 1,
    currency: 'AED',
    product_price: 0,
    product_retail_price: 0,
    discount_type: 0,
    product_discount: 0,
    cat_id: 0,
    sub_cat_id: undefined,
    availability: 0,
    max_order_quantity: 10,
    min_quantity: 10,
    product_stock: 1,
    price_priority: 1,
    delivery_model: [], // Array for multiple delivery methods
    shipping_model: 1,
    tax1_name: 'VAT',
    tax1_per: 0,
    tax2_name: 'GST',
    tax2_per: 0,
    popular_score: 0,
    vendor_id: isVendor ? vendorId : undefined,
    // Warehouse related fields
    warehouse_id: null,
    warehouse_stocks: [],
    // Open Box Delivery fields
    open_box_delivery: 0,
    open_box_charge: 0,
    cod_available: 1,  // Default to 1 (enabled)
  });

  // Bundle form date
  const [bundleFormData, setBundleFormData] = useState<BundleFormData>({
    bundle_name: '',
    bundle_short_name: '', // Ensure this is always initialized as empty string
    bundle_desc: '',
    status: 1,
    currency: 'AED',
    bundle_price: 0,
    bundle_retail_price: 0,
    discount_type: 0,
    bundle_discount: 0,
    cat_id: 0,
    sub_cat_id: undefined,
    availability: 0,
    max_order_quantity: 10,
    bundle_stock: 0,
    price_priority: 1,
    delivery_model: [], // Array for multiple delivery methods
    shipping_model: 1,
    tax1_name: 'VAT',
    tax1_per: 0,
    tax2_name: 'GST',
    tax2_per: 0,
    popular_score: 0,
    vendor_id: isVendor ? vendorId : undefined,
    products: [],
  });

  const [selectedImage, setSelectedImage] = useState<File | null>(null);
  const [imagePreview, setImagePreview] = useState<string>('');
  const [formErrors, setFormErrors] = useState<FormErrors>({});
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);

  // Bundle product selection
  const [availableProducts, setAvailableProducts] = useState<Product[]>([]);
  const [selectedProducts, setSelectedProducts] = useState<BundleProduct[]>([]);
  const [productQuantities, setProductQuantities] = useState<{ [key: number]: number }>({});

  /* additional product images */
  const [addAdditionalProductImageMutation, { isLoading: uploading }] = useAddProductImageMutation();
  const [deleteadditionalProductImage, { isLoading: deleting }] = useDeleteProductImageMutation();
  const [updateadditionalProductImage, { isLoading: updating }] = useUpdateProductImageMutation();
  const [deletingImageId, setDeletingImageId] = useState<string | null>(null);
  const [updatingImageId, setUpdatingImageId] = useState<string | null>(null);

  // Color management states
  const [colorDialogOpen, setColorDialogOpen] = useState(false);
  const [editingColor, setEditingColor] = useState<ProductColor | null>(null);
  const [colorForm, setColorForm] = useState({
    color: '',
    price: 0,
    retail_price: 0,
    color_image: null as File | null,
  });
  const [colorImagePreview, setColorImagePreview] = useState<string>('');

  // Shipping and Delivery Model states
  const [shippingModels, setShippingModels] = useState<ShippingCharge[]>([]);
  const [deliveryModels, setDeliveryModels] = useState<DeliveryModel[]>([]);
  const [defaultDeliveryModel, setDefaultDeliveryModel] = useState<DeliveryModel | null>(null);

  // Warehouse data
  const [warehouses, setWarehouses] = useState<Warehouse[]>([]);
  const [productWarehouses, setProductWarehouses] = useState<ProductWarehouse[]>([]);
  const [isLoadingWarehouses, setIsLoadingWarehouses] = useState(false);

  // Size and Color data states
  const [productSizes, setProductSizes] = useState<ProductSize[]>([]);
  const [productColors, setProductColors] = useState<ProductColor[]>([]);

  const productsPerPage = 10;

  // API hooks
  // API call ல filter apply ஆகும்:
  const {
    data: productsResponse,
    isLoading,
    error,
    isError,
    refetch
  } = useListProductsQuery({
    page,
    limit: productsPerPage,
    search_str: searchStr,
    vendor_id: isVendor ? vendorId : undefined,
    vendor_search: isVendor ? undefined : (vendorSearchStr || undefined),
    scope: isVendor ? 'vendor' : productScope,
    cat_id: categoryFilter !== 'all' ? Number(categoryFilter) : undefined, // Category filter
    sub_cat_id: subCategoryFilter !== 'all' ? Number(subCategoryFilter) : undefined, // Subcategory filter
    status: statusFilter !== 'all' ? Number(statusFilter) : undefined,
    availability: availabilityFilter !== 'all' ? Number(availabilityFilter) : undefined,
    approval_status: isVendor ? undefined : approvalFilter,
    stock_filter: stockFilter as any,
    discount_filter: discountFilter as any,
    sortby: sortBy,
    sortorder: 'desc',
  }, {
    // Vendor product approve/reject/block (VendorProductApprovals.tsx) and
    // vendor-side media uploads happen through plain fetch() calls, not
    // through this RTK Query API slice, so this cache never gets
    // invalidated automatically. Without this, navigating back to Product
    // Management re-used the stale cached list and only a hard browser
    // refresh (which wipes the cache) showed the updated approval status /
    // newly uploaded image or video. Refetching on every mount keeps this
    // list live without needing a manual page refresh.
    refetchOnMountOrArgChange: true,
  });

  // Bundle API hooks
  const {
    data: bundlesResponse,
    isLoading: isLoadingBundles,
    error: bundlesError,
    isError: isBundlesError,
    refetch: refetchBundles
  } = useListBundlesQuery({
    page,
    limit: productsPerPage,
    search_str: searchStr,
    vendor_id: isVendor ? vendorId : undefined,
    scope: isVendor ? 'vendor' : productScope,
    cat_id: categoryFilter !== 'all' ? Number(categoryFilter) : undefined,
    sub_cat_id: subCategoryFilter !== 'all' ? Number(subCategoryFilter) : undefined,
    status: statusFilter !== 'all' ? Number(statusFilter) : undefined,
    availability: availabilityFilter !== 'all' ? Number(availabilityFilter) : undefined,
  });

  const {
    data: countResponse,
    refetch: refetchCount
  } = useGetProductCountQuery({
    search_str: searchStr,
    vendor_id: isVendor ? vendorId : undefined,
    vendor_search: isVendor ? undefined : (vendorSearchStr || undefined),
    cat_id: categoryFilter !== 'all' ? Number(categoryFilter) : undefined,
    sub_cat_id: subCategoryFilter !== 'all' ? Number(subCategoryFilter) : undefined,
    status: statusFilter !== 'all' ? Number(statusFilter) : undefined,
    availability: availabilityFilter !== 'all' ? Number(availabilityFilter) : undefined,
    approval_status: isVendor ? undefined : approvalFilter,
    stock_filter: stockFilter as any,
    discount_filter: discountFilter as any,
  });

  const {
    data: bundleCountResponse,
    refetch: refetchBundleCount
  } = useGetBundleCountQuery({
    search_str: searchStr,
    vendor_id: isVendor ? vendorId : undefined,
    cat_id: categoryFilter !== 'all' ? Number(categoryFilter) : undefined,
    sub_cat_id: subCategoryFilter !== 'all' ? Number(subCategoryFilter) : undefined,
    status: statusFilter !== 'all' ? Number(statusFilter) : undefined,
    availability: availabilityFilter !== 'all' ? Number(availabilityFilter) : undefined,
  });

  const {
    data: popularProductsResponse,
    isLoading: isLoadingPopular,
    error: popularError,
    isError: isPopularError,
    refetch: refetchPopularProducts
  } = useGetPopularProductsQuery({
    page: popularPage,
    limit: productsPerPage,
    search_str: popularSearchStr,
    vendor_id: isVendor ? vendorId : undefined
  }, {
    skip: !popularProductsView
  });

  const {
    data: popularCountResponse,
    refetch: refetchPopularCount
  } = useGetPopularProductsCountQuery({
    search_str: popularSearchStr,
    vendor_id: isVendor ? vendorId : undefined
  }, {
    skip: !popularProductsView
  });

  // Product Return API hooks
  const {
    data: productReturnData,
    isLoading: isReturnLimitLoading,
    refetch: refetchProductReturnLimit
  } = useGetProductReturnLimitByIdQuery(
    { product_id: selectedProductForReturnLimit?.id || selectedProductForReturnLimit?.product_id || 0 },
    { skip: !selectedProductForReturnLimit }
  );

  const [setProductReturnLimitMutation, { isLoading: isSettingReturnLimit }] = useSetProductReturnLimitMutation();

  // Product Tax API hooks
  const {
    data: productTaxData,
    isLoading: isProductTaxLoading,
    refetch: refetchProductTax
  } = useGetProductTaxByIdQuery(
    { product_id: selectedProductForTax?.id || selectedProductForTax?.product_id || 0 },
    { skip: !selectedProductForTax }
  );

  const [setProductTaxMutation, { isLoading: isSettingProductTax }] = useSetProductTaxMutation();

  // Warranty API hooks
  const {
    data: warrantiesData,
    isLoading: isWarrantiesLoading,
    refetch: refetchWarranties
  } = useListWarrantiesByProductQuery(
    { product_id: selectedProductForWarranty?.id || selectedProductForWarranty?.product_id || 0 },
    { skip: !selectedProductForWarranty }
  );

  const {
    data: allWarrantiesData,
    isLoading: isLoadingAllWarranties,
  } = useListAllWarrantiesQuery(undefined);

  const allWarranties = allWarrantiesData?.data || [];

  const [addWarranty, { isLoading: isAddingWarranty }] = useAddWarrantyMutation();
  const [updateWarranty, { isLoading: isUpdatingWarranty }] = useUpdateWarrantyMutation();
  const [deleteWarranty, { isLoading: isDeletingWarranty }] = useDeleteWarrantyMutation();

  // Reward Product API hooks
  const [setProductReward, { isLoading: isSettingReward }] = useSetProductRewardMutation();
  const [removeProductReward, { isLoading: isRemovingReward }] = useRemoveProductRewardMutation();

  // Open Box Delivery API hooks
  const [setOpenBox, { isLoading: isSettingOpenBox }] = useSetOpenBoxMutation();

  // Unit Management API hook
  const {
    data: unitsResponse,
    isLoading: isLoadingUnits,
    refetch: refetchUnits
  } = useListUnitsQuery({});

  const { data: categoriesResponse } = useListCategoriesQuery({});
  const { data: subCategoriesResponse, refetch: refetchSubCategories } = useListSubCategoriesQuery(
    { cat_id: productType === 'bundle' ? bundleFormData.cat_id : formData.cat_id },
    { skip: productType === 'bundle' ? !bundleFormData.cat_id : !formData.cat_id }
  );

  // Sub-categories for the list FILTER (independent of the add/edit form's category)
  const { data: filterSubCategoriesResponse } = useListSubCategoriesQuery(
    { cat_id: Number(categoryFilter) },
    { skip: categoryFilter === 'all' }
  );

  const { data: productDetailResponse, refetch: refetchProductDetail, isUninitialized: productDetailUninitialized } = useGetProductDetailQuery(
    { product_id: selectedProductId as number },
    { skip: !selectedProductId }
  );

  // Fallback source for additional images/video. getProductDetail hits the
  // customer-storefront '/product/find' endpoint, which only returns data
  // for LIVE/approved products — so a vendor's uploaded media was invisible
  // here until the product got approved. This admin-scoped endpoint has no
  // approval gate, so it's used below whenever the primary response has no
  // images for the product being edited.
  const { data: adminProductMediaResponse, refetch: refetchAdminProductMedia, isUninitialized: adminProductMediaUninitialized } = useGetAdminProductMediaQuery(
    { product_id: selectedProductId as number },
    { skip: !selectedProductId }
  );

  const { data: productColorsResponse, refetch: refetchProductColors } = useGetProductColorsQuery(
    { product_id: selectedProductId as number },
    { skip: !selectedProductId }
  );

  const { data: productSizesResponse, refetch: refetchProductSizes } = useGetProductSizesQuery(
    { product_id: selectedProductId as number },
    { skip: !selectedProductId }
  );

  // Warehouse API hooks
  const {
    data: warehousesResponse,
    refetch: refetchWarehouses
  } = useListWarehousesQuery();

  // Product Warehouse API hooks
  const {
    data: productWarehousesResponse,
    refetch: refetchProductWarehouses
  } = useListProductWarehousesQuery(
    { product_id: selectedProductForWarehouse?.id || selectedProductForWarehouse?.product_id || 0 },
    { skip: !selectedProductForWarehouse }
  );

  const [addProductWarehouse] = useAddProductWarehouseMutation();
  const [updateProductWarehouse] = useUpdateProductWarehouseMutation();
  const [deleteProductWarehouse] = useDeleteProductWarehouseMutation();

  // Bundle mutations
  const [addBundle, { isLoading: isAddingBundle }] = useAddBundleMutation();
  const [updateBundle, { isLoading: isUpdatingBundle }] = useUpdateBundleMutation();
  const [deleteBundle, { isLoading: isDeletingBundle }] = useDeleteBundleMutation();
  const [bulkOrderDialogOpen, setBulkOrderDialogOpen] = useState(false);
  const [selectedProductForBulkOrder, setSelectedProductForBulkOrder] = useState<Product | null>(null);
  const [bulkOrderStatus, setBulkOrderStatus] = useState<0 | 1>(0);

  // Add the mutation hook
  const [setBulkOrder, { isLoading: isSettingBulkOrder }] = useSetBulkOrderMutation();
  const [deleteProduct, { isLoading: isDeleting }] = useDeleteProductMutation();
  const [addProduct] = useAddProductMutation();
  const [updateProduct] = useUpdateProductMutation();
  const [addProductColor] = useAddProductColorMutation();
  const [updateProductColor] = useUpdateProductColorMutation();
  const [deleteProductColor] = useDeleteProductColorMutation();
  const [setPopularProduct] = useSetPopularProductMutation();
  const [removePopularProduct] = useRemovePopularProductMutation();
  const [addProductSize] = useAddProductSizeMutation();
  const [updateProductSize] = useUpdateProductSizeMutation();
  const [deleteProductSize] = useDeleteProductSizeMutation();
  const [addFlashSale, { isLoading: isAddingFlashSale }] = useAddFlashSaleMutation();
  const [addDeal, { isLoading: isAddingDeal }] = useAddDealMutation();

  // Shipping and Delivery Model API hooks
  const { data: shippingResponse, refetch: refetchShippingModels } = useListShippingChargesQuery();
  const { data: deliveryResponse, refetch: refetchDeliveryModels } = useListDeliveryModelsQuery();

  // Handle API response structure
  const products = productsResponse?.result || productsResponse?.data || [];
  const bundles = bundlesResponse?.result || bundlesResponse?.data || bundlesResponse || [];
  const categories = categoriesResponse?.result || categoriesResponse?.data || [];
  const subCategories = subCategoriesResponse?.result || subCategoriesResponse?.data || [];
  const productDetail = productDetailResponse?.result || {};
  const popularProducts = popularProductsResponse?.result || popularProductsResponse?.data || [];

  // Get units from API
  const units = unitsResponse?.result || unitsResponse?.data || [];

  // Handle count response properly
  const totalRecords = countResponse?.count || countResponse?.result?.count || productsResponse?.count || 0;
  const bundleTotalRecords = bundleCountResponse?.count || bundleCountResponse?.result?.count || bundlesResponse?.count || 0;
  const popularTotalRecords = popularCountResponse?.count || popularCountResponse?.result?.count || popularProductsResponse?.count || 0;

  const totalPages = Math.ceil(totalRecords / productsPerPage) || 1;
  const bundleTotalPages = Math.ceil(bundleTotalRecords / productsPerPage) || 1;
  const popularTotalPages = Math.ceil(popularTotalRecords / productsPerPage) || 1;

  const [additionalImages, setAdditionalImages] = useState<any[]>([]);
  const [updateProductDeliveryModels] = useUpdateProductDeliveryModelsMutation();
  const [fetchProductDeliveryModels] = useLazyGetProductDeliveryModelsQuery();
  const isEditing = Boolean(editingProduct);
  const isEditingBundle = Boolean(editingBundle);
  const isEditingWarranty = Boolean(editingWarranty);

  // Shopify-style color scheme
  const shopifyColors = {
    primary: '#008060',
    primaryHover: '#006e52',
    surface: '#f6f6f7',
    border: '#e1e3e5',
    textPrimary: '#202223',
    textSecondary: '#6d7175',
    success: '#008060',
    warning: '#ffc453',
    error: '#d72c0d',
    blue: '#2c6ecb',
    purple: '#5c6ac4',
    pink: '#c2185b',
    openBox: '#9c27b0', // Open box color
  };

  // Add scroll handler effect
  useEffect(() => {
    const scrollContainer = document.getElementById('product-list-scroll-container');

    const handleScroll = () => {
      if (scrollContainer) {
        const { scrollTop, scrollHeight, clientHeight } = scrollContainer;
        setShowScrollTop(scrollTop > 300);
        setShowScrollBottom(scrollTop + clientHeight < scrollHeight - 300);
      }
    };

    scrollContainer?.addEventListener('scroll', handleScroll);
    return () => scrollContainer?.removeEventListener('scroll', handleScroll);
  }, []);

  // Add keyboard navigation for scroll
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      const scrollContainer = document.getElementById('product-list-scroll-container');
      if (!scrollContainer) return;

      switch (e.key) {
        case 'Home':
          e.preventDefault();
          scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
          break;
        case 'End':
          e.preventDefault();
          scrollContainer.scrollTo({
            top: scrollContainer.scrollHeight,
            behavior: 'smooth'
          });
          break;
        case 'PageUp':
          e.preventDefault();
          scrollContainer.scrollBy({ top: -window.innerHeight, behavior: 'smooth' });
          break;
        case 'PageDown':
          e.preventDefault();
          scrollContainer.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
          break;
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Add scroll functions
  const scrollToTop = () => {
    const scrollContainer = document.getElementById('product-list-scroll-container');
    scrollContainer?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const scrollToBottom = () => {
    const scrollContainer = document.getElementById('product-list-scroll-container');
    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: scrollContainer.scrollHeight,
        behavior: 'smooth'
      });
    }
  };

  // ── Top-scrollbar sync callbacks ──
  const syncScrollState = React.useCallback(() => {
    const table = tableScrollRef.current;
    const inner = topScrollInnerRef.current;
    if (!table) return;
    setCanScrollLeft(table.scrollLeft > 0);
    setCanScrollRight(table.scrollLeft + table.clientWidth < table.scrollWidth - 1);
    if (inner) inner.style.width = `${table.scrollWidth}px`;
  }, []);

  const setTableScrollRef = React.useCallback((node: HTMLDivElement | null) => {
    if (tableScrollRef.current) {
      tableScrollRef.current.removeEventListener('scroll', syncScrollState);
    }
    tableScrollRef.current = node;
    if (!node) return;
    const onTableScroll = () => {
      syncScrollState();
      if (isSyncingScroll.current) return;
      isSyncingScroll.current = true;
      if (topScrollRef.current) topScrollRef.current.scrollLeft = node.scrollLeft;
      isSyncingScroll.current = false;
    };
    node.addEventListener('scroll', onTableScroll);
    window.addEventListener('resize', syncScrollState);
    setTimeout(syncScrollState, 0);
  }, [syncScrollState]);

  const setTopScrollRef = React.useCallback((node: HTMLDivElement | null) => {
    if (topScrollRef.current) {
      topScrollRef.current.removeEventListener('scroll', () => { });
    }
    topScrollRef.current = node;
    if (!node) return;
    const onTopScroll = () => {
      if (isSyncingScroll.current) return;
      isSyncingScroll.current = true;
      if (tableScrollRef.current) {
        tableScrollRef.current.scrollLeft = node.scrollLeft;
        syncScrollState();
      }
      isSyncingScroll.current = false;
    };
    node.addEventListener('scroll', onTopScroll);
  }, [syncScrollState]);

  const setTopScrollInnerRef = React.useCallback((node: HTMLDivElement | null) => {
    topScrollInnerRef.current = node;
  }, []);

  useEffect(() => {
    setTimeout(syncScrollState, 50);
  }, [page, searchStr, productType, categoryFilter, subCategoryFilter,
    statusFilter, availabilityFilter, syncScrollState]);

  const handleScrollLeft = () => tableScrollRef.current?.scrollBy({ left: -300, behavior: 'smooth' });
  const handleScrollRight = () => tableScrollRef.current?.scrollBy({ left: 300, behavior: 'smooth' });

  // Fetch delivery models and find default
  useEffect(() => {
    if (deliveryResponse?.result) {
      setDeliveryModels(deliveryResponse.result);

      // Find default delivery model
      const defaultModel = deliveryResponse.result.find((model: DeliveryModel) => model.is_default === 1);
      setDefaultDeliveryModel(defaultModel || null);
      setDefaultDeliveryModelId(defaultModel?.id || null);

      // Set available delivery models (all active models)
      const activeModels = deliveryResponse.result.filter((model: DeliveryModel) => model.status === 1);
      setAvailableDeliveryModels(activeModels);
    }
  }, [deliveryResponse]);

  // Auto-refresh count when search or filters change
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      refetchCount();
      refetchBundleCount();
      if (popularProductsView) {
        refetchPopularCount();
      }
    }, 300);

    return () => clearTimeout(delayDebounceFn);
  }, [searchStr, categoryFilter, subCategoryFilter, statusFilter, availabilityFilter, stockFilter, discountFilter, approvalFilter, sortBy, refetchCount, refetchBundleCount, refetchPopularCount, popularProductsView]);

  // Load product-specific return limit when dialog opens
  useEffect(() => {
    if (selectedProductForReturnLimit) {
      refetchProductReturnLimit();
    }
  }, [selectedProductForReturnLimit, refetchProductReturnLimit]);

  // Load product-specific tax when dialog opens
  useEffect(() => {
    if (selectedProductForTax) {
      refetchProductTax();
    }
  }, [selectedProductForTax, refetchProductTax]);

  // Load product warranties when dialog opens
  useEffect(() => {
    if (selectedProductForWarranty) {
      refetchWarranties();
    }
  }, [selectedProductForWarranty, refetchWarranties]);

  // Update warranties state when data changes
  useEffect(() => {
    if (warrantiesData?.data) {
      setWarranties(warrantiesData.data);
    } else {
      setWarranties([]);
    }
  }, [warrantiesData]);

  // Update product return limit from API response
  useEffect(() => {
    if (productReturnData?.return_limit) {
      setProductReturnLimit(productReturnData.return_limit);
    } else if (selectedProductForReturnLimit) {
      setProductReturnLimit('0'); // Default value if no return limit is set
    }
  }, [productReturnData, selectedProductForReturnLimit]);

// ✅ Add this useEffect to monitor product detail changes
useEffect(() => {
  if (editingProduct) {
    const codValue = editingProduct.cod_available !== undefined && editingProduct.cod_available !== null 
      ? editingProduct.cod_available 
      : 1;
    
    console.log('📦 Product loaded with COD value:', codValue);
    
    // Only update if the value has changed to avoid loops
    setCodEnabled(prev => {
      if (prev !== codValue) {
        return codValue as 0 | 1;
      }
      return prev;
    });
    
    setFormData(prev => ({
      ...prev,
      cod_available: codValue
    }));
  }
}, [editingProduct]);
  // Update product tax from API response
  useEffect(() => {
    if (productTaxData && selectedProductForTax) {
      console.log('Product Tax Data:', productTaxData);

      if (productTaxData.tax_name !== undefined && productTaxData.tax_name !== null) {
        setProductTaxName(String(productTaxData.tax_name));
      } else {
        setProductTaxName('VAT'); // Default value
      }

      if (productTaxData.tax_per !== undefined && productTaxData.tax_per !== null) {
        setProductTaxPercentage(String(productTaxData.tax_per));
      } else {
        setProductTaxPercentage('5');
      }

      if (productTaxData.currency !== undefined && productTaxData.currency !== null) {
        setProductTaxCurrency(String(productTaxData.currency));
      } else {
        setProductTaxCurrency('AED');
      }
    }
  }, [productTaxData, selectedProductForTax]);

  // Refetch subcategories when category changes
  useEffect(() => {
    const catId = productType === 'bundle' ? bundleFormData.cat_id : formData.cat_id;
    if (catId && catId > 0) {
      refetchSubCategories();
    }
  }, [productType, bundleFormData.cat_id, formData.cat_id, refetchSubCategories]);

  // Fetch warehouses when needed
  useEffect(() => {
    if (formOpen || warehouseStockDialogOpen) {
      refetchWarehouses();
    }
  }, [formOpen, warehouseStockDialogOpen, refetchWarehouses]);

  // Fetch product warehouses when product is selected
  useEffect(() => {
    if (selectedProductForWarehouse) {
      refetchProductWarehouses();
    }
  }, [selectedProductForWarehouse, refetchProductWarehouses]);

  // Update product warehouses state
  useEffect(() => {
    if (productWarehousesResponse?.result) {
      setProductWarehouses(productWarehousesResponse.result);
    }
  }, [productWarehousesResponse]);

  // Update warehouses state
  useEffect(() => {
    if (warehousesResponse) {
      if (Array.isArray(warehousesResponse.warehouses)) {
        setWarehouses(warehousesResponse.warehouses);
      } else if (Array.isArray(warehousesResponse.result)) {
        setWarehouses(warehousesResponse.result);
      } else if (Array.isArray(warehousesResponse)) {
        setWarehouses(warehousesResponse);
      }
    }
  }, [warehousesResponse]);

  // Auto-assign the vendor's own pickup location (warehouse/shop/home) to
  // a new product, so vendors don't have to manually pick a warehouse.
  // Since `warehouses` is already scoped to the logged-in vendor, this
  // picks their default one (or their only one) automatically. Vendors
  // with more than one pickup location can still change it — this is a
  // convenience default, not a lock.
  useEffect(() => {
    if (
      isVendor &&
      formOpen &&
      productType === 'single' &&
      !editingProduct &&
      !formData.warehouse_id &&
      warehouses.length > 0
    ) {
      const ownDefault =
        warehouses.find((w) => w.is_default === 1) || warehouses[0];
      if (ownDefault) {
        setFormData((prev) => ({ ...prev, warehouse_id: ownDefault.id }));
      }
    }
  }, [isVendor, formOpen, productType, editingProduct, warehouses]);

  // Filtered categories for display - SORTED
  const filteredCategoriesForDisplay = useMemo(() => {
    return [...categories].sort((a, b) =>
      a.cat_name.localeCompare(b.cat_name)
    );
  }, [categories]);

  // Filtered subcategories - SORTED
  const filteredSubCategoriesForDisplay = useMemo(() => {
    return [...subCategories].sort((a, b) =>
      a.sub_cat_name.localeCompare(b.sub_cat_name)
    );
  }, [subCategories]);

  const [subCategoryPage, setSubCategoryPage] = useState(1);
  const subCategoriesPerPage = 30;

  // Filtered subcategories logic
  const filteredSubCategories = useMemo(() => {
    const selectedCatId = productType === 'bundle' ? bundleFormData.cat_id : formData.cat_id;
    if (!selectedCatId || selectedCatId === 0) {
      return [];
    }
    return subCategories.filter((subCat: any) =>
      (subCat.cat_id || subCat.category_id) === selectedCatId
    );
  }, [subCategories, productType, bundleFormData.cat_id, formData.cat_id]);

  const getCategoryName = (catId: number) => {
    const category = categories.find(
      (cat: any) => (cat.cat_id || cat.id) === catId
    );
    return category?.cat_name || 'N/A';
  };

  const totalSubCategoryPages = Math.ceil(filteredSubCategories.length / subCategoriesPerPage) || 1;
  const startIndex = (subCategoryPage - 1) * subCategoriesPerPage;
  const endIndex = startIndex + subCategoriesPerPage;
  const paginatedSubCategories = filteredSubCategories.slice(startIndex, endIndex);

  // Add handler to reset subcategory page when category changes
  const handleCategoryChange = (e: SelectChangeEvent) => {
    const { name, value } = e.target;

    // Reset subcategory selection and page when category changes
    if (name === 'cat_id') {
      setSubCategoryPage(1);
      if (productType === 'bundle') {
        setBundleFormData(prev => ({
          ...prev,
          cat_id: Number(value),
          sub_cat_id: undefined
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          cat_id: Number(value),
          sub_cat_id: undefined
        }));
      }
    } else {
      if (productType === 'bundle') {
        setBundleFormData(prev => ({
          ...prev,
          [name]: name === 'cat_id' || name === 'sub_cat_id' || name === 'status' ||
            name === 'availability' || name === 'discount_type' ||
            name === 'shipping_model' || name === 'delivery_model' ||
            name === 'price_priority' ? Number(value) : value
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          [name]: name === 'cat_id' || name === 'sub_cat_id' || name === 'status' ||
            name === 'availability' || name === 'discount_type' ||
            name === 'shipping_model' || name === 'delivery_model' ||
            name === 'price_priority' ? Number(value) : value
        }));
      }
    }
  };

  // Handlers for pagination
  const handleSubCategoryPrevPage = () => {
    setSubCategoryPage(prev => Math.max(1, prev - 1));
  };

  const handleSubCategoryNextPage = () => {
    setSubCategoryPage(prev => Math.min(totalSubCategoryPages, prev + 1));
  };

  // Load available products for bundle creation
  useEffect(() => {
    if (productType === 'bundle' && formOpen) {
      const vendorProducts = isVendor
        ? products.filter((product: Product) => Number(product.vendor_id) === Number(normalizedVendorId))
        : products;
      setAvailableProducts(vendorProducts);
    }
  }, [productType, formOpen, products, isVendor, vendorId]);

  // Update shipping and delivery models state when data changes
  useEffect(() => {
    if (shippingResponse?.result) {
      setShippingModels(shippingResponse.result);
    }
  }, [shippingResponse]);

  // Update product sizes and colors when data changes
  useEffect(() => {
    if (productSizesResponse?.data) {
      setProductSizes(productSizesResponse.data);
    }
  }, [productSizesResponse]);

  useEffect(() => {
    if (productColorsResponse?.data) {
      setProductColors(productColorsResponse.data);
    }
  }, [productColorsResponse]);

  // Update this useEffect to properly reset and load images
  useEffect(() => {
    if (!selectedProductId) return;

    const storefrontImages = productDetailResponse?.images || [];
    // productDetailResponse comes from '/product/find', which only returns
    // data for approved products — for a still-pending/rejected/blocked
    // vendor product it comes back with no images even though the vendor
    // did upload some. Fall back to the admin-scoped endpoint in that case
    // so the images/video still show up here for editing.
    const sourceImages = storefrontImages.length > 0
      ? storefrontImages
      : (adminProductMediaResponse?.images || []);

    setAdditionalImages(
      sourceImages.map((img: any) => ({
        id: img.id,
        filename: img.product_image || img.image,
      }))
    );
  }, [productDetailResponse, adminProductMediaResponse, selectedProductId]);

  // Function to get delivery methods display for a product
  const getDeliveryMethodsDisplay = (product: Product | Bundle) => {
    const deliveryModelIds = product.delivery_model;

    if (!deliveryModelIds || (Array.isArray(deliveryModelIds) && deliveryModelIds.length === 0)) {
      return 'Using Default';
    }

    // Get delivery model names
    const selectedModels = availableDeliveryModels.filter(model =>
      Array.isArray(deliveryModelIds)
        ? deliveryModelIds.includes(model.id)
        : deliveryModelIds === model.id
    );

    if (selectedModels.length === 0) {
      return 'Using Default';
    }

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
        {selectedModels.map((model, index) => (
          <Chip
            key={model.id}
            label={model.model_name}
            size="small"
            sx={{
              bgcolor: '#e6f6fc',
              color: '#006fbb',
              fontWeight: 500,
              fontSize: '11px',
              borderRadius: '4px',
              maxWidth: '100px',
              height: '20px'
            }}
          />
        ))}
        {selectedModels.length > 1 && (
          <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontSize: '10px' }}>
            +{selectedModels.length - 1} more
          </Typography>
        )}
      </Box>
    );
  };

  // Render product tax information
  const renderTaxInfo = (product: Product) => {
    const taxName = product.tax1_name || globalTaxName;
    const taxPercentage = (product.tax1_per !== undefined && product.tax1_per !== null) ? product.tax1_per : globalTaxPer;

    return (
      <Chip
        label={`${taxName} (${taxPercentage}%)`}
        size="small"
        sx={{
          bgcolor: '#e6f6fc',
          color: '#006fbb',
          fontWeight: 600,
          fontSize: isMobile ? '10px' : '12px',
          borderRadius: '6px',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: '#d4edfa',
          }
        }}
        onClick={() => handleOpenProductTaxDialog(product)}
      />
    );
  };

  // Render warranty information
  const renderWarrantyInfo = (product: Product) => {
    const warrantyCount = product.warranty_count || 0;

    return (
      <Chip
        label={`${warrantyCount} warranty${warrantyCount !== 1 ? 's' : ''}`}
        size="small"
        icon={<Shield />}
        sx={{
          bgcolor: warrantyCount > 0 ? '#f0f4ff' : '#e4e5e7',
          color: warrantyCount > 0 ? shopifyColors.blue : '#616161',
          fontWeight: 600,
          fontSize: isMobile ? '10px' : '12px',
          borderRadius: '6px',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: warrantyCount > 0 ? '#e1e8ff' : '#d8d9db',
          }
        }}
        onClick={() => handleOpenWarrantyDialog(product)}
      />
    );
  };

  const renderBulkOrderStatus = (product: Product) => {
    const isBulkOrder = product.bulkorder === 1;

    return (
      <Chip
        label={isBulkOrder ? 'Bulk Order' : 'Normal'}
        size="small"
        onClick={() => handleOpenBulkOrderDialog(product)}
        sx={{
          bgcolor: isBulkOrder ? '#e3f2fd' : '#f5f5f5',
          color: isBulkOrder ? '#1976d2' : '#616161',
          fontWeight: 600,
          fontSize: isMobile ? '10px' : '12px',
          borderRadius: '6px',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: isBulkOrder ? '#bbdefb' : '#eeeeee',
          }
        }}
      />
    );
  };

  const handleOpenBulkOrderDialog = (product: Product) => {
    setSelectedProductForBulkOrder(product);
    setBulkOrderStatus(product.bulkorder || 0);
    setBulkOrderDialogOpen(true);
  };

  // Close Bulk Order Dialog
  const handleCloseBulkOrderDialog = () => {
    setBulkOrderDialogOpen(false);
    setSelectedProductForBulkOrder(null);
    setBulkOrderStatus(0);
  };

  // Save Bulk Order Settings
  const handleSaveBulkOrderSettings = async () => {
    if (!selectedProductForBulkOrder) return;

    try {
      const productId = selectedProductForBulkOrder.id || selectedProductForBulkOrder.product_id || 0;

      const bulkOrderData: BulkOrderSettings = {
        product_id: productId,
        bulkorder: bulkOrderStatus,
      };

      const result = await setBulkOrder(bulkOrderData).unwrap();

      setSnackbar({
        open: true,
        message: result?.message || 'Bulk order settings updated successfully!',
        severity: 'success'
      });

      handleCloseBulkOrderDialog();
      refetch(); // Refresh the product list
    } catch (err: any) {
      console.error('Failed to update bulk order settings:', err);
      setSnackbar({
        open: true,
        message: err?.data?.message || err?.message || 'Error updating bulk order settings. Please try again.',
        severity: 'error'
      });
    }
  };


  // Render reward status
  const renderRewardStatus = (product: Product) => {
    const isReward = product.is_reward === 1;
    const rewardPoints = product.reward_points || 0;

    return (
      <Chip
        label={isReward ? `${rewardPoints} pts` : 'Not Eligible'}
        size="small"
        icon={isReward ? <CardGiftcard /> : undefined}
        onClick={() => handleOpenRewardDialog(product)}
        sx={{
          bgcolor: isReward ? '#fff0f7' : '#e4e5e7',
          color: isReward ? shopifyColors.pink : '#616161',
          fontWeight: 600,
          fontSize: isMobile ? '10px' : '12px',
          borderRadius: '6px',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: isReward ? '#ffe3f2' : '#d8d9db',
          }
        }}
      />
    );
  };

  // Render Open Box status
  const renderOpenBoxStatus = (product: Product) => {
    const isOpenBox = product.open_box_delivery === 1;
    const openBoxCharge = product.open_box_charge || 0;

    return (
      <Chip
        label={isOpenBox ? `AED ${openBoxCharge}` : 'Disabled'}
        size="small"
        onClick={() => handleOpenOpenBoxDialog(product)}
        sx={{
          bgcolor: isOpenBox ? '#f3e5f5' : '#e4e5e7',
          color: isOpenBox ? shopifyColors.openBox : '#616161',
          fontWeight: 600,
          fontSize: isMobile ? '10px' : '12px',
          borderRadius: '6px',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: isOpenBox ? '#e1bee7' : '#d8d9db',
          }
        }}
      />
    );
  };

  // Open Product Tax Dialog
  const handleOpenProductTaxDialog = (product: Product) => {
    setSelectedProductForTax(product);
    setProductTaxDialogOpen(true);
  };

  // Close Product Tax Dialog
  const handleCloseProductTaxDialog = () => {
    setProductTaxDialogOpen(false);
    setSelectedProductForTax(null);
    setProductTaxName('VAT');
    setProductTaxPercentage('5');
    setProductTaxCurrency('AED');
  };

  // Save Product-specific Tax
  const handleSaveProductTax = async () => {
    if (!selectedProductForTax) return;

    const productId = selectedProductForTax.id || selectedProductForTax.product_id;
    if (!productId) {
      setProductTaxSnackbar({
        open: true,
        message: 'Product ID is missing',
        severity: 'error'
      });
      return;
    }

    if (!productTaxPercentage || parseFloat(productTaxPercentage) < 0) {
      setProductTaxSnackbar({
        open: true,
        message: 'Please enter a valid tax percentage',
        severity: 'error'
      });
      return;
    }

    try {
      const result = await setProductTaxMutation({
        product_id: productId,
        tax_name: productTaxName,
        tax_per: productTaxPercentage,
        currency: productTaxCurrency
      }).unwrap();

      if (result.access) {
        setProductTaxSnackbar({
          open: true,
          message: result.message || `Tax settings updated for ${selectedProductForTax.prod_name}!`,
          severity: 'success'
        });

        setTimeout(() => {
          handleCloseProductTaxDialog();
          refetch();
        }, 1500);

      } else {
        throw new Error(result.message || 'Failed to update tax settings');
      }
    } catch (err: any) {
      let errorMessage = 'Error updating tax settings.';

      if (err?.data?.message) {
        errorMessage = err.data.message;
      } else if (err?.message) {
        errorMessage = err.message;
      }

      setProductTaxSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  // Close Product Tax Snackbar
  const handleCloseProductTaxSnackbar = () => {
    setProductTaxSnackbar({ ...productTaxSnackbar, open: false });
  };

  // Open Warranty Dialog
  const handleOpenWarrantyDialog = (product: Product) => {
    setSelectedProductForWarranty(product);
    setWarrantyFormErrors({});
    setSelectedWarrantyIds([]);       // reset checkbox selection on open
    setWarrantyDialogOpen(true);
  };

  // Close Warranty Dialog
  const handleCloseWarrantyDialog = () => {
    setWarrantyDialogOpen(false);
    setSelectedProductForWarranty(null);
    setEditingWarranty(null);
    setWarrantyFormData({
      product_id: 0,
      warranty_name: '',
      warranty_period: 'month',
      no_of_period: 6,
      description: '',
      features: '',
      price: 0,
      additional_cost: 0,
    });
    setWarrantyFormErrors({});
  };

  // Open Reward Dialog
  const handleOpenRewardDialog = (product: Product) => {
    setSelectedProductForReward(product);
    setRewardFormData({
      is_reward: product.is_reward || 0,
      reward_points: product.reward_points || 0,
    });
    setRewardFormErrors({});
    setRewardDialogOpen(true);
  };

  const handleSaveWarrantySelection = async () => {
    if (!selectedProductForWarranty || selectedWarrantyIds.length === 0) return;

    const productId =
      selectedProductForWarranty.id || selectedProductForWarranty.product_id || 0;

    let successCount = 0;
    let lastError = '';

    for (const wid of selectedWarrantyIds) {
      const source = allWarranties.find((w: Warranty) => w.id === wid);
      if (!source) continue;

      try {
        await addWarranty({
          product_id: productId,
          warranty_name: source.warranty_name,
          warranty_period: source.warranty_period,
          no_of_period: source.no_of_period,
          description: source.description,
          features: source.features,
          price: source.price || 0,
          additional_cost: source.additional_cost || 0,
        }).unwrap();
        successCount++;
      } catch (err: any) {
        lastError =
          err?.data?.message || err?.message || 'Error linking warranty.';
      }
    }

    if (successCount > 0) {
      setSnackbar({
        open: true,
        message: `${successCount} warrant${successCount === 1 ? 'y' : 'ies'} linked successfully!`,
        severity: 'success',
      });
      setSelectedWarrantyIds([]);
      refetchWarranties();
      refetch();
    }

    if (lastError) {
      setSnackbar({
        open: true,
        message: lastError,
        severity: 'error',
      });
    }
  };

  // Close Reward Dialog
  const handleCloseRewardDialog = () => {
    setRewardDialogOpen(false);
    setSelectedProductForReward(null);
    setRewardFormData({
      is_reward: 0,
      reward_points: 0,
    });
    setRewardFormErrors({});
  };

  // Open Open Box Dialog
  const handleOpenOpenBoxDialog = (product: Product) => {
    setSelectedProductForOpenBox(product);
    setOpenBoxFormData({
      open_box_delivery: product.open_box_delivery || 0,
      open_box_charge: product.open_box_charge || 0,
    });
    setOpenBoxFormErrors({});
    setOpenBoxDialogOpen(true);
  };

  // Close Open Box Dialog
  const handleCloseOpenBoxDialog = () => {
    setOpenBoxDialogOpen(false);
    setSelectedProductForOpenBox(null);
    setOpenBoxFormData({
      open_box_delivery: 0,
      open_box_charge: 0,
    });
    setOpenBoxFormErrors({});
  };

  // Reward Form Handlers
  const handleRewardInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setRewardFormData(prev => ({
      ...prev,
      [name]: name === 'reward_points' ? Number(value) : Number(value)
    }));
    if (rewardFormErrors[name as keyof typeof rewardFormErrors]) {
      setRewardFormErrors(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  const handleRewardToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isReward = e.target.checked ? 1 : 0;
    setRewardFormData(prev => ({
      ...prev,
      is_reward: isReward as 0 | 1
    }));
  };

  const validateRewardForm = (): boolean => {
    const errors: typeof rewardFormErrors = {};

    if (rewardFormData.is_reward === 1 && (!rewardFormData.reward_points || rewardFormData.reward_points <= 0)) {
      errors.reward_points = 'Reward points must be greater than 0';
    }

    setRewardFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveRewardSettings = async () => {
    if (!validateRewardForm() || !selectedProductForReward) {
      return;
    }

    try {
      const productId = selectedProductForReward.id || selectedProductForReward.product_id || 0;

      if (rewardFormData.is_reward === 1) {
        // Set as reward product
        const result = await setProductReward({
          product_id: productId,
          is_reward: 1,
          reward_points: rewardFormData.reward_points
        }).unwrap();

        setSnackbar({
          open: true,
          message: result?.message || `Product enabled as reward with ${rewardFormData.reward_points} points!`,
          severity: 'success'
        });
      } else {
        // Remove from reward products
        const result = await removeProductReward({
          product_id: productId
        }).unwrap();

        setSnackbar({
          open: true,
          message: result?.message || 'Product removed from reward products!',
          severity: 'success'
        });
      }

      handleCloseRewardDialog();
      refetch();
    } catch (err: any) {
      console.error('Failed to update reward settings:', err);
      setSnackbar({
        open: true,
        message: err?.data?.message || err?.message || 'Error updating reward settings. Please try again.',
        severity: 'error'
      });
    }
  };

  // Open Box Form Handlers
  const handleOpenBoxInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setOpenBoxFormData(prev => ({
      ...prev,
      [name]: name === 'open_box_delivery' ? (Number(value) as 0 | 1) : Number(value)
    }));
    if (openBoxFormErrors[name as keyof typeof openBoxFormErrors]) {
      setOpenBoxFormErrors(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  const handleOpenBoxToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isEnabled = e.target.checked ? 1 : 0;
    setOpenBoxFormData(prev => ({
      ...prev,
      open_box_delivery: isEnabled as 0 | 1,
      // Reset charge to 0 when disabling
      open_box_charge: isEnabled ? prev.open_box_charge : 0
    }));
  };

  const validateOpenBoxForm = (): boolean => {
    const errors: typeof openBoxFormErrors = {};

    if (openBoxFormData.open_box_delivery === 1 && (!openBoxFormData.open_box_charge || openBoxFormData.open_box_charge < 0)) {
      errors.open_box_charge = 'Open box charge must be greater than or equal to 0';
    }

    setOpenBoxFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSaveOpenBoxSettings = async () => {
    if (!validateOpenBoxForm() || !selectedProductForOpenBox) {
      return;
    }

    try {
      const productId = selectedProductForOpenBox.id || selectedProductForOpenBox.product_id || 0;

      const openBoxData: OpenBoxSettings = {
        product_id: productId,
        open_box_delivery: openBoxFormData.open_box_delivery,
        open_box_charge: openBoxFormData.open_box_delivery === 1 ? openBoxFormData.open_box_charge : 0,
      };

      const result = await setOpenBox(openBoxData).unwrap();

      setSnackbar({
        open: true,
        message: result?.message || 'Open box delivery settings updated successfully!',
        severity: 'success'
      });

      handleCloseOpenBoxDialog();
      refetch(); // Refresh the product list
    } catch (err: any) {
      console.error('Failed to update open box settings:', err);
      setSnackbar({
        open: true,
        message: err?.data?.message || err?.message || 'Error updating open box settings. Please try again.',
        severity: 'error'
      });
    }
  };

  // Warranty Form Handlers
  const handleWarrantyInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setWarrantyFormData(prev => ({ ...prev, [name]: value }));

    if (warrantyFormErrors[name]) {
      setWarrantyFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleWarrantySelectChange = (e: SelectChangeEvent) => {
    const { name, value } = e.target;
    setWarrantyFormData(prev => ({ ...prev, [name]: value }));

    if (warrantyFormErrors[name]) {
      setWarrantyFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleWarrantyNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setWarrantyFormData(prev => ({ ...prev, [name]: Number(value) }));

    if (warrantyFormErrors[name]) {
      setWarrantyFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleEditWarranty = (warranty: Warranty) => {
    setEditingWarranty(warranty);
    setWarrantyFormData({
      product_id: warranty.product_id || 0,
      warranty_name: warranty.warranty_name || '',
      warranty_period: warranty.warranty_period || 'month',
      no_of_period: warranty.no_of_period || 6,
      description: warranty.description || '',
      features: warranty.features || '',
      price: warranty.price || 0,
      additional_cost: warranty.additional_cost || 0,
      id: warranty.id,
    });
  };

  const validateWarrantyForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!warrantyFormData.warranty_name.trim()) {
      newErrors.warranty_name = 'Warranty name is required';
    }

    if (!warrantyFormData.warranty_period) {
      newErrors.warranty_period = 'Warranty period is required';
    }

    if (!warrantyFormData.no_of_period || warrantyFormData.no_of_period < 1) {
      newErrors.no_of_period = 'Number of periods must be at least 1';
    }

    if (!warrantyFormData.description.trim()) {
      newErrors.description = 'Description is required';
    }

    if (!warrantyFormData.features.trim()) {
      newErrors.features = 'Features are required';
    }

    setWarrantyFormErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSaveWarranty = async () => {
    if (!validateWarrantyForm() || !selectedProductForWarranty) return;

    try {
      let result;
      if (isEditingWarranty && editingWarranty) {
        const updateData = {
          id: warrantyFormData.id || editingWarranty.id,
          product_id: warrantyFormData.product_id,
          warranty_name: warrantyFormData.warranty_name.trim(),
          warranty_period: warrantyFormData.warranty_period,
          no_of_period: warrantyFormData.no_of_period,
          description: warrantyFormData.description.trim(),
          features: warrantyFormData.features.trim(),
          price: warrantyFormData.price || 0,
          additional_cost: warrantyFormData.additional_cost || 0,
        };

        result = await updateWarranty(updateData).unwrap();
      } else {
        const addData = {
          product_id: warrantyFormData.product_id,
          warranty_name: warrantyFormData.warranty_name.trim(),
          warranty_period: warrantyFormData.warranty_period,
          no_of_period: warrantyFormData.no_of_period,
          description: warrantyFormData.description.trim(),
          features: warrantyFormData.features.trim(),
          price: warrantyFormData.price || 0,
          additional_cost: warrantyFormData.additional_cost || 0,
        };

        result = await addWarranty(addData).unwrap();
      }

      setSnackbar({
        open: true,
        message: result?.message || `Warranty ${isEditingWarranty ? 'updated' : 'added'} successfully!`,
        severity: 'success'
      });

      refetchWarranties();

      // Reset form for next entry (unless editing)
      if (!isEditingWarranty) {
        setWarrantyFormData({
          product_id: selectedProductForWarranty.id || selectedProductForWarranty.product_id || 0,
          warranty_name: '',
          warranty_period: 'month',
          no_of_period: 6,
          description: '',
          features: '',
          price: 0,
          additional_cost: 0,
        });
        setEditingWarranty(null);
      }
    } catch (err: any) {
      console.error('Failed to save warranty:', err);

      let errorMessage = `Error ${isEditingWarranty ? 'updating' : 'adding'} warranty. Please try again.`;

      if (err?.data?.message) {
        errorMessage = err.data.message;
      } else if (err?.data?.error) {
        errorMessage = typeof err.data.error === 'string' ? err.data.error : 'Validation failed';
      } else if (err?.message) {
        errorMessage = err.message;
      }

      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  const handleDeleteWarranty = async (id: number) => {
    if (window.confirm('Are you sure you want to delete this warranty?')) {
      try {
        const result = await deleteWarranty({ id }).unwrap();
        setSnackbar({
          open: true,
          message: result?.message || 'Warranty deleted successfully!',
          severity: 'success'
        });
        refetchWarranties();
      } catch (err: any) {
        console.error('Failed to delete warranty:', err);

        let errorMessage = 'Error deleting warranty. Please try again.';

        if (err?.data?.message) {
          errorMessage = err.data.message;
        } else if (err?.data?.error) {
          errorMessage = typeof err.data.error === 'string' ? err.data.error : 'Delete operation failed';
        } else if (err?.message) {

          errorMessage = err.message;
        }

        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
      }
    }
  };

  // Format warranty period
  const formatWarrantyPeriod = (period: string, count: number) => {
    return `${count} ${period}${count > 1 ? 's' : ''}`;
  };

  // Format currency
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
    }).format(amount);
  };

  // Open Delivery Method Dialog
  const handleOpenDeliveryMethodDialog = (item: Product | Bundle) => {
    setSelectedProductForDelivery(item);

    // Parse current delivery models
    const currentDeliveryModels = item.delivery_model;
    let initialSelected: number[] = [];

    if (Array.isArray(currentDeliveryModels)) {
      initialSelected = currentDeliveryModels;
    } else if (currentDeliveryModels) {
      initialSelected = [Number(currentDeliveryModels)];
    }

    setSelectedDeliveryModels(initialSelected);
    setDeliveryMethodDialogOpen(true);
  };

  // Close Delivery Method Dialog
  const handleCloseDeliveryMethodDialog = () => {
    setDeliveryMethodDialogOpen(false);
    setSelectedProductForDelivery(null);
    setSelectedDeliveryModels([]);
  };

  // Save Delivery Methods for Product
  const handleSaveDeliveryMethods = async () => {
    if (!selectedProductForDelivery) return;

    try {
      const productId = selectedProductForDelivery.id ||
        selectedProductForDelivery.product_id ||
        selectedProductForDelivery.bundle_id;

      if (!productId) {
        setSnackbar({
          open: true,
          message: 'Product ID is missing',
          severity: 'error'
        });
        return;
      }

      // Prepare update data
      const updateData: any = {
        delivery_model: selectedDeliveryModels.length > 0 ? selectedDeliveryModels : null
      };

      // Determine if it's a product or bundle
      if ('product_id' in selectedProductForDelivery || 'prod_name' in selectedProductForDelivery) {
        // It's a product
        updateData.product_id = productId;

        await updateProduct(updateData).unwrap();
      } else {
        // It's a bundle
        updateData.bundle_id = productId;

        await updateBundle(updateData).unwrap();
      }

      setSnackbar({
        open: true,
        message: 'Delivery methods updated successfully!',
        severity: 'success'
      });

      // Refresh data
      if (productType === 'bundle') {
        refetchBundles();
      } else {
        refetch();
      }

      handleCloseDeliveryMethodDialog();
    } catch (error: any) {
      console.error('Failed to update delivery methods:', error);
      setSnackbar({
        open: true,
        message: error?.data?.message || 'Error updating delivery methods. Please try again.',
        severity: 'error'
      });
    }
  };

  // Shopify-style status rendering
  const renderStatus = (status: number) => {
    switch (status) {
      case 1:
        return (
          <Chip
            label="Active"
            size="small"
            sx={{
              bgcolor: '#d1f4e0',
              color: '#00783e',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
        );
      case 0:
        return (
          <Chip
            label="Inactive"
            size="small"
            sx={{
              bgcolor: '#e4e5e7',
              color: '#616161',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
        );
      case 2:
        return (
          <Chip
            label="Suspended"
            size="small"
            sx={{
              bgcolor: '#ffe8d4',
              color: '#b24000',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
        );
      default:
        return <Chip label="Unknown" size="small" />;
    }
  };

  // Vendor-facing approval status. This is separate from the normal Active/Inactive product status.
  const handleResubmitProduct = async (product: any) => {
    const productId = Number(product?.id || product?.product_id);
    const token = localStorage.getItem('vendor_token');
    if (!productId || !token) return;
    if (!window.confirm('Resubmit this product for admin approval?')) return;
    try {
      const response = await fetch(`${process.env.REACT_APP_SERVER_ENDPOINT}/product/resubmit`, { method: 'POST', headers: { Authorization: `Bearer ${token}`, authkey: '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3', 'Content-Type': 'application/json' }, body: JSON.stringify({ product_id: productId }) });
      const data = await response.json();
      if (!response.ok || data.error) throw new Error(data.message || 'Unable to resubmit product');
      setSnackbar({ open: true, message: data.message || 'Product resubmitted for approval', severity: 'success' });
      refetch();
    } catch (err: any) {
      setSnackbar({ open: true, message: err?.message || 'Unable to resubmit product', severity: 'error' });
    }
  };

  const renderApprovalStatus = (approvalStatus?: string) => {
    const value = String(approvalStatus || 'pending').toLowerCase();
    const map: Record<string, { label: string; bg: string; color: string }> = {
      pending: { label: 'Pending Approval', bg: '#fff4d6', color: '#9a6700' },
      approved: { label: 'Approved', bg: '#d1f4e0', color: '#00783e' },
      rejected: { label: 'Rejected', bg: '#fdeded', color: '#d72c0d' },
      blocked: { label: 'Blocked', bg: '#eceff1', color: '#455a64' },
    };
    const item = map[value] || map.pending;
    return (
      <Chip
        label={item.label}
        size="small"
        sx={{ bgcolor: item.bg, color: item.color, fontWeight: 600, fontSize: isMobile ? '10px' : '11px', borderRadius: '6px' }}
      />
    );
  };

  const renderAvailability = (availability: number) => {
    switch (availability) {
      case 1:
        return (
          <Chip
            label="In Stock"
            size="small"
            sx={{
              bgcolor: '#d1f4e0',
              color: '#00783e',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
        );
      case 0:
        return (
          <Chip
            label="Out of Stock"
            size="small"
            sx={{
              bgcolor: '#fdeded',
              color: '#d72c0d',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
        );
      case 2:
        return (
          <Chip
            label="Pre-order"
            size="small"
            sx={{
              bgcolor: '#e6f6fc',
              color: '#006fbb',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
        );
      default:
        return <Chip label="Unknown" size="small" />;
    }
  };

  const getTotalWarehouseStock = (productId: number): number => {
    if (productType === 'bundle') return 0;

    const productWarehousesForProduct = productWarehouses.filter(
      pw => pw.product_id === productId
    );

    return productWarehousesForProduct.reduce(
      (total, pw) => total + (pw.available_quantity || 0),
      0
    );
  };

  const getTotalStockFromState = (productId: number): number => {
    const selectedProductId = selectedProductForWarehouse?.id || selectedProductForWarehouse?.product_id;
    if (selectedProductId === productId && warehouseStocks.length > 0) {
      return warehouseStocks.reduce((sum, stock) => sum + stock.available_quantity, 0);
    }
    return 0;
  };

  const renderStockStatus = (product: Product | Bundle) => {
    let totalStock = 0;
    let warehouseCount = 0;

    // The admin's explicit Availability choice (In Stock / Out of Stock /
    // Pre-order) must win over the raw quantity number — otherwise picking
    // "Out of Stock" with quantity still set to 1 kept showing "In Stock (1)"
    // here, which looked like the choice was never saved.
    const availabilityValue = (product as any).availability;

    if (availabilityValue === 0) {
      return (
        <Chip
          label="Out of Stock"
          size="small"
          icon={<Warning />}
          sx={{
            bgcolor: '#fdeded',
            color: '#d72c0d',
            fontWeight: 600,
            fontSize: isMobile ? '10px' : '12px',
            borderRadius: '6px'
          }}
        />
      );
    }

    if (availabilityValue === 2) {
      return (
        <Chip
          label="Pre-order"
          size="small"
          sx={{
            bgcolor: '#e6f6fc',
            color: '#006fbb',
            fontWeight: 600,
            fontSize: isMobile ? '10px' : '12px',
            borderRadius: '6px'
          }}
        />
      );
    }

    if (productType === 'single') {
      const prod = product as Product;
      const productId = prod.id || prod.product_id || 0;

      const selectedMappings = productWarehouses.filter(pw => pw.product_id === productId);
      warehouseCount = Number((prod as any).warehouse_count ?? selectedMappings.length ?? 0);
      const apiWarehouseStock = (prod as any).warehouse_stock;
      const warehouseStockTotal = selectedMappings.reduce((sum, pw) => sum + Number(pw.available_quantity || 0), 0);

      // Use warehouse quantity only when the product actually has warehouse mappings.
      // Otherwise product_stock is the authoritative stock value.
      totalStock = selectedMappings.length > 0
        ? warehouseStockTotal
        : warehouseCount > 0
          ? Number(apiWarehouseStock || 0)
          : Number(prod.product_stock || 0);

      const stateStock = getTotalStockFromState(productId);
      if (selectedProductForWarehouse && (selectedProductForWarehouse.id || selectedProductForWarehouse.product_id) === productId) {
        totalStock = stateStock;
      }
    } else {
      totalStock = (product as Bundle).bundle_stock || 0;
    }

    if (totalStock === 0) {
      return (
        <Box>
          <Chip
            label={isMobile ? `Out (0)` : `Out of Stock (0)`}
            size="small"
            icon={<Warning />}
            sx={{
              bgcolor: '#fdeded',
              color: '#d72c0d',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
          {productType === 'single' && warehouseCount > 0 && !isMobile && (
            <Typography variant="caption" sx={{
              color: shopifyColors.textSecondary,
              fontSize: '10px',
              display: 'block',
              mt: 0.5
            }}>
              Across {warehouseCount} warehouse{warehouseCount > 1 ? 's' : ''}
            </Typography>
          )}
        </Box>
      );
    } else {
      return (
        <Box>
          <Chip
            label={isMobile ? `In Stock (${totalStock})` : `In Stock (${totalStock})`}
            size="small"
            icon={<CheckCircle />}
            sx={{
              bgcolor: '#d1f4e0',
              color: '#00783e',
              fontWeight: 600,
              fontSize: isMobile ? '10px' : '12px',
              borderRadius: '6px'
            }}
          />
          {productType === 'single' && warehouseCount > 0 && !isMobile && (
            <Typography variant="caption" sx={{
              color: shopifyColors.textSecondary,
              fontSize: '10px',
              display: 'block',
              mt: 0.5
            }}>
              Across {warehouseCount} warehouse{warehouseCount > 1 ? 's' : ''}
            </Typography>
          )}
        </Box>
      );
    }
  };

  const renderReturnLimit = (product: Product) => {
    const returnLimit = product.return_limit || 0;
    return (
      <Chip
        label={`${returnLimit} limits`}
        size="small"
        sx={{
          bgcolor: returnLimit > 0 ? '#e6f6fc' : '#e4e5e7',
          color: returnLimit > 0 ? '#006fbb' : '#616161',
          fontWeight: 600,
          fontSize: isMobile ? '10px' : '12px',
          borderRadius: '6px',
          cursor: 'pointer',
          '&:hover': {
            bgcolor: returnLimit > 0 ? '#d4edfa' : '#d8d9db',
          }
        }}
        onClick={() => handleOpenReturnLimitDialog(product)}
      />
    );
  };

  const renderPopularScore = (score: number) => {
    return (
      <Chip
        label={isMobile ? `S: ${score}` : `Score: ${score}`}
        size="small"
        variant="outlined"
        sx={{
          borderColor: score >= 80 ? '#00783e' : score >= 50 ? '#ffc453' : '#e1e3e5',
          color: score >= 80 ? '#00783e' : score >= 50 ? '#b24000' : '#6d7175',
          fontWeight: 500,
          fontSize: isMobile ? '10px' : '11px',
          borderRadius: '6px'
        }}
      />
    );
  };

  // Format currency in Shopify style
  const formatCurrencyAED = (amount: number, currency: string = 'AED') => {
    return new Intl.NumberFormat('ar-AE', {
      style: 'currency',
      currency: currency,
      currencyDisplay: 'symbol'
    }).format(amount);
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    // Scroll to top when changing page
    scrollToTop();
  };

  const handlePopularPageChange = (event: React.ChangeEvent<unknown>, newPage: number) => {
    setPopularPage(newPage);
    // Scroll to top when changing page
    scrollToTop();
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchStr(value);
    setPage(1);
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      if (productType === 'bundle') {
        refetchBundles();
        refetchBundleCount();
      } else {
        refetch();
        refetchCount();
      }
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchStr, categoryFilter, subCategoryFilter, statusFilter, availabilityFilter, stockFilter, discountFilter, approvalFilter, sortBy, refetch, refetchCount, refetchBundles, refetchBundleCount, productType]);

  const handlePopularSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    setPopularSearchStr(event.target.value);
    setPopularPage(1);
  };

  const handleProductTypeChange = (event: SelectChangeEvent<'single' | 'bundle'>) => {
    setProductType(event.target.value as 'single' | 'bundle');
    setPage(1);
  };

  // Category Filter Handlers
  const handleOpenFilterMenu = (event: React.MouseEvent<HTMLElement>) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleCloseFilterMenu = () => {
    setFilterAnchorEl(null);
  };

  const handleCategoryFilterChange = (categoryId: string) => {
    if (categoryId === 'all') {
      setCategoryFilter('all');
      setSubCategoryFilter('all');
    } else {
      setCategoryFilter(categoryId);
      setSubCategoryFilter('all'); // Reset subcategory when category changes
    }
    setPage(1);
    handleCloseFilterMenu();
  };

  const handleSubCategoryFilterChange = (subCategoryId: string) => {
    setSubCategoryFilter(subCategoryId);
    setPage(1);
  };

  const handleStatusFilterChange = (status: string) => {
    setStatusFilter(status);
    setPage(1);
  };

  const handleAvailabilityFilterChange = (availability: string) => {
    setAvailabilityFilter(availability);
    setPage(1);
  };

  const handleSortChange = (sort: string) => {
    setSortBy(sort);
    setPage(1);
  };

  const handleClearFilters = () => {
    setCategoryFilter('all');
    setSubCategoryFilter('all');
    setStatusFilter('all');
    setAvailabilityFilter('all');
    setStockFilter('all');
    setDiscountFilter('all');
    setApprovalFilter('all');
    setSortBy('newest');
    setSearchStr('');
    setPage(1);
  };

  // UI Filter Function
  const filterProducts = (products: Product[]) => {
    if (!products || !Array.isArray(products)) return [];

    let filtered = [...products];

    // Search filter
    if (searchStr.trim() !== '') {
      const searchLower = searchStr.toLowerCase();
      filtered = filtered.filter(product =>
        product.prod_name?.toLowerCase().includes(searchLower) ||
        product.prod_short_name?.toLowerCase().includes(searchLower) ||
        product.product_price?.toString().includes(searchStr) ||
        product.cat_id?.toString().includes(searchStr)
      );
    }

    // Category filter
    if (categoryFilter !== 'all') {
      const catId = Number(categoryFilter);
      filtered = filtered.filter(product => product.cat_id === catId);
    }

    // Subcategory filter
    if (subCategoryFilter !== 'all') {
      const subCatId = Number(subCategoryFilter);
      filtered = filtered.filter(product => product.sub_cat_id === subCatId);
    }

    // Status filter
    if (statusFilter !== 'all') {
      const status = Number(statusFilter);
      filtered = filtered.filter(product => product.status === status);
    }

    // Availability filter
    if (availabilityFilter !== 'all') {
      const availability = Number(availabilityFilter);
      filtered = filtered.filter(product => product.availability === availability);
    }

    // Sort filter
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          // Assuming you have a created_at field
          return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
        case 'oldest':
          return new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime();
        case 'name_asc':
          return (a.prod_name || '').localeCompare(b.prod_name || '');
        case 'name_desc':
          return (b.prod_name || '').localeCompare(a.prod_name || '');
        case 'price_asc':
          return (a.product_price || 0) - (b.product_price || 0);
        case 'price_desc':
          return (b.product_price || 0) - (a.product_price || 0);
        case 'stock_asc':
          return (a.product_stock || 0) - (b.product_stock || 0);
        case 'stock_desc':
          return (b.product_stock || 0) - (a.product_stock || 0);
        default:
          return 0;
      }
    });

    return filtered;
  };

  // UI Filter for Bundles
  const filterBundles = (bundles: Bundle[]) => {
    if (!bundles || !Array.isArray(bundles)) return [];

    let filtered = [...bundles];

    // Search filter
    if (searchStr.trim() !== '') {
      const searchLower = searchStr.toLowerCase();
      filtered = filtered.filter(bundle =>
        bundle.bundle_name?.toLowerCase().includes(searchLower) ||
        bundle.bundle_short_name?.toLowerCase().includes(searchLower) ||
        (bundle.bundle_price?.toString() || '').includes(searchStr) ||
        (bundle.cat_id?.toString() || '').includes(searchStr)
      );
    }

    // Category filter
    if (categoryFilter !== 'all') {
      const catId = Number(categoryFilter);
      filtered = filtered.filter(bundle => bundle.cat_id === catId);
    }
    // Subcategory filter
    if (subCategoryFilter !== 'all') {
      const subCatId = Number(subCategoryFilter);
      filtered = filtered.filter(bundle => bundle.sub_cat_id === subCatId);
    }

    // Status filter
    if (statusFilter !== 'all') {
      const status = Number(statusFilter);
      filtered = filtered.filter(bundle => bundle.status === status);
    }

    // Availability filter
    if (availabilityFilter !== 'all') {
      const availability = Number(availabilityFilter);
      filtered = filtered.filter(bundle => bundle.availability === availability);
    }

    // Sort filter
    filtered.sort((a, b) => {
      switch (sortBy) {
        case 'newest':
          return new Date(b.created_at || 0).getTime() - new Date(a.created_at || 0).getTime();
        case 'oldest':
          return new Date(a.created_at || 0).getTime() - new Date(b.created_at || 0).getTime();
        case 'name_asc':
          return (a.bundle_name || '').localeCompare(b.bundle_name || '');
        case 'name_desc':
          return (b.bundle_name || '').localeCompare(a.bundle_name || '');
        case 'price_asc':
          return (a.bundle_price || 0) - (b.bundle_price || 0);
        case 'price_desc':
          return (b.bundle_price || 0) - (a.bundle_price || 0);
        case 'stock_asc':
          return (a.bundle_stock || 0) - (b.bundle_stock || 0);
        case 'stock_desc':
          return (b.bundle_stock || 0) - (a.bundle_stock || 0);
        default:
          return 0;
      }
    });

    return filtered;
  };

  // Then replace the API calls with UI filtering:
  const allProducts = productsResponse?.result || productsResponse?.data || [];
  const allBundles = Array.isArray(bundlesResponse?.result) ? bundlesResponse.result :
    Array.isArray(bundlesResponse?.data) ? bundlesResponse.data :
      Array.isArray(bundlesResponse) ? bundlesResponse : [];

  // Apply UI filters
  const filteredProducts = filterProducts(allProducts);
  const filteredBundles = filterBundles(allBundles);

  // Check if any filter is active
  const isFilterActive =
    categoryFilter !== 'all' ||
    subCategoryFilter !== 'all' ||
    statusFilter !== 'all' ||
    availabilityFilter !== 'all' ||
    stockFilter !== 'all' ||
    discountFilter !== 'all' ||
    approvalFilter !== 'all' ||
    Boolean(vendorSearchStr.trim()) ||
    sortBy !== 'newest';

  // Get filtered subcategories based on selected category
  const filteredSubCategoriesForFilter = useMemo(() => {
    if (categoryFilter === 'all') return [];
    const selectedCatId = Number(categoryFilter);
    const list: any[] = filterSubCategoriesResponse?.result || filterSubCategoriesResponse?.data || [];
    return list
      .filter((subCat: any) => {
        const parent = subCat.cat_id ?? subCat.category_id;
        return parent === undefined || parent === null || Number(parent) === selectedCatId;
      })
      .sort((a: any, b: any) => String(a.sub_cat_name || '').localeCompare(String(b.sub_cat_name || '')));
  }, [categoryFilter, filterSubCategoriesResponse]);

  // Bundle product selection handlers
  const handleProductSelection = (product: Product) => {
    const isSelected = selectedProducts.some(p => p.product_id === (product.product_id || product.id));

    if (isSelected) {
      setSelectedProducts(prev => prev.filter(p => p.product_id !== (product.product_id || product.id)));
      setProductQuantities(prev => {
        const newQuantities = { ...prev };
        delete newQuantities[product.product_id || product.id || 0];
        return newQuantities;
      });
    } else {
      const bundleProduct: BundleProduct = {
        product_id: product.product_id || product.id || 0,
        product_name: product.prod_name || '',
        product_price: product.product_price || 0,
        product_retail_price: product.product_retail_price || 0,
        product_main_image: product.product_main_image || '',
        quantity: 1
      };
      setSelectedProducts(prev => [...prev, bundleProduct]);
      setProductQuantities(prev => ({
        ...prev,
        [product.product_id || product.id || 0]: 1
      }));
    }
  };

  const handleProductQuantityChange = (productId: number, quantity: number) => {
    setProductQuantities(prev => ({
      ...prev,
      [productId]: quantity
    }));

    setSelectedProducts(prev =>
      prev.map(p =>
        p.product_id === productId ? { ...p, quantity } : p
      )
    );
  };

  // Flash Sale handlers
  const handleOpenFlashSaleDialog = (product: Product) => {
    setSelectedProductForFlashSale(product);
    setFlashSaleFormData({
      start_date: '',
      end_date: '',
      active: true,
    });
    setFlashSaleFormErrors({});
    setFlashSaleDialogOpen(true);
  };

  const handleCloseFlashSaleDialog = () => {
    setFlashSaleDialogOpen(false);
    setSelectedProductForFlashSale(null);
    setFlashSaleFormData({
      start_date: '',
      end_date: '',
      active: true,
    });
    setFlashSaleFormErrors({});
  };

  const handleFlashSaleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFlashSaleFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (flashSaleFormErrors[name as keyof typeof flashSaleFormErrors]) {
      setFlashSaleFormErrors(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  const handleFlashSaleActiveChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFlashSaleFormData(prev => ({
      ...prev,
      active: e.target.checked
    }));
  };

  const validateFlashSaleForm = (): boolean => {
    const errors: typeof flashSaleFormErrors = {};

    if (!flashSaleFormData.start_date) {
      errors.start_date = 'Start date is required';
    }
    if (!flashSaleFormData.end_date) {
      errors.end_date = 'End date is required';
    }
    if (flashSaleFormData.start_date && flashSaleFormData.end_date &&
      new Date(flashSaleFormData.end_date) <= new Date(flashSaleFormData.start_date)) {
      errors.end_date = 'End date must be after start date';
    }

    setFlashSaleFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddToFlashSale = async () => {
    if (!validateFlashSaleForm() || !selectedProductForFlashSale) {
      return;
    }

    try {
      const payload = {
        product_id: Number(selectedProductForFlashSale.product_id || selectedProductForFlashSale.id),
        product_price: selectedProductForFlashSale.product_price || 0,
        start_date: flashSaleFormData.start_date,
        end_date: flashSaleFormData.end_date,
        active: flashSaleFormData.active ? 1 : 0,
      };

      await addFlashSale(payload).unwrap();

      setSnackbar({
        open: true,
        message: 'Product added to flash sale successfully!',
        severity: 'success'
      });

      handleCloseFlashSaleDialog();
    } catch (err: any) {
      console.error('Failed to add flash sale:', err);
      setSnackbar({
        open: true,
        message: err?.data?.message || err?.message || 'Error adding product to flash sale. Please try again.',
        severity: 'error'
      });
    }
  };

  // Warehouse Stock Management Handlers
  const handleOpenWarehouseStockDialog = (product: Product) => {
    setSelectedProductForWarehouse(product);
    setWarehouseStockDialogOpen(true);
  };

  const handleCloseWarehouseStockDialog = () => {
    setWarehouseStockDialogOpen(false);
    setSelectedProductForWarehouse(null);
    setWarehouseStocks([]);
  };

  // Initialize warehouse stocks when product warehouses data is loaded
  useEffect(() => {
    if (productWarehouses.length > 0 && selectedProductForWarehouse) {
      const initialStocks = productWarehouses.map(pw => ({
        warehouse_id: pw.warehouse_id,
        available_quantity: pw.available_quantity
      }));
      setWarehouseStocks(initialStocks);
    } else if (selectedProductForWarehouse && productWarehouses.length === 0) {
      setWarehouseStocks([]);
    }
  }, [productWarehouses, selectedProductForWarehouse]);

  const handleWarehouseStockChange = (warehouseId: number, quantity: number) => {
    setWarehouseStocks(prev => {
      const existing = prev.find(item => item.warehouse_id === warehouseId);
      if (existing) {
        return prev.map(item =>
          item.warehouse_id === warehouseId
            ? { ...item, available_quantity: quantity }
            : item
        );
      } else {
        return [...prev, { warehouse_id: warehouseId, available_quantity: quantity }];
      }
    });
  };

  const handleSaveWarehouseStocks = async () => {
    if (!selectedProductForWarehouse) return;

    try {
      const productId = selectedProductForWarehouse.id || selectedProductForWarehouse.product_id || 0;

      if (!productId) {
        throw new Error('Product ID is missing');
      }

      const totalStock = warehouseStocks.reduce((sum, stock) => sum + stock.available_quantity, 0);

      for (const stock of warehouseStocks) {
        const existingStock = productWarehouses.find(
          pw => pw.warehouse_id === stock.warehouse_id && pw.product_id === productId
        );

        if (existingStock) {
          await updateProductWarehouse({
            id: existingStock.id,
            product_id: productId,
            warehouse_id: stock.warehouse_id,
            available_quantity: stock.available_quantity
          }).unwrap();
        } else {
          await addProductWarehouse({
            product_id: productId,
            warehouse_id: stock.warehouse_id,
            available_quantity: stock.available_quantity
          }).unwrap();
        }
      }

      const updatedWarehouseIds = warehouseStocks.map(stock => stock.warehouse_id);
      for (const pw of productWarehouses) {
        if (!updatedWarehouseIds.includes(pw.warehouse_id) && pw.product_id === productId) {
          await deleteProductWarehouse(pw.id).unwrap();
        }
      }

      try {
        await updateProduct({
          product_id: productId,
          product_stock: totalStock
        } as UpdateProductRequest).unwrap();
      } catch (error) {
        console.error('⚠️ Could not update product total stock:', error);
      }

      setSnackbar({
        open: true,
        message: `Warehouse stocks updated successfully! Total stock: ${totalStock}`,
        severity: 'success'
      });

      await Promise.all([
        refetch(),
        refetchWarehouses(),
        refetchCount(),
        refetchProductWarehouses()
      ]);

      handleCloseWarehouseStockDialog();

    } catch (err: any) {
      console.error('❌ Failed to update warehouse stocks:', err);
      setSnackbar({
        open: true,
        message: err?.data?.message || err?.message || 'Error updating warehouse stocks. Please try again.',
        severity: 'error'
      });
    }
  };

  // Product Return Limit Handlers
  const handleOpenReturnLimitDialog = (product: Product) => {
    setSelectedProductForReturnLimit(product);
    setProductReturnLimit(product.return_limit?.toString() || '0');
    setReturnLimitDialogOpen(true);
  };

  const handleCloseReturnLimitDialog = () => {
    setReturnLimitDialogOpen(false);
    setSelectedProductForReturnLimit(null);
    setProductReturnLimit('0');
  };

  const handleReturnLimitChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value === '' || /^\d+$/.test(value)) {
      setProductReturnLimit(value);
    }
  };

  const handleSaveReturnLimit = async () => {
    if (!selectedProductForReturnLimit) return;

    const productId = selectedProductForReturnLimit.id || selectedProductForReturnLimit.product_id;
    if (!productId) {
      setReturnLimitSnackbar({
        open: true,
        message: 'Product ID is missing',
        severity: 'error'
      });
      return;
    }

    if (!productReturnLimit || productReturnLimit === '0') {
      setReturnLimitSnackbar({
        open: true,
        message: 'Please enter a valid return limit (greater than 0)',
        severity: 'error'
      });
      return;
    }

    try {
      const result = await setProductReturnLimitMutation({
        product_id: productId,
        return_limit: productReturnLimit
      }).unwrap();

      // Check for success - assume success unless there's an explicit error flag
      if (result && result.success !== false) {
        setReturnLimitSnackbar({
          open: true,
          message: result.message || `Product return limit updated successfully for ${selectedProductForReturnLimit.prod_name}!`,
          severity: 'success'
        });

        setTimeout(() => {
          handleCloseReturnLimitDialog();
          refetch();
        }, 1500);
      } else {
        throw new Error(result?.message || 'Failed to update return limit');
      }
    } catch (err: any) {
      let errorMessage = 'Error updating product return limit.';

      if (err?.data?.message) {
        errorMessage = err.data.message;
      } else if (err?.message) {
        errorMessage = err.message;
      }

      setReturnLimitSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    }
  };

  const handleCloseReturnLimitSnackbar = () => {
    setReturnLimitSnackbar({ ...returnLimitSnackbar, open: false });
  };

  const quillModules = {
    toolbar: [
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
      [{ 'font': [] }],
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'align': [] }],
      ['link', 'image'],
      ['blockquote', 'code-block'],
      ['clean']
    ],
  };

  const quillFormats = [
    'header', 'font', 'size',
    'bold', 'italic', 'underline', 'strike',
    'color', 'background',
    'list', 'bullet', 'align',
    'link', 'image', 'blockquote', 'code-block'
  ];

  // Deal of the Day handlers
  const handleOpenDealDialog = (product: Product) => {
    setSelectedProductForDeal(product);
    setDealFormData({
      start_date: '',
      end_date: '',
      discount: '',
      status: 1,
    });
    setDealFormErrors({});
    setDealOfTheDayDialogOpen(true);
  };

  const handleCloseDealDialog = () => {
    setDealOfTheDayDialogOpen(false);
    setSelectedProductForDeal(null);
    setDealFormData({
      start_date: '',
      end_date: '',
      discount: '',
      status: 1,
    });
    setDealFormErrors({});
  };

  const handleDealInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setDealFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (dealFormErrors[name as keyof typeof dealFormErrors]) {
      setDealFormErrors(prev => ({
        ...prev,
        [name]: undefined
      }));
    }
  };

  const handleDealStatusChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setDealFormData(prev => ({
      ...prev,
      status: e.target.checked ? 1 : 0
    }));
  };

  const validateDealForm = (): boolean => {
    const errors: typeof dealFormErrors = {};

    if (!dealFormData.start_date) {
      errors.start_date = 'Start date is required';
    }
    if (!dealFormData.end_date) {
      errors.end_date = 'End date is required';
    }
    // Remove discount validation - make it optional
    if (dealFormData.discount && (parseFloat(dealFormData.discount) <= 0 || parseFloat(dealFormData.discount) > 100)) {
      errors.discount = 'Discount must be between 1 and 100';
    }
    if (dealFormData.start_date && dealFormData.end_date &&
      new Date(dealFormData.end_date) <= new Date(dealFormData.start_date)) {
      errors.end_date = 'End date must be after start date';
    }

    setDealFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleAddToDeal = async () => {
    if (!validateDealForm() || !selectedProductForDeal) {
      return;
    }

    try {
      const payload = {
        product_id: Number(selectedProductForDeal.product_id || selectedProductForDeal.id),
        discount: Number(dealFormData.discount),
        start_date: dealFormData.start_date,
        end_date: dealFormData.end_date,
        status: dealFormData.status,
      };

      await addDeal(payload).unwrap();

      setSnackbar({
        open: true,
        message: 'Product added as Deal of the Day successfully!',
        severity: 'success'
      });

      handleCloseDealDialog();
    } catch (err: any) {
      console.error('Failed to add deal:', err);
      setSnackbar({
        open: true,
        message: err?.data?.message || err?.message || 'Error adding product as Deal of the Day. Please try again.',
        severity: 'error'
      });
    }
  };

  // form handling functions
  const resetForm = () => {
    setFormData({
      product_name: '',
      product_short_name: '',
      product_desc: '',
      status: 1,
      product_unit: 'pcs',
      product_quantity: 1,
      currency: 'AED',
      product_price: 0,
      product_retail_price: 0,
      discount_type: 0,
      product_discount: 0,
      cat_id: 0,
      sub_cat_id: undefined,
      availability: 0,
      max_order_quantity: 10,
      min_quantity: 10,
      product_stock: 1,
      price_priority: 1,
      delivery_model: [],
      shipping_model: 1,
      tax1_name: globalTaxName,
      tax1_per: globalTaxPer,
      tax2_name: 'GST',
      tax2_per: 0,
      popular_score: 0,
      vendor_id: isVendor ? vendorId : undefined,
      warehouse_id: null,
      warehouse_stocks: [],
      open_box_delivery: 0,
      open_box_charge: 0,
      cod_available: 1,
    });

    // ✅ Reset COD local state to 1 (enabled)
    setCodEnabled(1);

    setSelectedImage(null);
    setImagePreview('');
    setFormErrors({});
    setEditingProduct(null);
    setTabValue(0);
    setAdditionalImages([]);
    setSelectedProductId(null);
  };

  const resetBundleForm = () => {
    setBundleFormData({
      bundle_name: '',
      bundle_short_name: '', // Ensure it's reset properly
      bundle_desc: '',
      status: 1,
      currency: 'AED',
      bundle_price: 0,
      bundle_retail_price: 0,
      discount_type: 0,
      bundle_discount: 0,
      cat_id: 0,
      sub_cat_id: undefined,
      availability: 0,
      max_order_quantity: 10,
      bundle_stock: 0,
      price_priority: 1,
      delivery_model: [], // Array for multiple delivery methods
      shipping_model: 1,
      tax1_name: globalTaxName,
      tax1_per: globalTaxPer,
      tax2_name: 'GST',
      tax2_per: 0,
      popular_score: 0,
      vendor_id: isVendor ? vendorId : undefined,
      products: [],
    });
    setSelectedProducts([]);
    setProductQuantities({});
    setSelectedImage(null);
    setImagePreview('');
    setFormErrors({});
    setEditingBundle(null);
    setTabValue(0);
  };

  const handleAddProduct = () => {
    resetForm();
    setProductType('single');
    setFormOpen(true);
  };

  const handleAddBundle = () => {
    resetBundleForm();
    setProductType('bundle');
    setFormOpen(true);
  };


 const handleEditProduct = (product: Product) => {
  if (isVendor && !isOwnVendorProduct(product)) {
    setSnackbar({ open: true, message: 'You can only edit your own products', severity: 'error' });
    return;
  }

  if (isVendor && String(product.approval_status || '').toLowerCase() === 'approved') {
    const proceed = window.confirm('This product is already approved. Any changes may require admin review before the updated details are published. Do you want to continue?');
    if (!proceed) return;
  }

  setTempDeliveryModels([]);
  setTabValue(0);
  setAdditionalImages([]);
  setSelectedProductId(product?.id ?? null);
  setSelectedImage(null); // Clear any stray File left over from a previous edit session

  // selectedProductId can be the SAME id as the last product that was
  // edited (re-opening Edit on the same row after closing it once). RTK
  // Query won't refetch on its own when the args haven't changed, so
  // without this, additionalImages stays stuck at the [] we just reset it
  // to above — the effect that repopulates it only runs when the query
  // data reference actually changes. Explicitly refetching here guarantees
  // fresh images/video every time Edit is opened, even for the same product.
  //
  // Guarded with the `isUninitialized` flags: on the very first Edit click
  // of a session (no product opened yet), these queries were still `skip:
  // true` up to this point and have never started, so calling refetch()
  // on them throws "Cannot refetch a query that has not been started yet."
  // In that case the upcoming setSelectedProductId (already run above) is
  // enough on its own — it flips `skip` to false and RTK Query fetches
  // fresh data naturally, no explicit refetch needed.
  const editProductId = product?.id ?? null;
  if (editProductId) {
    // Fire the refetches, and — on top of the existing useEffect below —
    // ALSO consume their resolved data directly here. The effect only
    // re-runs when productDetailResponse/adminProductMediaResponse change
    // *reference*, and re-opening Edit on the SAME product doesn't always
    // guarantee that reference actually changes in time, which is why
    // additionalImages could stay stuck at [] (showing "No additional
    // images uploaded yet") until a full page refresh. Setting it directly
    // from the refetch's own resolved result removes that dependency
    // entirely, so it's correct every single time Edit is opened.
    const detailPromise = !productDetailUninitialized ? refetchProductDetail() : null;
    const mediaPromise = !adminProductMediaUninitialized ? refetchAdminProductMedia() : null;

    if (detailPromise || mediaPromise) {
      Promise.all([
        detailPromise ?? Promise.resolve(null),
        mediaPromise ?? Promise.resolve(null),
      ]).then(([detailRes, mediaRes]: any[]) => {
        const storefrontImages = detailRes?.data?.images || [];
        const sourceImages = storefrontImages.length > 0
          ? storefrontImages
          : (mediaRes?.data?.images || []);

        setAdditionalImages(
          sourceImages.map((img: any) => ({
            id: img.id,
            filename: img.product_image || img.image,
          }))
        );
      }).catch((err) => {
        console.error('Failed to refresh additional images on edit open:', err);
      });
    }
    // First-ever Edit click of a session: both queries were still
    // `skip: true` until setSelectedProductId above flipped it off, so
    // there's nothing to refetch yet — the natural fetch RTK Query kicks
    // off on its own, and the existing useEffect below picks it up once
    // it resolves.
  }

  const productId = product.product_id || product.id;
  if (productId) {
    fetchProductDeliveryModels({ product_id: productId })
      .then((res: any) => {
        const ids: number[] = res?.data?.result || [];
        setTempDeliveryModels(Array.isArray(ids) ? ids.map(Number).filter(n => !isNaN(n)) : []);
      })
      .catch(() => setTempDeliveryModels([]));
  }

  // ✅ Get COD value from product - ensure it's properly set to 0 or 1
  const codValue = product.cod_available !== undefined && product.cod_available !== null 
    ? product.cod_available 
    : 1;
  
  console.log('📝 Loading product with COD value:', codValue, 'Product:', product.prod_name);

  // Set form data with all product details
  // ⚠️ IMPORTANT: use `??` (nullish coalescing), NOT `||`, for every numeric /
  // status-like field below. `||` treats a real, intentionally-saved 0 as
  // "missing" and silently swaps in the fallback (e.g. status 0 -> 1,
  // availability 0 -> 1, cat_id 0 -> 0 by luck). That meant editing a product
  // for ANY reason (including just replacing the image) could silently flip
  // fields the admin never touched, which could push the product out of the
  // current status/availability/category filter on the list screen after
  // saving — looking exactly like "the product disappeared from the list".
  setFormData({
    product_name: product.prod_name || '',
    product_short_name: product.prod_short_name || '',
    product_desc: product.prod_desc || '',
    status: product.status ?? 1,
    product_unit: product.product_unit || 'pcs',
    product_quantity: product.product_quantity ?? 1,
    currency: product.currency || 'AED',
    product_price: product.product_price ?? 0,
    product_retail_price: product.product_retail_price ?? 0,
    discount_type: product.discount_type ?? 0,
    product_discount: product.product_discount ?? 0,
    cat_id: product.cat_id ?? 0,
    sub_cat_id: product.sub_cat_id,
    availability: product.availability ?? 1,
    max_order_quantity: product.max_order_quantity ?? 10,
    min_quantity: product.min_quantity ?? 10,
    tax1_name: product.tax1_name || globalTaxName,
    tax1_per: (product.tax1_per !== undefined && product.tax1_per !== null) ? product.tax1_per : globalTaxPer,
    tax2_name: product.tax2_name || 'GST',
    tax2_per: product.tax2_per ?? 0,
    product_stock: product.product_stock ?? 0,
    shipping_charge: product.shipping_charge ?? 0,
    shipping_model: product.shipping_model ?? 1,
    delivery_model: [],
    vendor_id: product.vendor_id || (isVendor ? vendorId : undefined),
    price_priority: product.price_priority ?? 1,
    popular_score: product.popular_score ?? 0,
    warehouse_id: product.warehouse_id || null,
    warehouse_stocks: product.warehouse_stocks || [],
    open_box_delivery: product.open_box_delivery ?? 0,
    open_box_charge: product.open_box_charge ?? 0,
    cod_available: codValue,  // ✅ Set cod_available from product
  });

  // ✅ Set COD local state to match the product's cod_available value
  setCodEnabled(codValue as 0 | 1);
  
  console.log('✅ Set codEnabled to:', codValue, 'for product:', product.prod_name);

  // Set image preview if product has main image
  setImagePreview(
    product.product_main_image
      ? `https://fftestservice.sarsetech.com/images/${product.product_main_image}`
      : ''
  );
  
  // Set editing product and open form
  setEditingProduct(product);
  setProductType('single');
  setFormOpen(true);
};

  // UPDATED handleEditBundle with delivery model fix
  const handleEditBundle = (bundle: Bundle) => {
    // Check if vendor is trying to edit someone else's bundle
    if (isVendor && Number(bundle.vendor_id) !== Number(normalizedVendorId)) {
      setSnackbar({ open: true, message: 'You can only edit your own bundles', severity: 'error' });
      return;
    }

    setSelectedImage(null); // Same fix as handleEditProduct

    // ✅ Fetch real delivery model IDs from product_delivery_models junction table
    setTempBundleDeliveryModels([]);
    const bundleProductId = bundle.product_id || bundle.bundle_id || bundle.id;
    if (bundleProductId) {
      fetchProductDeliveryModels({ product_id: bundleProductId })
        .then((res: any) => {
          const ids: number[] = res?.data?.result || [];
          setTempBundleDeliveryModels(Array.isArray(ids) ? ids.map(Number).filter(n => !isNaN(n)) : []);
        })
        .catch(() => setTempBundleDeliveryModels([]));
    }

    // Same `??` fix as handleEditProduct above — don't let a real 0 in
    // status/availability/cat_id/etc. get silently replaced when a bundle is
    // re-saved (e.g. after only changing its image).
    setBundleFormData({
      bundle_name: bundle.bundle_name || '',
      bundle_short_name: bundle.bundle_short_name || '',
      bundle_desc: bundle.bundle_desc || '',
      status: bundle.status ?? 1,
      currency: bundle.currency || 'AED',
      bundle_price: bundle.bundle_price ?? 0,
      bundle_retail_price: bundle.bundle_retail_price ?? 0,
      discount_type: bundle.discount_type ?? 0,
      bundle_discount: bundle.bundle_discount ?? 0,
      cat_id: bundle.cat_id ?? 0,
      sub_cat_id: bundle.sub_cat_id,
      availability: bundle.availability ?? 1,
      max_order_quantity: bundle.max_order_quantity ?? 10,
      bundle_stock: bundle.bundle_stock ?? 0,
      tax1_name: bundle.tax1_name || globalTaxName,
      tax1_per: (bundle.tax1_per !== undefined && bundle.tax1_per !== null) ? bundle.tax1_per : globalTaxPer,
      tax2_name: bundle.tax2_name || 'GST',
      tax2_per: bundle.tax2_per ?? 0,
      shipping_charge: bundle.shipping_charge ?? 0,
      shipping_model: bundle.shipping_model ?? 1,
      delivery_model: [],
      price_priority: bundle.price_priority ?? 1,
      popular_score: bundle.popular_score ?? 0,
      vendor_id: bundle.vendor_id || (isVendor ? vendorId : undefined),
      products: bundle.products || [],

    });

    // Set selected products from bundle
    if (bundle.products && Array.isArray(bundle.products)) {
      setSelectedProducts(bundle.products);
      const quantities: { [key: number]: number } = {};
      bundle.products.forEach((p: BundleProduct) => {
        quantities[p.product_id] = p.quantity || 1;
      });
      setProductQuantities(quantities);
    }

    setImagePreview(bundle.bundle_main_image ? `https://fftestservice.sarsetech.com/images/${bundle.bundle_main_image}` : '');
    setEditingBundle(bundle);
    setProductType('bundle');
    setFormOpen(true);
  };

  const handleViewProductDetails = (productId: number) => {
    setSelectedProductId(productId);
    setDetailOpen(true);
    // Guarded for the same reason as handleEditProduct above: on the very
    // first click of a session these queries are still skipped/never
    // started, and refetch() on an unstarted query throws.
    if (!productDetailUninitialized) refetchProductDetail();
    if (!adminProductMediaUninitialized) refetchAdminProductMedia();
    refetchProductColors();
    refetchProductSizes();
  };

  // Arriving here from a notification click hands us a specific product_id —
  // open that product's own detail dialog instead of just the full list.
  const routerLocation = useLocation();
  const routerNavigate = useNavigate();
  useEffect(() => {
    const openProductId = (routerLocation.state as any)?.openProductId;
    if (openProductId) {
      handleViewProductDetails(Number(openProductId));
      // Clear the nav state so revisiting this page doesn't keep reopening it.
      routerNavigate(routerLocation.pathname, { replace: true, state: {} });
    }
  }, []);

  // First, let's fix the handleFormClose function to NOT reset when editing:
  const handleFormClose = () => {
    if (isEditing || isEditingBundle) {
      // When editing, just close the dialog but keep the data
      // so if user reopens it, the selections are still there
      setFormOpen(false);
    } else {
      // When adding new product, reset everything
      resetForm();
      resetBundleForm();
      setFormOpen(false);
    }
    setEditingProduct(null);
    setEditingBundle(null);
    setAdditionalImages([]);
  };

  const handleDetailClose = () => {
    setDetailOpen(false);
    setSelectedProductId(null);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    if (productType === 'bundle') {
      setBundleFormData(prev => ({
        ...prev,
        [name]: (name.includes('_per') || name.includes('price') || name.includes('discount') ||
          name.includes('quantity') || name.includes('stock') || name.includes('popular_score') ||
          name.includes('open_box')) ? (value === '' ? '' : Number(value)) : value
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: (name.includes('_per') || name.includes('price') || name.includes('discount') ||
          name.includes('quantity') || name.includes('stock') || name.includes('popular_score') ||
          name.includes('open_box')) ? (value === '' ? '' : Number(value)) : value
      }));
    }

    if (formErrors[name]) {
      setFormErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const handleSelectChange = (event: SelectChangeEvent) => {
    const { name, value } = event.target;

    setFormData(prev => ({
      ...prev,
      [name]: value === '' ? null : value,
    }));
  };

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const handleProductScopeChange = (_event: React.SyntheticEvent, newValue: string) => {
    if (isVendor) return;
    const nextScope = newValue as 'all' | 'own' | 'vendor';
    setProductScope(nextScope);
    setPage(1);
    // Ownership tabs represent the primary list scope, so reset only filters
    // that could otherwise make the selected tab appear empty unexpectedly.
    setApprovalFilter('all');
    setStatusFilter('all');
    setAvailabilityFilter('all');
    setStockFilter('all');
    setDiscountFilter('all');
  };

  const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
      if (!allowedTypes.includes(file.type)) {
        setSnackbar({
          open: true,
          message: 'Please select a valid image file (JPEG, PNG, or GIF)',
          severity: 'error'
        });
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        setSnackbar({
          open: true,
          message: 'Image size should be less than 5MB',
          severity: 'error'
        });
        return;
      }

      setSelectedImage(file);
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target?.result as string);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleRemoveImage = () => {
    setSelectedImage(null);
    setImagePreview('');
    const fileInput = document.getElementById('image-upload') as HTMLInputElement;
    if (fileInput) {
      fileInput.value = '';
    }
  };

  const validateForm = (): { isValid: boolean; errorTab: number | null } => {
    const newErrors: FormErrors = {};
    let errorTab: number | null = null;

    if (productType === 'bundle') {
      // Tab 0 - Basic Info errors
      if (!bundleFormData.bundle_name?.trim()) {
        newErrors.bundle_name = 'Bundle name is required';
        if (errorTab === null) errorTab = 0;
      }
      if (!bundleFormData.bundle_short_name.trim()) {
        newErrors.bundle_short_name = 'Bundle short name is required';
        if (errorTab === null) errorTab = 0;
      }
      if (!bundleFormData.cat_id || bundleFormData.cat_id === 0) {
        newErrors.cat_id = 'Category is required';
        if (errorTab === null) errorTab = 0;
      }

      // Tab 1 - Pricing errors
      if (bundleFormData.bundle_price <= 0) {
        newErrors.bundle_price = 'Price must be greater than 0';
        if (errorTab === null) errorTab = 1;
      }
      if (bundleFormData.bundle_retail_price <= 0) {
        newErrors.bundle_retail_price = 'Retail price must be greater than 0';
        if (errorTab === null) errorTab = 1;
      }

      // Tab 2 - Bundle Products errors
      if (selectedProducts.length === 0) {
        newErrors.products = 'At least one product must be selected for the bundle';
        if (errorTab === null) errorTab = 2;
      }
    } else {
      // Tab 0 - Basic Info errors
      if (!formData.product_name?.trim()) {
        newErrors.product_name = 'Product name is required';
        if (errorTab === null) errorTab = 0;
      }

      if (!formData.cat_id || formData.cat_id === 0) {
        newErrors.cat_id = 'Category is required';
        if (errorTab === null) errorTab = 0;
      }

      // Tab 1 - Pricing errors
      if (formData.product_price <= 0) {
        newErrors.product_price = 'Price must be greater than 0';
        if (errorTab === null) errorTab = 1;
      }
      if (formData.product_retail_price <= 0) {
        newErrors.product_retail_price = 'Retail price must be greater than 0';
        if (errorTab === null) errorTab = 1;
      }
    }

    setFormErrors(newErrors);
    return {
      isValid: Object.keys(newErrors).length === 0,
      errorTab
    };
  };

  // Last tab index in the Add/Edit Product dialog. The "Properties"/"Bundle
  // Products" tab (index 2) only shows for bundles or when editing an
  // existing single product, so the last tab shifts accordingly.
  const getLastTabIndex = () => {
    if (productType === 'bundle') return 3;
    if (productType === 'single' && isEditing) return 3;
    return 2;
  };

  // Validates only the fields that belong to a given tab, so the "Next"
  // button can block moving forward without requiring the whole form
  // (all tabs) to be valid yet.
  const validateTabFields = (tab: number): FormErrors => {
    const errs: FormErrors = {};

    if (productType === 'bundle') {
      if (tab === 0) {
        if (!bundleFormData.bundle_name?.trim()) errs.bundle_name = 'Bundle name is required';
        if (!bundleFormData.bundle_short_name.trim()) errs.bundle_short_name = 'Bundle short name is required';
        if (!bundleFormData.cat_id || bundleFormData.cat_id === 0) errs.cat_id = 'Category is required';
      }
      if (tab === 1) {
        if (bundleFormData.bundle_price <= 0) errs.bundle_price = 'Price must be greater than 0';
        if (bundleFormData.bundle_retail_price <= 0) errs.bundle_retail_price = 'Retail price must be greater than 0';
      }
      if (tab === 2) {
        if (selectedProducts.length === 0) errs.products = 'At least one product must be selected for the bundle';
      }
    } else {
      if (tab === 0) {
        if (!formData.product_name?.trim()) errs.product_name = 'Product name is required';
        if (!formData.product_short_name.trim()) errs.product_short_name = 'Product short name is required';
        if (!formData.cat_id || formData.cat_id === 0) errs.cat_id = 'Category is required';
      }
      if (tab === 1) {
        if (formData.product_price <= 0) errs.product_price = 'Price must be greater than 0';
        if (formData.product_retail_price <= 0) errs.product_retail_price = 'Retail price must be greater than 0';
      }
    }

    return errs;
  };

  const handleNextTab = () => {
    const tabErrors = validateTabFields(tabValue);

    if (Object.keys(tabErrors).length > 0) {
      setFormErrors(prev => ({ ...prev, ...tabErrors }));
      return;
    }

    // Clear out any stale errors that belonged to this tab, keep the rest.
    setFormErrors(prev => {
      const updated = { ...prev };
      const fieldsForTab = tab_fields_for(productType, tabValue);
      fieldsForTab.forEach(f => { delete updated[f as keyof FormErrors]; });
      return updated;
    });

    setTabValue(prev => Math.min(prev + 1, getLastTabIndex()));
  };

  // Field names owned by each tab, used to clear stale errors when moving on.
  const tab_fields_for = (type: 'single' | 'bundle', tab: number): string[] => {
    if (type === 'bundle') {
      if (tab === 0) return ['bundle_name', 'bundle_short_name', 'cat_id'];
      if (tab === 1) return ['bundle_price', 'bundle_retail_price'];
      if (tab === 2) return ['products'];
      return [];
    }
    if (tab === 0) return ['product_name', 'product_short_name', 'cat_id'];
    if (tab === 1) return ['product_price', 'product_retail_price'];
    return [];
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    const validation = validateForm();

    if (!validation.isValid) {
      if (validation.errorTab !== null) {
        setTabValue(validation.errorTab);
        setSnackbar({
          open: true,
          message: 'Please fill in all required fields in the highlighted tab',
          severity: 'error'
        });
      }
      return;
    }

    setIsFormSubmitting(true);

    try {
      if (productType === 'bundle') {
        // Prepare bundle data
        const bundleData = new FormData();

        // ✅ Always use tempBundleDeliveryModels when editing (no length > 0 guard)
        let deliveryModels: number[] = isEditingBundle
          ? [...tempBundleDeliveryModels]
          : (Array.isArray(bundleFormData.delivery_model) ? [...bundleFormData.delivery_model] : []);

        // If no delivery models selected, use default if available
        if (deliveryModels.length === 0 && defaultDeliveryModel) {
          deliveryModels = [defaultDeliveryModel.id];
        }

        // Add all bundle form data
        Object.keys(bundleFormData).forEach(key => {
          if (key === 'products') {
            // Handle products separately
            const productsData = selectedProducts.map(p => ({
              product_id: p.product_id,
              quantity: p.quantity
            }));
            bundleData.append('products', JSON.stringify(productsData));
          } else if (key === 'sub_cat_id' && !bundleFormData.sub_cat_id) {
            // Skip if sub_cat_id is undefined
            return;
          } else if (key === 'delivery_model') {
            // Handle delivery_model array
            bundleData.append(key, JSON.stringify(deliveryModels));
          } else {
            const value = bundleFormData[key as keyof BundleFormData];
            if (value !== undefined && value !== null) {
              bundleData.append(key, value.toString());
            }
          }
        });

        // Add image if selected
        if (selectedImage) {
          bundleData.append('bundle_main_image', selectedImage);
        }

        // Auto-add vendor_id for vendor users if not already set
        if (isVendor && vendorId && !bundleFormData.vendor_id) {
          bundleData.append('vendor_id', vendorId.toString());
        }

        let result;
        if (isEditingBundle && editingBundle) {
          // Update existing bundle
          const bundleId = editingBundle.bundle_id || editingBundle.id;
          bundleData.append('bundle_id', bundleId.toString());

          result = await updateBundle(bundleData).unwrap();
        } else {
          // Create new bundle
          result = await addBundle(bundleData).unwrap();
        }

        setSnackbar({
          open: true,
          message: result.message || result.data?.message || `Bundle ${isEditingBundle ? 'updated' : 'added'} successfully!`,
          severity: 'success'
        });

        handleFormClose();
        refetchBundles();
        refetchBundleCount();
      } else {
        // For single products

        // ✅ Always use tempDeliveryModels when editing (no length > 0 guard)
        // For new product: use formData.delivery_model
        let deliveryModels: number[] = isEditing
          ? [...tempDeliveryModels]
          : (Array.isArray(formData.delivery_model) ? [...formData.delivery_model] : []);

        // If no delivery models selected, use default if available
        if (deliveryModels.length === 0 && defaultDeliveryModel) {
          deliveryModels = [defaultDeliveryModel.id];
        }

        const requestData: any = {
          ...formData,
          delivery_model: deliveryModels,
          ...(selectedImage && { product_main_image: selectedImage }),
          warehouse_id: formData.warehouse_id,
        };

        // Auto-add vendor_id for vendor users if not already set
        if (isVendor && vendorId && !requestData.vendor_id) {
          requestData.vendor_id = vendorId;
        }

        if (isEditing && editingProduct) {
          requestData.product_id = editingProduct.product_id || editingProduct.id;
        }

        let result;
        if (isEditing) {
          result = await updateProduct(requestData as UpdateProductRequest).unwrap();
        } else {
          result = await addProduct(requestData).unwrap();
        }

        // ✅ Save delivery models to junction table
        // EDIT: use known product id directly (backend update route also saves, this is a safety net)
        // ADD:  extract id from API response
        if (productType === 'single' && deliveryModels.length > 0) {
          try {
            const productId = isEditing
              ? (editingProduct?.product_id || editingProduct?.id)
              : (result?.recId || result?.insertId || result?.product_id || result?.id || result?.data?.id);
            if (productId) {
              await updateProductDeliveryModels({
                product_id: productId,
                delivery_model_ids: deliveryModels,
              }).unwrap();
            }
          } catch (err) {
            console.error('Failed to update delivery models:', err);
            setSnackbar({
              open: true,
              message: 'Product saved, but delivery methods could not be updated.',
              severity: 'warning'
            });
          }
        }

        // If warehouse_id is set, also create warehouse stock entry
        if (formData.warehouse_id && formData.product_stock > 0) {
          try {
            const productId = isEditing ?
              (editingProduct?.id || editingProduct?.product_id || 0) :
              (result.id || result.data?.id || result.result?.id);

            if (productId) {
              await addProductWarehouse({
                product_id: productId,
                warehouse_id: formData.warehouse_id,
                available_quantity: formData.product_stock
              }).unwrap();
            }
          } catch (error) {
            console.error('Error adding warehouse stock:', error);
          }
        }

        if (formData.popular_score > 0 && isEditing && editingProduct) {
          try {
            await setPopularProduct({
              product_id: editingProduct.product_id || editingProduct.id || 0,
              score: formData.popular_score
            }).unwrap();
          } catch (error) {
            console.error('Error setting popular score:', error);
          }
        }

        setSnackbar({
          open: true,
          message: result.message || result.data?.message ||
            (isVendor && isEditing
              ? 'Product updated successfully! It has been sent for admin re-approval.'
              : `Product ${isEditing ? 'updated' : 'added'} successfully!`),
          severity: 'success'
        });

        handleFormClose();
        refetch();
        refetchCount();
      }
    } catch (error: any) {
      console.error('Submit error:', error);
      setSnackbar({
        open: true,
        message: error.data?.message || error.message || `Error ${isEditing || isEditingBundle ? 'updating' : 'adding'} ${productType}. Please try again.`,
        severity: 'error'
      });
    } finally {
      setIsFormSubmitting(false);
    }
  };

  const handleDelete = async (productId: string | number) => {
    if (window.confirm('Are you sure you want to delete this product?')) {
      try {
        const result = await deleteProduct({ product_id: Number(productId) }).unwrap();
        setSnackbar({
          open: true,
          message: result.message || 'Product deleted successfully!',
          severity: 'success'
        });
        refetch();
        refetchCount();
      } catch (err: any) {
        const errorMessage = err?.data?.message || err?.message || 'Error deleting product. Please try again.';
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
      }
    }
  };

  const handleDeleteBundle = async (bundleId: string | number) => {
    if (window.confirm('Are you sure you want to delete this bundle?')) {
      try {
        const result = await deleteBundle({
          bundle_id: Number(bundleId)
        }).unwrap();

        setSnackbar({
          open: true,
          message: result.message || result.data?.message || 'Bundle deleted successfully!',
          severity: 'success'
        });

        refetchBundles();
        refetchBundleCount();
      } catch (err: any) {
        const errorMessage = err?.data?.message || err?.message || 'Error deleting bundle. Please try again.';
        setSnackbar({
          open: true,
          message: errorMessage,
          severity: 'error'
        });
      }
    }
  };

  const handleSetPopularProduct = async (product: Product, score: number = 100) => {
    try {
      const result = await setPopularProduct({
        product_id: product.product_id || product.id || 0,
        score
      }).unwrap();

      setSnackbar({
        open: true,
        message: result.message || 'Product marked as popular successfully!',
        severity: 'success'
      });

      refetch();
      if (popularProductsView) {
        refetchPopularProducts();
      }
    } catch (err: any) {
      const errorMessage = err?.data?.message || err?.message || 'Error marking product as popular. Please try again.';
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    } finally {
      setAnchorEl(null);
      setSelectedProduct(null);
      setScoreDialogOpen(false);
    }
  };

  const handleRemovePopularProduct = async (product: Product) => {
    try {
      const result = await removePopularProduct({
        product_id: product.product_id || product.id || 0
      }).unwrap();

      setSnackbar({
        open: true,
        message: result.message || 'Product removed from popular list successfully!',
        severity: 'success'
      });

      refetch();
      if (popularProductsView) {
        refetchPopularProducts();
      }
    } catch (err: any) {
      const errorMessage = err?.data?.message || err?.message || 'Error removing product from popular list. Please try again.';
      setSnackbar({
        open: true,
        message: errorMessage,
        severity: 'error'
      });
    } finally {
      setAnchorEl(null);
      setSelectedProduct(null);
    }
  };

  const handleCodToggleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isEnabled = e.target.checked ? 1 : 0;

    console.log('🔄 Toggling COD to:', isEnabled); // Debug log

    setCodEnabled(isEnabled as 0 | 1);

    // ✅ Update form data with cod_available
    if (productType === 'bundle') {
      setBundleFormData(prev => ({
        ...prev,
        cod_available: isEnabled as 0 | 1
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        cod_available: isEnabled as 0 | 1
      }));
    }
  };


  // COD Charge Handler
  const handleCodChargeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setCodCharge(value);

      if (productType === 'bundle') {
        setBundleFormData(prev => ({
          ...prev,
          cod_charge: value ? parseFloat(value) : 0
        }));
      } else {
        setFormData(prev => ({
          ...prev,
          cod_charge: value ? parseFloat(value) : 0
        }));
      }

      // Clear error
      if (codFormErrors.cod_charge) {
        setCodFormErrors(prev => ({ ...prev, cod_charge: undefined }));
      }
    }
  };

  // Validate COD charge
  const validateCodCharge = () => {
    if (codEnabled === 1 && (!codCharge || parseFloat(codCharge) < 0)) {
      setCodFormErrors({ cod_charge: 'COD charge must be greater than or equal to 0' });
      return false;
    }
    return true;
  };

  const handlePopularMenuOpen = (event: React.MouseEvent<HTMLElement>, product: Product) => {
    setAnchorEl(event.currentTarget);
    setSelectedProduct(product);
  };

  const handlePopularMenuClose = () => {
    setAnchorEl(null);
    setSelectedProduct(null);
  };

  const handleScoreDialogOpen = (product: Product) => {
    setSelectedProduct(product);
    setPopularScore(product.popular_score || 100);
    setScoreDialogOpen(true);
  };

  const handleScoreDialogClose = () => {
    setScoreDialogOpen(false);
    setSelectedProduct(null);
    setPopularScore(100);
  };

  const handleScoreSubmit = () => {
    if (selectedProduct) {
      handleSetPopularProduct(selectedProduct, popularScore);
    }
  };

  const handleTogglePopularView = (checked: boolean) => {
    setPopularProductsView(checked);
    if (checked) {
      setPopularPage(1);
      setPopularSearchStr('');
    } else {
      setPage(1);
      setSearchStr('');
    }
  };

  const handleRefresh = () => {
    if (productType === 'bundle') {
      refetchBundles();
      refetchBundleCount();
    } else {
      refetch();
      refetchCount();
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleAdditionalImagesChange = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = e.target.files;
    if (!files) return;

    if (!editingProduct?.id) {
      toast.error("Product ID is missing. Save product before uploading images.");
      return;
    }

    if (files.length > 10) {
      toast.error("You can upload a maximum of 10 images.");
      return;
    }

    const uploadPromises = [];

    for (let i = 0; i < files.length; i++) {
      const validationError = validateAdditionalMedia(files[i]);
      if (validationError) {
        toast.error(validationError);
        continue;
      }
      const formDataUpload = new FormData();
      formDataUpload.append("product_id", editingProduct.id.toString());
      formDataUpload.append("product_main_image", files[i]);

      uploadPromises.push(
        addAdditionalProductImageMutation(formDataUpload).unwrap()
          .then((res) => {
            toast.success(`Uploaded ${files[i].name}`);
            return res;
          })
          .catch((error) => {
            console.error('Upload error:', error);
            toast.error(error?.data?.message || `Failed to upload ${files[i].name}`);
            return null;
          })
      );
    }

    const results = await Promise.all(uploadPromises);
    const successfulUploads = results.filter(r => r !== null);

    if (successfulUploads.length > 0 && selectedProductId) {
      try {
        await Promise.all([refetchProductDetail(), refetchAdminProductMedia()]);
        toast.success(`Successfully uploaded ${successfulUploads.length} file(s)!`);
      } catch (error) {
        console.error('Failed to refetch product details:', error);
      }
    }

    e.target.value = '';
  };

  useEffect(() => {
    console.log('formData.warehouse_id:', formData.warehouse_id);
  }, [formData.warehouse_id]);

  // Calculate current data based on product type
  const currentData = productType === 'bundle' ? bundles : products;
  const currentIsLoading = productType === 'bundle' ? isLoadingBundles : isLoading;
  const currentIsError = productType === 'bundle' ? isBundlesError : isError;
  const currentError = productType === 'bundle' ? bundlesError : error;
  const currentTotalRecords = productType === 'bundle' ? bundleTotalRecords : totalRecords;
  const currentTotalPages = productType === 'bundle' ? bundleTotalPages : totalPages;

  const isBundleLoading = isAddingBundle || isUpdatingBundle || isDeletingBundle;

  const handleExportVendorProducts = async () => {
    if (isVendor || productType !== 'single') return;
    try {
      const token = localStorage.getItem('admin_token');
      const response = await fetch(`${process.env.REACT_APP_SERVER_ENDPOINT || ''}/admin/export-products`, {
        method: 'POST',
        headers: { Authorization: token ? `Bearer ${token}` : '', authkey: API_CONFIG.AUTH_KEY, 'Content-Type': 'application/json' },
        body: JSON.stringify({
          scope: 'vendor',
          approval_status: approvalFilter,
          category_id: categoryFilter !== 'all' ? Number(categoryFilter) : undefined,
          subcategory_id: subCategoryFilter !== 'all' ? Number(subCategoryFilter) : undefined,
          status: statusFilter !== 'all' && ['0','1','2'].includes(statusFilter) ? Number(statusFilter) : undefined,
          availability: availabilityFilter !== 'all' ? Number(availabilityFilter) : undefined,
          stock_filter: stockFilter,
          discount_filter: discountFilter,
        }),
      });
      if (!response.ok) throw new Error('Unable to export vendor products');
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a'); a.href = url; a.download = 'vendor_products.csv'; a.click();
      window.URL.revokeObjectURL(url);
    } catch (e:any) { setSnackbar({open:true,message:e.message || 'Export failed',severity:'error'}); }
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', bgcolor: '#f1f2f4', overflow: 'hidden' }}>
      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden' }}>
        {/* Desktop sidebar is provided once by App.tsx -> AdminLayout. */}
        {/* Drawer for mobile */}
        <Drawer
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiDrawer-paper': { width: 250 },
          }}
        >
          <Slidemenu onToggle={handleDrawerToggle} mobileOpen={false} />
        </Drawer>

        {/* Main content - FIXED SCROLLING */}
        <Box sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden' // Important: hide overflow at this level
        }}>
          <AdminHeader onToggleMenu={handleDrawerToggle} />

          {/* Scrollable content area with ID for scroll control */}
          <Box
            id="product-list-scroll-container"
            sx={{
              flexGrow: 1,
              overflow: 'auto', // Enable scrolling only here
              backgroundColor: '#f1f2f4',
              position: 'relative',
              '&::-webkit-scrollbar': {
                width: '8px',
                height: '8px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
                borderRadius: '4px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}
          >
            {/* Scroll to top/bottom buttons */}
            {(showScrollTop || showScrollBottom) && (
              <Box sx={{
                position: 'fixed',
                bottom: 24,
                right: 24,
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
                zIndex: 1000,
              }}>
                {showScrollTop && (
                  <Tooltip title="Scroll to top (Home)" placement="left">
                    <IconButton
                      onClick={scrollToTop}
                      sx={{
                        bgcolor: shopifyColors.primary,
                        color: 'white',
                        '&:hover': {
                          bgcolor: shopifyColors.primaryHover,
                        },
                        boxShadow: 3,
                        width: 40,
                        height: 40,
                      }}
                    >
                      <ArrowUpward />
                    </IconButton>
                  </Tooltip>
                )}
                {showScrollBottom && (
                  <Tooltip title="Scroll to bottom (End)" placement="left">
                    <IconButton
                      onClick={scrollToBottom}
                      sx={{
                        bgcolor: shopifyColors.primary,
                        color: 'white',
                        '&:hover': {
                          bgcolor: shopifyColors.primaryHover,
                        },
                        boxShadow: 3,
                        width: 40,
                        height: 40,
                      }}
                    >
                      <ArrowDownward />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            )}

            {/* Mobile floating action button */}
            {isMobile && showScrollTop && (
              <Fab
                color="primary"
                size="medium"
                onClick={scrollToTop}
                sx={{
                  position: 'fixed',
                  bottom: 80,
                  right: 16,
                  zIndex: 1000,
                  bgcolor: shopifyColors.primary,
                  '&:hover': {
                    bgcolor: shopifyColors.primaryHover,
                  },
                }}
              >
                <ArrowUpward />
              </Fab>
            )}

            {/* Main Content Area */}
            <Box sx={{
              maxWidth: 1600,
              mx: 'auto',
              p: { xs: 1, sm: 2, md: 3 },
              width: '100%',
            }}>
              {/* Header Section */}
              <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'column', sm: 'row' },
                justifyContent: 'space-between',
                alignItems: { xs: 'stretch', sm: 'center' },
                mb: 3,
                gap: { xs: 2, sm: 0 }
              }}>
                <Box>
                  <Typography variant="h5" sx={{
                    fontWeight: 600,
                    color: '#202223',
                    fontSize: { xs: '1.25rem', sm: '1.5rem' }
                  }}>
                    {popularProductsView ? 'Popular Products' : `${productType === 'bundle' ? 'Bundles' : 'Products'}`}
                  </Typography>
                  {isVendor && (
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                      <Store fontSize="small" sx={{ color: shopifyColors.textSecondary }} />
                      <Typography variant="body2" sx={{
                        color: shopifyColors.textSecondary,
                        fontWeight: 500,
                        fontSize: { xs: '11px', sm: '12px' }
                      }}>
                        Vendor: {userName} (ID: {vendorId})
                      </Typography>
                    </Box>
                  )}
                </Box>

                <Box sx={{
                  display: 'flex',
                  gap: 1,
                  alignItems: 'center',
                  flexDirection: { xs: 'column', sm: 'row' },
                  width: { xs: '100%', sm: 'auto' }
                }}>
                  {!isVendor && !popularProductsView && productType === 'single' && (
                    <Button variant="outlined" onClick={handleExportVendorProducts} size="small" sx={{textTransform:'none', borderRadius:'6px', width:{xs:'100%',sm:'auto'}}}>
                      Export Vendor Products
                    </Button>
                  )}
                  <Button
                    variant="outlined"
                    startIcon={<Refresh />}
                    onClick={handleRefresh}
                    disabled={currentIsLoading}
                    size="small"
                    sx={{
                      textTransform: 'none',
                      borderColor: shopifyColors.border,
                      color: shopifyColors.textPrimary,
                      borderRadius: '6px',
                      fontWeight: 500,
                      width: { xs: '100%', sm: 'auto' },
                      '&:hover': {
                        borderColor: shopifyColors.textSecondary,
                        bgcolor: 'transparent',
                      }
                    }}
                  >
                    Refresh
                  </Button>

                  {!popularProductsView && (
                    <Button
                      variant="contained"
                      startIcon={<Add />}
                      onClick={productType === 'bundle' ? handleAddBundle : handleAddProduct}
                      size="small"
                      sx={{
                        bgcolor: shopifyColors.primary,
                        color: 'white',
                        textTransform: 'none',
                        fontWeight: 600,
                        borderRadius: '6px',
                        px: 2,
                        width: { xs: '100%', sm: 'auto' },
                        '&:hover': { bgcolor: shopifyColors.primaryHover }
                      }}
                    >
                      Add {productType === 'bundle' ? 'Bundle' : 'Product'}
                    </Button>
                  )}
                </Box>
              </Box>

              {/* Product ownership tabs - admin only */}
              {!isVendor && !popularProductsView && productType === 'single' && (
                <Card sx={{
                  borderRadius: '8px',
                  boxShadow: '0 1px 0 rgba(0, 0, 0, 0.05)',
                  border: `1px solid ${shopifyColors.border}`,
                  mb: 2,
                  overflow: 'hidden',
                }}>
                  <Tabs
                    value={productScope}
                    onChange={handleProductScopeChange}
                    variant={isMobile ? 'fullWidth' : 'standard'}
                    sx={{
                      minHeight: 48,
                      '& .MuiTab-root': {
                        minHeight: 48,
                        textTransform: 'none',
                        fontWeight: 600,
                        px: { xs: 1.5, sm: 3 },
                      },
                    }}
                  >
                    <Tab value="all" label="All - Own Product & Vendor Products" />
                    <Tab value="own" label="Own Product" />
                    <Tab value="vendor" label="Vendor Products" />
                  </Tabs>
                </Card>
              )}

              {/* Search and Filter Bar */}
              <Card sx={{
                borderRadius: '8px',
                boxShadow: '0 1px 0 rgba(0, 0, 0, 0.05)',
                border: `1px solid ${shopifyColors.border}`,
                mb: 2,
                overflow: 'visible',
                width: '100%',
              }}>
                <Box sx={{
                  p: 2,
                  display: 'flex',
                  gap: 2,
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  flexDirection: { xs: 'column', sm: 'row' }
                }}>
                  {/* Search Input with Filter Button */}
                  <Box sx={{
                    display: 'flex',
                    gap: 1,
                    alignItems: 'center',
                    flex: 1,
                    minWidth: { xs: '100%', sm: '300px' }
                  }}>
                    <TextField
                      size="small"
                      placeholder={popularProductsView ? "Search popular products..." : `Search ${productType === 'bundle' ? 'bundles' : 'products'}...`}
                      value={popularProductsView ? popularSearchStr : searchStr}
                      onChange={popularProductsView ? handlePopularSearch : handleSearch}
                      sx={{
                        flex: 1,
                        '& .MuiOutlinedInput-root': {
                          borderRadius: '6px',
                          bgcolor: 'white',
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search fontSize="small" sx={{ color: shopifyColors.textSecondary }} />
                          </InputAdornment>
                        ),
                        endAdornment: searchStr ? (
                          <InputAdornment position="end">
                            <IconButton
                              size="small"
                              onClick={() => setSearchStr('')}
                              edge="end"
                            >
                              <ClearIcon fontSize="small" />
                            </IconButton>
                          </InputAdornment>
                        ) : null,
                      }}
                    />
                  </Box>

                  {!popularProductsView && productType === 'single' && (
                    <>
                      {!isVendor && (
                        <TextField
                          size="small"
                          placeholder="Search vendor (name or ID)..."
                          value={vendorSearchStr}
                          onChange={(e) => { setVendorSearchStr(e.target.value); setPage(1); }}
                          sx={{
                            minWidth: { xs: '100%', sm: 220 },
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '6px',
                              bgcolor: 'white',
                            }
                          }}
                          InputProps={{
                            endAdornment: vendorSearchStr ? (
                              <InputAdornment position="end">
                                <IconButton size="small" onClick={() => { setVendorSearchStr(''); setPage(1); }} edge="end">
                                  <ClearIcon fontSize="small" />
                                </IconButton>
                              </InputAdornment>
                            ) : null,
                          }}
                        />
                      )}
                      <FormControl size="small" sx={{minWidth:{xs:'100%',sm:170}}}>
                        <InputLabel>Category</InputLabel>
                        <Select
                          value={categoryFilter}
                          label="Category"
                          onChange={(e) => handleCategoryFilterChange(String(e.target.value))}
                          MenuProps={{ PaperProps: { style: { maxHeight: 360 } } }}
                        >
                          <MenuItem value="all">All Categories</MenuItem>
                          {filteredCategoriesForDisplay.map((category: any) => (
                            <MenuItem key={category.cat_id || category.id} value={String(category.cat_id || category.id)}>
                              {category.cat_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{minWidth:{xs:'100%',sm:190}}} disabled={categoryFilter === 'all'}>
                        <InputLabel>Sub Category</InputLabel>
                        <Select
                          value={subCategoryFilter}
                          label="Sub Category"
                          onChange={(e) => handleSubCategoryFilterChange(String(e.target.value))}
                          MenuProps={{ PaperProps: { style: { maxHeight: 360 } } }}
                        >
                          <MenuItem value="all">All Sub Categories</MenuItem>
                          {filteredSubCategoriesForFilter.map((subCat: any) => (
                            <MenuItem key={subCat.sub_cat_id || subCat.id} value={String(subCat.sub_cat_id || subCat.id)}>
                              {subCat.sub_cat_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{minWidth:{xs:'100%',sm:145}}}>
                        <InputLabel>Stock</InputLabel><Select value={stockFilter} label="Stock" onChange={e=>{setStockFilter(e.target.value);setPage(1)}}>
                          <MenuItem value="all">All Stock</MenuItem><MenuItem value="in">In Stock</MenuItem><MenuItem value="out">Out of Stock</MenuItem>
                        </Select>
                      </FormControl>
                      <FormControl size="small" sx={{minWidth:{xs:'100%',sm:155}}}>
                        <InputLabel>Discount</InputLabel><Select value={discountFilter} label="Discount" onChange={e=>{setDiscountFilter(e.target.value);setPage(1)}}>
                          <MenuItem value="all">All Discounts</MenuItem><MenuItem value="active">Active Discount</MenuItem><MenuItem value="inactive">No Discount</MenuItem>
                        </Select>
                      </FormControl>
                      {!isVendor && <FormControl size="small" sx={{minWidth:{xs:'100%',sm:155}}}>
                        <InputLabel>Approval</InputLabel><Select value={approvalFilter} label="Approval" onChange={e=>{setApprovalFilter(e.target.value);setPage(1)}}>
                          <MenuItem value="all">All Approval</MenuItem><MenuItem value="pending">Pending</MenuItem><MenuItem value="approved">Approved</MenuItem><MenuItem value="rejected">Rejected</MenuItem><MenuItem value="blocked">Blocked</MenuItem>
                        </Select>
                      </FormControl>}
                      <FormControl size="small" sx={{minWidth:{xs:'100%',sm:165}}}>
                        <InputLabel>Sort</InputLabel><Select value={sortBy} label="Sort" onChange={e=>handleSortChange(e.target.value)}>
                          <MenuItem value="newest">Newest</MenuItem><MenuItem value="oldest">Oldest</MenuItem><MenuItem value="name_asc">Name A–Z</MenuItem><MenuItem value="name_desc">Name Z–A</MenuItem><MenuItem value="price_asc">Price Low–High</MenuItem><MenuItem value="price_desc">Price High–Low</MenuItem><MenuItem value="discount_asc">Discount Low–High</MenuItem><MenuItem value="discount_desc">Discount High–Low</MenuItem><MenuItem value="stock_asc">Stock Low–High</MenuItem><MenuItem value="stock_desc">Stock High–Low</MenuItem>
                        </Select>
                      </FormControl>
                    </>
                  )}

                  {/* Results Summary */}
                  {!currentIsLoading && !currentIsError && (
                    <Typography variant="body2" sx={{
                      color: shopifyColors.textSecondary,
                      ml: { xs: 0, sm: 'auto' },
                      textAlign: { xs: 'center', sm: 'right' },
                      width: { xs: '100%', sm: 'auto' }
                    }}>
                      {isFilterActive ? (
                        `${totalRecords} ${productType === 'bundle' ? 'bundle' : 'product'}${totalRecords === 1 ? '' : 's'} found (Filtered from ${allProducts.length})`
                      ) : searchStr ? (
                        `${totalRecords} ${productType === 'bundle' ? 'bundle' : 'product'}${totalRecords === 1 ? '' : 's'} matching "${searchStr}"`
                      ) : (
                        `${allProducts.length} ${productType === 'bundle' ? 'bundle' : 'product'}${allProducts.length === 1 ? '' : 's'} total`
                      )}
                      {isVendor && ` • Showing only your ${productType === 'bundle' ? 'bundles' : 'products'}`}
                    </Typography>
                  )}
                </Box>
              </Card>

              {/* Loading State */}
              {currentIsLoading && (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: 200,
                  bgcolor: 'white',
                  borderRadius: '8px',
                  border: `1px solid ${shopifyColors.border}`,
                  width: '100%',
                }}>
                  <CircularProgress sx={{ color: shopifyColors.primary }} />
                  <Typography sx={{ ml: 2, color: shopifyColors.textSecondary }}>
                    {popularProductsView ? 'Loading popular products...' : `Loading ${productType === 'bundle' ? 'bundles' : 'products'}...`}
                  </Typography>
                </Box>
              )}

              {/* Error State */}
              {currentIsError && !currentIsLoading && (
                <Alert
                  severity="error"
                  sx={{
                    mb: 2,
                    borderRadius: '8px',
                    border: `1px solid ${shopifyColors.border}`,
                    width: '100%',
                  }}
                  action={
                    <IconButton color="inherit" size="small" onClick={handleRefresh}>
                      <Refresh />
                    </IconButton>
                  }
                >
                  {popularProductsView ?
                    'Failed to load popular products' :
                    (productType === 'bundle' ? 'Failed to load bundles' : 'Failed to load products')
                  }
                </Alert>
              )}

              {/* Empty State */}
              {!currentIsLoading &&
                !currentIsError &&
                currentData.length === 0 && (
                  <Box sx={{
                    textAlign: 'center',
                    py: 8,
                    bgcolor: 'white',
                    borderRadius: '8px',
                    border: `1px solid ${shopifyColors.border}`,
                    width: '100%',
                  }}>
                    <Typography variant="h6" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, mb: 1 }}>
                      {popularProductsView ?
                        (popularSearchStr ? 'No popular products found' : 'No popular products available') :
                        (searchStr || isFilterActive ? `No ${productType === 'bundle' ? 'bundles' : 'products'} found` : `No ${productType === 'bundle' ? 'bundles' : 'products'} available`)
                      }
                    </Typography>
                    <Typography variant="body2" sx={{ color: shopifyColors.textSecondary, mb: 3 }}>
                      {popularProductsView ?
                        (popularSearchStr ?
                          `No popular products match your search "${popularSearchStr}"` :
                          'Mark products as popular to see them here') :
                        (searchStr ?
                          `No ${productType === 'bundle' ? 'bundles' : 'products'} match your search "${searchStr}"` :
                          isFilterActive ?
                            `No ${productType === 'bundle' ? 'bundles' : 'products'} match your filters` :
                            `Get started by adding your first ${productType === 'bundle' ? 'bundle' : 'product'}`
                        )
                      }
                    </Typography>
                    {!popularProductsView && !searchStr && !isFilterActive && (
                      <Button
                        variant="contained"
                        startIcon={<Add />}
                        onClick={productType === 'bundle' ? handleAddBundle : handleAddProduct}
                        sx={{
                          bgcolor: shopifyColors.primary,
                          color: 'white',
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: '6px',
                          '&:hover': { bgcolor: shopifyColors.primaryHover }
                        }}
                      >
                        Add First {productType === 'bundle' ? 'Bundle' : 'Product'}
                      </Button>
                    )}
                    {(searchStr || isFilterActive) && (
                      <Button
                        variant="outlined"
                        startIcon={<ClearIcon />}
                        onClick={handleClearFilters}
                        sx={{
                          textTransform: 'none',
                          fontWeight: 600,
                          borderRadius: '6px',
                          mt: 1,
                          '&:hover': {
                            borderColor: shopifyColors.textSecondary,
                          }
                        }}
                      >
                        Clear Search & Filters
                      </Button>
                    )}
                  </Box>
                )}

              {/* Products Table - UPDATED WITH OPEN BOX COLUMN */}
              {!currentIsLoading && currentData.length > 0 && (
                <Card sx={{
                  borderRadius: '8px',
                  boxShadow: '0 1px 0 rgba(0, 0, 0, 0.05)',
                  border: `1px solid ${shopifyColors.border}`,
                  overflow: 'hidden',
                  width: '100%',
                  position: 'relative',
                }}>
                  {/* Top mirror scrollbar + arrows — desktop only */}
                  {!isMobile && (
                    <Box sx={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e0e0e0' }}>
                      <IconButton
                        onClick={handleScrollLeft}
                        size="small"
                        disabled={!canScrollLeft}
                        sx={{
                          flexShrink: 0, width: 28, height: 28, borderRadius: 0,
                          bgcolor: '#f5f5f5', border: '1px solid #c0c0c0', borderRight: 'none',
                          color: canScrollLeft ? '#444' : '#bbb',
                          '&:hover:not(:disabled)': { bgcolor: '#e0e0e0' },
                        }}
                      >
                        <ChevronLeft sx={{ fontSize: 18 }} />
                      </IconButton>

                      <Box
                        ref={setTopScrollRef}
                        sx={{
                          flex: 1, overflowX: 'scroll', overflowY: 'hidden', height: 14,
                          '&::-webkit-scrollbar': { height: 14 },
                          '&::-webkit-scrollbar-track': { bgcolor: '#f5f5f5' },
                          '&::-webkit-scrollbar-thumb': {
                            bgcolor: '#aaa', borderRadius: 2, border: '2px solid #f5f5f5',
                          },
                          '&::-webkit-scrollbar-thumb:hover': { bgcolor: '#888' },
                        }}
                      >
                        <Box ref={setTopScrollInnerRef} sx={{ height: 1, width: '100%' }} />
                      </Box>

                      <IconButton
                        onClick={handleScrollRight}
                        size="small"
                        disabled={!canScrollRight}
                        sx={{
                          flexShrink: 0, width: 28, height: 28, borderRadius: 0,
                          bgcolor: '#f5f5f5', border: '1px solid #c0c0c0', borderLeft: 'none',
                          color: canScrollRight ? '#444' : '#bbb',
                          '&:hover:not(:disabled)': { bgcolor: '#e0e0e0' },
                        }}
                      >
                        <ChevronRight sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Box>
                  )}

                  <ResponsiveTableContainer ref={setTableScrollRef}>
                    <Box
                      sx={{
                        minWidth: '1200px',
                        width: '100%',
                        display: 'inline-block',
                      }}
                    >
                      {/* Table Header */}
                      <Box sx={{
                        display: 'grid',
                        gridTemplateColumns: productType === 'bundle'
                          ? isMobile
                            ? '60px 120px 100px minmax(200px, 1fr)'
                            : '60px 120px 100px minmax(200px, 1fr) 120px 120px 120px 100px 100px 120px 150px'
                          : isMobile
                            ? '60px 120px 100px minmax(200px, 1fr)'
                            : '60px 120px 100px minmax(200px, 1fr) 120px 120px 120px 100px 100px 120px 120px 120px 120px 150px',
                        gap: { xs: 1, md: 2 },
                        px: { xs: 1.5, md: 3 },
                        py: 2,
                        borderBottom: `1px solid ${shopifyColors.border}`,
                        bgcolor: '#fafbfb',
                        width: '100%',
                      }}>
                        {/* Column Headers */}
                        <Typography variant="caption" sx={{
                          color: shopifyColors.textSecondary,
                          fontWeight: 600,
                          fontSize: { xs: '10px', md: '11px' },
                          textTransform: 'uppercase',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                          Product No
                        </Typography>

                        <Typography variant="caption" sx={{
                          color: shopifyColors.textSecondary,
                          fontWeight: 600,
                          fontSize: { xs: '10px', md: '11px' },
                          textTransform: 'uppercase',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                          Actions
                        </Typography>

                        <Typography variant="caption" sx={{
                          color: shopifyColors.textSecondary,
                          fontWeight: 600,
                          fontSize: { xs: '10px', md: '11px' },
                          textTransform: 'uppercase',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                          Image
                        </Typography>

                        <Typography variant="caption" sx={{
                          color: shopifyColors.textSecondary,
                          fontWeight: 600,
                          fontSize: { xs: '10px', md: '11px' },
                          textTransform: 'uppercase',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}>
                          Name
                        </Typography>

                        {/* Desktop-only columns */}
                        {!isMobile && (
                          <>
                            <Typography variant="caption" sx={{
                              color: shopifyColors.textSecondary,
                              fontWeight: 600,
                              fontSize: { xs: '10px', md: '11px' },
                              textTransform: 'uppercase',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                              Category
                            </Typography>

                            <Typography variant="caption" sx={{
                              color: shopifyColors.textSecondary,
                              fontWeight: 600,
                              fontSize: { xs: '10px', md: '11px' },
                              textTransform: 'uppercase',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                              Discount Price
                            </Typography>

                            <Typography variant="caption" sx={{
                              color: shopifyColors.textSecondary,
                              fontWeight: 600,
                              fontSize: { xs: '10px', md: '11px' },
                              textTransform: 'uppercase',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                              Availability
                            </Typography>

                            <Typography variant="caption" sx={{
                              color: shopifyColors.textSecondary,
                              fontWeight: 600,
                              fontSize: { xs: '10px', md: '11px' },
                              textTransform: 'uppercase',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                              Status
                            </Typography>

                            {productType === 'single' && (
                              <Typography variant="caption" sx={{
                                color: shopifyColors.textSecondary,
                                fontWeight: 600,
                                fontSize: { xs: '10px', md: '11px' },
                                textTransform: 'uppercase',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}>
                                Tax
                              </Typography>
                            )}

                            {productType === 'single' && (
                              <Typography variant="caption" sx={{
                                color: shopifyColors.textSecondary,
                                fontWeight: 600,
                                fontSize: { xs: '10px', md: '11px' },
                                textTransform: 'uppercase',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}>
                                Reward
                              </Typography>
                            )}

                            {/* COD Column Header */}
                            <Typography variant="caption" sx={{
                              color: shopifyColors.textSecondary,
                              fontWeight: 600,
                              fontSize: { xs: '10px', md: '11px' },
                              textTransform: 'uppercase',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}>
                              COD
                            </Typography>

                            {productType === 'bundle' && (
                              <Typography variant="caption" sx={{
                                color: shopifyColors.textSecondary,
                                fontWeight: 600,
                                fontSize: { xs: '10px', md: '11px' },
                                textTransform: 'uppercase',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}>
                                Products
                              </Typography>
                            )}
                          </>
                        )}
                      </Box>

                      {/* Table Rows */}
                      <Box sx={{ bgcolor: 'white' }}>
                        {currentData.map((item: any, index: number) => {
                          const categoryName = categories.find(
                            (cat: any) => (cat.cat_id || cat.id) === item.cat_id
                          )?.cat_name || 'N/A';

                          return (
                            <Box
                              key={item.id || item.bundle_id || item.product_id || index}
                              sx={{
                                display: 'grid',
                                gridTemplateColumns: productType === 'bundle'
                                  ? isMobile
                                    ? '60px 120px 100px minmax(200px, 1fr)'
                                    : '60px 120px 100px minmax(200px, 1fr) 120px 120px 120px 100px 100px 120px 150px'
                                  : isMobile
                                    ? '60px 120px 100px minmax(200px, 1fr)'
                                    : '60px 120px 100px minmax(200px, 1fr) 120px 120px 120px 100px 100px 120px 120px 120px 120px 150px',
                                gap: { xs: 1, md: 2 },
                                px: { xs: 1.5, md: 3 },
                                py: { xs: 1.5, md: 2.5 },
                                alignItems: 'center',
                                borderBottom: index < currentData.length - 1 ? `1px solid ${shopifyColors.border}` : 'none',
                                '&:hover': { bgcolor: '#f9fafb' },
                                transition: 'background-color 0.15s ease',
                                width: '100%',
                              }}
                            >
                              {/* Product Number */}
                              <Typography variant="body2" sx={{
                                color: shopifyColors.textSecondary,
                                fontSize: { xs: '12px', md: '13px' },
                                textAlign: 'center', fontWeight: 600,
                              }}>
                                {productType === 'bundle' ? (item.id || item.bundle_id || '-') : (item.id || item.product_id || '-')}
                              </Typography>

                              {/* Actions with Tooltips */}
                              <Box sx={{
                                display: 'flex',
                                gap: 0.5,
                                justifyContent: 'flex-start',
                                flexWrap: 'wrap',
                              }}>
                                {/* Mobile: Show simplified actions */}
                                {isMobile ? (
                                  <>
                                    {isVendor && productType === 'single' && String((item as any).approval_status || '').toLowerCase() === 'rejected' && (
                                      <Button size="small" variant="outlined" onClick={() => handleResubmitProduct(item)} sx={{ minWidth: 0, px: 1, textTransform: 'none' }}>Resubmit</Button>
                                    )}
                                    <IconButton
                                      size="small"
                                      onClick={() => productType === 'bundle' ? handleDeleteBundle(item.bundle_id ?? item.id ?? 0) : handleDelete(item.product_id ?? item.id ?? 0)}
                                      disabled={isDeleting || isBundleLoading || (isVendor && !isOwnVendorProduct(item))}
                                      sx={{
                                        width: 30, height: 30, borderRadius: '6px',
                                        border: `1.5px solid ${shopifyColors.error}`,
                                        color: shopifyColors.error,
                                        '&:hover': { bgcolor: shopifyColors.error, color: '#fff' },
                                        transition: 'all 0.15s ease',
                                      }}
                                    >
                                      <Delete fontSize="small" />
                                    </IconButton>
                                    <IconButton
                                      size="small"
                                      onClick={() => productType === 'bundle' ? handleEditBundle(item) : handleEditProduct(item)}
                                      disabled={isVendor && !isOwnVendorProduct(item)}
                                      sx={{
                                        width: 30, height: 30, borderRadius: '6px',
                                        border: '1.5px solid #1976d2',
                                        color: '#1976d2',
                                        '&:hover': { bgcolor: '#1976d2', color: '#fff' },
                                        transition: 'all 0.15s ease',
                                      }}
                                    >
                                      <Edit fontSize="small" />
                                    </IconButton>
                                  </>
                                ) : (
                                  // Desktop: Show all action buttons
                                  <>
                                    {isVendor && productType === 'single' && String((item as any).approval_status || '').toLowerCase() === 'rejected' && (
                                      <Button size="small" variant="outlined" onClick={() => handleResubmitProduct(item)} sx={{ textTransform: 'none', fontSize: '11px' }}>Resubmit</Button>
                                    )}
                                    {productType === 'single' && (
                                      <>
                                        <>
                                        {/* Open Box Button — available to the product owner, including vendors */}
                                        <Tooltip title="Open Box Delivery" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenOpenBoxDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: `1.5px solid ${item.open_box_delivery === 1 ? shopifyColors.openBox : shopifyColors.textSecondary}`,
                                              color: item.open_box_delivery === 1 ? shopifyColors.openBox : shopifyColors.textSecondary,
                                              '&:hover': {
                                                bgcolor: item.open_box_delivery === 1 ? shopifyColors.openBox : shopifyColors.textSecondary,
                                                color: '#fff',
                                              },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <Inventory fontSize="small" />
                                          </IconButton>
                                        </Tooltip>

                                        <Tooltip title="Bulk Order" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenBulkOrderDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: `1.5px solid ${item.bulkorder === 1 ? '#1976d2' : shopifyColors.textSecondary}`,
                                              color: item.bulkorder === 1 ? '#1976d2' : shopifyColors.textSecondary,
                                              '&:hover': {
                                                bgcolor: item.bulkorder === 1 ? '#1976d2' : shopifyColors.textSecondary,
                                                color: '#fff',
                                              },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <ShoppingBasket fontSize="small" />
                                          </IconButton>
                                        </Tooltip>

                                        {/* Warranty Button */}
                                        <Tooltip title="Warranty" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenWarrantyDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: `1.5px solid ${shopifyColors.blue}`,
                                              color: shopifyColors.blue,
                                              '&:hover': { bgcolor: shopifyColors.blue, color: '#fff' },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <Shield fontSize="small" />
                                          </IconButton>
                                        </Tooltip>

                                        {/* Reward Button — admin only */}
                                        {!isVendor && <Tooltip title="Reward Points" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenRewardDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: `1.5px solid ${item.is_reward === 1 ? shopifyColors.pink : shopifyColors.textSecondary}`,
                                              color: item.is_reward === 1 ? shopifyColors.pink : shopifyColors.textSecondary,
                                              '&:hover': {
                                                bgcolor: item.is_reward === 1 ? shopifyColors.pink : shopifyColors.textSecondary,
                                                color: '#fff',
                                              },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <CardGiftcard fontSize="small" />
                                          </IconButton>
                                        </Tooltip>}

                                        {/* Return Limit Button — available to the product owner, including vendors */}
                                        <Tooltip title="Return Limit" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenReturnLimitDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: '1.5px solid #006fbb',
                                              color: '#006fbb',
                                              '&:hover': { bgcolor: '#006fbb', color: '#fff' },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <AssignmentReturn fontSize="small" />
                                          </IconButton>
                                        </Tooltip>

                                        </>

                                        {/* Warehouse Stocks Button */}
                                        <Tooltip title="Warehouse Stocks" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenWarehouseStockDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: `1.5px solid ${shopifyColors.primary}`,
                                              color: shopifyColors.primary,
                                              '&:hover': { bgcolor: shopifyColors.primary, color: '#fff' },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <Inventory2 fontSize="small" />
                                          </IconButton>
                                        </Tooltip>

                                        {/* Flash Sale Button - admin only */}
                                        {!isVendor && <Tooltip title="Flash Sale" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenFlashSaleDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: '1.5px solid #ff6f00',
                                              color: '#ff6f00',
                                              '&:hover': { bgcolor: '#ff6f00', color: '#fff' },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <LocalOffer fontSize="small" />
                                          </IconButton>
                                        </Tooltip>}

                                        {/* Deal of the Day is an admin campaign control and is never shown to vendors. */}
                                        {!isVendor && <Tooltip title="Deal of the Day" arrow>
                                          <IconButton
                                            size="small"
                                            onClick={() => handleOpenDealDialog(item)}
                                            sx={{
                                              width: 30, height: 30, borderRadius: '6px',
                                              border: '1.5px solid #d32f2f',
                                              color: '#d32f2f',
                                              '&:hover': { bgcolor: '#d32f2f', color: '#fff' },
                                              transition: 'all 0.15s ease',
                                            }}
                                          >
                                            <Whatshot fontSize="small" />
                                          </IconButton>
                                        </Tooltip>}
                                      </>
                                    )}

                                    {/* Delete Button */}
                                    <Tooltip title="Delete" arrow>
                                      <IconButton
                                        size="small"
                                        onClick={() => productType === 'bundle' ? handleDeleteBundle(item.bundle_id ?? item.id ?? 0) : handleDelete(item.product_id ?? item.id ?? 0)}
                                        disabled={isDeleting || isBundleLoading || (isVendor && !isOwnVendorProduct(item))}
                                        sx={{
                                          width: 30, height: 30, borderRadius: '6px',
                                          border: `1.5px solid ${shopifyColors.error}`,
                                          color: shopifyColors.error,
                                          '&:hover': { bgcolor: shopifyColors.error, color: '#fff' },
                                          transition: 'all 0.15s ease',
                                        }}
                                      >
                                        <Delete fontSize="small" />
                                      </IconButton>
                                    </Tooltip>

                                    {/* Edit Button */}
                                    <Tooltip title="Edit" arrow>
                                      <IconButton
                                        size="small"
                                        onClick={() => {
                                          if (productType === 'bundle') {
                                            handleEditBundle(item as Bundle);
                                          } else {
                                            handleEditProduct(item as Product);
                                          }
                                        }}
                                        disabled={isVendor && !isOwnVendorProduct(item)}
                                        sx={{
                                          width: 30, height: 30, borderRadius: '6px',
                                          border: '1.5px solid #1976d2',
                                          color: '#1976d2',
                                          '&:hover': { bgcolor: '#1976d2', color: '#fff' },
                                          transition: 'all 0.15s ease',
                                        }}
                                      >
                                        <Edit fontSize="small" />
                                      </IconButton>
                                    </Tooltip>
                                  </>
                                )}
                              </Box>
                              {/* Image */}
                              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                <Avatar
                                  src={`https://fftestservice.sarsetech.com/images/${item.product_main_image || item.bundle_main_image || ''}` || undefined}
                                  variant="rounded"
                                  sx={{
                                    width: { xs: 40, md: 48 },
                                    height: { xs: 40, md: 48 },
                                    bgcolor: '#f1f2f4',
                                    borderRadius: '6px'
                                  }}
                                >
                                  {productType === 'bundle'
                                    ? (item.bundle_short_name?.[0] || item.bundle_name?.[0] || 'B')
                                    : (item.prod_short_name?.[0] || item.prod_name?.[0] || 'P')
                                  }
                                </Avatar>
                              </Box>

                              {/* Name and Details */}
                              <Box sx={{ minWidth: 0 }}>
                                <Typography variant="body2" sx={{
                                  fontWeight: 600,
                                  color: shopifyColors.textPrimary,
                                  fontSize: { xs: '13px', md: '14px' },
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                }}>
                                  {productType === 'bundle' ? item.bundle_name : item.prod_name || 'N/A'}
                                </Typography>
                                <Typography variant="caption" sx={{
                                  color: shopifyColors.textSecondary,
                                  fontSize: { xs: '11px', md: '12px' },
                                  overflow: 'hidden',
                                  textOverflow: 'ellipsis',
                                  whiteSpace: 'nowrap',
                                  display: 'block',
                                }}>
                                  {productType === 'bundle' ? item.bundle_short_name : item.prod_short_name || 'N/A'}
                                </Typography>

                                {isVendor && productType === 'single' && (
                                  <Box sx={{ mt: 0.5 }}>
                                    {renderApprovalStatus((item as Product).approval_status)}
                                  </Box>
                                )}

                                {/* Mobile View: Show condensed info */}
                                {isMobile && (
                                  <Box sx={{ mt: 0.5 }}>
                                    <Typography variant="caption" sx={{
                                      color: shopifyColors.textSecondary,
                                      fontSize: '10px',
                                      display: 'block',
                                    }}>
                                      {formatCurrencyAED(
                                        productType === 'bundle' ? (item.bundle_retail_price || 0) : (item.product_retail_price || 0),
                                        item.currency || 'AED'
                                      )}
                                    </Typography>
                                    {renderStockStatus(item)}
                                  </Box>
                                )}

                                {!isVendor && item.vendor_name && !isMobile && (
                                  <Typography variant="caption" sx={{
                                    color: shopifyColors.textSecondary,
                                    fontSize: '11px',
                                    display: 'block',
                                    mt: 0.5
                                  }}>
                                    Vendor: {item.vendor_name}
                                  </Typography>
                                )}
                              </Box>

                              {/* Desktop-only columns */}
                              {!isMobile && (
                                <>
                                  {/* Category Column */}
                                  <Box>
                                    <Chip
                                      label={getCategoryName(item.cat_id)}
                                      size="small"
                                      sx={{
                                        bgcolor: '#e6f6fc',
                                        color: '#006fbb',
                                        fontWeight: 500,
                                        fontSize: '11px',
                                        borderRadius: '6px',
                                        maxWidth: '100%',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                      }}
                                    />
                                  </Box>

                                  {/* Retail Price */}
                                  <Box>
                                    <Typography variant="body2" sx={{
                                      fontWeight: 600,
                                      color: shopifyColors.textPrimary,
                                      fontSize: '13px'
                                    }}>
                                      {formatCurrencyAED(
                                        productType === 'bundle' ? (item.bundle_retail_price || 0) : (item.product_retail_price || 0),
                                        item.currency || 'AED'
                                      )}
                                    </Typography>
                                    {(item.product_discount > 0 || item.bundle_discount > 0) && (
                                      <Typography variant="caption" sx={{ color: shopifyColors.error, fontSize: '11px' }}>
                                        -{productType === 'bundle' ? item.bundle_discount : item.product_discount}%
                                      </Typography>
                                    )}
                                  </Box>

                                  {/* Stock: show one authoritative stock badge only. */}
                                  <Box>
                                    {renderStockStatus(item)}
                                  </Box>

                                  {/* Status */}
                                  <Box>
                                    {renderStatus(item.status ?? 1)}
                                  </Box>

                                  {/* Tax Column */}
                                  {productType === 'single' && (
                                    <Box>
                                      {renderTaxInfo(item)}
                                    </Box>
                                  )}

                                  {/* Reward Column */}
                                  {productType === 'single' && (
                                    <Box>
                                      {renderRewardStatus(item)}
                                    </Box>
                                  )}

                                  {/* COD Column */}
                                  {productType === 'single' && (
                                    <Box>
                                      {item.cod_available === 1 ? (
                                        <Chip
                                          label="Enabled"
                                          size="small"
                                          sx={{
                                            bgcolor: '#d1f4e0',
                                            color: '#00783e',
                                            fontWeight: 500,
                                            fontSize: '11px',
                                            borderRadius: '6px'
                                          }}
                                        />
                                      ) : (
                                        <Chip
                                          label="Disabled"
                                          size="small"
                                          sx={{
                                            bgcolor: '#e4e5e7',
                                            color: '#616161',
                                            fontWeight: 500,
                                            fontSize: '11px',
                                            borderRadius: '6px'
                                          }}
                                        />
                                      )}
                                    </Box>
                                  )}

                                  {/* Bundle Products Count */}
                                  {productType === 'bundle' && (
                                    <Chip
                                      label={`${item.products?.length || 0} products`}
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        borderColor: shopifyColors.border,
                                        color: shopifyColors.textSecondary,
                                        fontWeight: 500,
                                        fontSize: '11px',
                                        borderRadius: '6px'
                                      }}
                                    />
                                  )}
                                </>
                              )}

                            </Box>
                          );
                        })}
                      </Box>
                    </Box>
                  </ResponsiveTableContainer>
                </Card>
              )}

              {/* Pagination */}
              {currentTotalPages > 1 && !currentIsLoading && (
                <Box sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mt: 3,
                  width: '100%',
                }}>
                  <Pagination
                    count={currentTotalPages}
                    page={page}
                    onChange={handleChangePage}
                    sx={{
                      '& .MuiPaginationItem-root': {
                        borderRadius: '6px',
                        fontWeight: 500,
                        fontSize: '13px',
                      },
                      '& .Mui-selected': {
                        bgcolor: shopifyColors.primary + ' !important',
                        color: 'white',
                      },
                      '& .MuiPaginationItem-root:hover': {
                        bgcolor: '#f1f2f4',
                      }
                    }}
                  />
                </Box>
              )}
            </Box>
          </Box>
        </Box>
      </Box>

      {/* All your dialog components remain the same... */}
      {/* Product Tax Dialog */}
      <Dialog
        open={productTaxDialogOpen}
        onClose={handleCloseProductTaxDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Receipt sx={{ color: '#9c27b0' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Manage Product Tax
            </Typography>
          </Box>

        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            {selectedProductForTax && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForTax.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForTax.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForTax.prod_short_name?.[0] || selectedProductForTax.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForTax.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Product ID: {selectedProductForTax.id || selectedProductForTax.product_id}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <TextField
              label="Tax Percentage"
              value={productTaxPercentage}
              onChange={(e) => {
                const value = e.target.value;
                if (value === '' || /^\d+(\.\d{1,2})?$/.test(value)) {
                  setProductTaxPercentage(value);
                }
              }}
              fullWidth
              helperText="Enter tax percentage (e.g., 5, 18, 20)"
              InputProps={{
                endAdornment: <InputAdornment position="end">%</InputAdornment>,
              }}
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                }
              }}
            />

            <TextField
              label="Currency"
              value={productTaxCurrency}
              onChange={(e) => setProductTaxCurrency(e.target.value)}
              select
              fullWidth
              helperText="Select currency for tax calculation"
              sx={{
                '& .MuiOutlinedInput-root': {
                  borderRadius: '6px',
                }
              }}
            >
              <MenuItem value="AED">AED (د.إ)</MenuItem>
              <MenuItem value="USD">USD ($)</MenuItem>
              <MenuItem value="EUR">EUR (€)</MenuItem>
              <MenuItem value="GBP">GBP (£)</MenuItem>
              <MenuItem value="INR">INR (₹)</MenuItem>
            </TextField>

            <Alert severity="info" sx={{ borderRadius: '6px' }}>
              <Typography variant="body2">
                <strong>Note:</strong> This tax setting will override the global tax settings
                for this specific product only. If no product-specific tax is set,
                the global tax settings will be used.
              </Typography>
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseProductTaxDialog}
            disabled={isSettingProductTax}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseProductTaxDialog}
            disabled={isSettingProductTax}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveProductTax}
            variant="contained"
            disabled={isSettingProductTax || !selectedProductForTax || !productTaxPercentage}
            startIcon={isSettingProductTax ? <CircularProgress size={20} /> : <Save />}
            sx={{
              bgcolor: '#9c27b0',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#7b1fa2' }
            }}
          >
            {isSettingProductTax ? 'Saving...' : 'Save Tax Settings'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Warranty Dialog */}
      <Dialog
        open={warrantyDialogOpen}
        onClose={handleCloseWarrantyDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          },
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Shield sx={{ color: shopifyColors.blue }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Manage Warranties
              {selectedProductForWarranty && (
                <Typography
                  variant="caption"
                  display="block"
                  sx={{ color: shopifyColors.textSecondary, fontWeight: 500 }}
                >
                  Product: {selectedProductForWarranty.prod_name}
                </Typography>
              )}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ mt: 2 }}>
            {selectedProductForWarranty && (
              <>
                {/* ── Product info card ────────────────────────────────── */}
                <Box
                  sx={{
                    p: 2,
                    bgcolor: '#fafbfb',
                    borderRadius: '6px',
                    border: `1px solid ${shopifyColors.border}`,
                    mb: 3,
                  }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    <Avatar
                      src={
                        selectedProductForWarranty.product_main_image
                          ? `https://fftestservice.sarsetech.com/images/${selectedProductForWarranty.product_main_image}`
                          : undefined
                      }
                      variant="rounded"
                      sx={{ width: 60, height: 60, borderRadius: '6px' }}
                    >
                      {selectedProductForWarranty.prod_short_name?.[0] ||
                        selectedProductForWarranty.prod_name?.[0] ||
                        'P'}
                    </Avatar>
                    <Box>
                      <Typography
                        variant="h6"
                        sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}
                      >
                        {selectedProductForWarranty.prod_name}
                      </Typography>
                      <Typography variant="body2" sx={{ color: shopifyColors.textSecondary }}>
                        Product ID:{' '}
                        {selectedProductForWarranty.product_id ||
                          selectedProductForWarranty.id}
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* ── Already-linked warranties ─────────────────────────── */}
                {isWarrantiesLoading ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <CircularProgress size={18} />
                    <Typography variant="body2" sx={{ color: shopifyColors.textSecondary }}>
                      Loading linked warranties…
                    </Typography>
                  </Box>
                ) : warranties.length > 0 ? (
                  <Box sx={{ mb: 3 }}>
                    <Typography
                      variant="subtitle2"
                      sx={{ fontWeight: 600, mb: 1, color: shopifyColors.textPrimary }}
                    >
                      Currently Linked Warranties ({warranties.length})
                    </Typography>
                    <Card
                      sx={{ border: `1px solid ${shopifyColors.border}`, borderRadius: '6px' }}
                    >
                      <List>
                        {warranties.map((warranty: Warranty, index: number) => (
                          <ListItem
                            key={warranty.id}
                            sx={{
                              borderBottom:
                                index < warranties.length - 1
                                  ? `1px solid ${shopifyColors.border}`
                                  : 'none',
                              '&:hover': { bgcolor: '#fafbfb' },
                              py: 1.5,
                            }}
                          >
                            <ListItemIcon>
                              <Shield sx={{ color: shopifyColors.blue, fontSize: 20 }} />
                            </ListItemIcon>
                            <ListItemText
                              primary={
                                <Box
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    flexWrap: 'wrap',
                                    mb: 0.5,
                                  }}
                                >
                                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {warranty.warranty_name}
                                  </Typography>
                                  <Chip
                                    label={`${warranty.no_of_period} ${warranty.warranty_period}${warranty.no_of_period > 1 ? 's' : ''}`}
                                    size="small"
                                    sx={{
                                      bgcolor: shopifyColors.blue,
                                      color: '#fff',
                                      fontWeight: 500,
                                      fontSize: '11px',
                                    }}
                                  />
                                  {(warranty.price ?? 0) > 0 && (
                                    <Chip
                                      label={`AED ${warranty.price}`}
                                      size="small"
                                      variant="outlined"
                                      sx={{
                                        borderColor: shopifyColors.primary,
                                        color: shopifyColors.primary,
                                        fontSize: '11px',
                                      }}
                                    />
                                  )}
                                </Box>
                              }
                              secondary={
                                <Typography
                                  variant="caption"
                                  sx={{ color: shopifyColors.textSecondary }}
                                >
                                  {warranty.description}
                                </Typography>
                              }
                            />
                            <Tooltip title="Remove this warranty from product">
                              <IconButton
                                size="small"
                                color="error"
                                onClick={() => handleDeleteWarranty(warranty.id)}
                                disabled={isDeletingWarranty}
                              >
                                <Delete fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </ListItem>
                        ))}
                      </List>
                    </Card>
                  </Box>
                ) : (
                  <Alert severity="info" sx={{ borderRadius: '6px', mb: 3 }}>
                    <Typography variant="body2">
                      No warranties linked to this product yet. Select from the list below.
                    </Typography>
                  </Alert>
                )}

                <Divider sx={{ my: 2 }} />

                {/* ── Select from global warranty pool ─────────────────── */}
                <Typography
                  variant="subtitle2"
                  sx={{ fontWeight: 600, mb: 0.5, color: shopifyColors.textPrimary }}
                >
                  Link Warranties to This Product
                </Typography>
                <Typography
                  variant="caption"
                  sx={{ color: shopifyColors.textSecondary, display: 'block', mb: 2 }}
                >
                  Choose from warranties created in{' '}
                  <strong>Master → Extended Warranty</strong>. To add new warranty
                  types, go there first.
                </Typography>

                {isLoadingAllWarranties ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={18} />
                    <Typography variant="body2" sx={{ color: shopifyColors.textSecondary }}>
                      Loading available warranties…
                    </Typography>
                  </Box>
                ) : allWarranties.length === 0 ? (
                  <Alert severity="warning" sx={{ borderRadius: '6px' }}>
                    <Typography variant="body2">
                      No warranties found. Please create warranties in{' '}
                      <strong>Master → Extended Warranty</strong> first.
                    </Typography>
                  </Alert>
                ) : (
                  <Card
                    sx={{ border: `1px solid ${shopifyColors.border}`, borderRadius: '6px' }}
                  >
                    <List sx={{ maxHeight: 320, overflowY: 'auto' }}>
                      {allWarranties.map((warranty: Warranty, index: number) => {
                        // A warranty is "already linked" if it exists in the
                        // product's warranty list (matched by warranty_name + period
                        // because linking creates a new row with same data).
                        const alreadyLinked = warranties.some(
                          (w: Warranty) =>
                            w.warranty_name === warranty.warranty_name &&
                            w.warranty_period === warranty.warranty_period &&
                            w.no_of_period === warranty.no_of_period
                        );
                        const isChecked =
                          alreadyLinked || selectedWarrantyIds.includes(warranty.id);

                        return (
                          <ListItem
                            key={warranty.id}
                            disablePadding
                            sx={{
                              borderBottom:
                                index < allWarranties.length - 1
                                  ? `1px solid ${shopifyColors.border}`
                                  : 'none',
                            }}
                          >
                            <ListItemButton
                              onClick={() => {
                                if (alreadyLinked) return; // cannot uncheck already-linked (use delete above)
                                setSelectedWarrantyIds((prev) =>
                                  prev.includes(warranty.id)
                                    ? prev.filter((id) => id !== warranty.id)
                                    : [...prev, warranty.id]
                                );
                              }}
                              disabled={alreadyLinked}
                              sx={{
                                py: 1.5,
                                opacity: alreadyLinked ? 0.7 : 1,
                              }}
                            >
                              <ListItemIcon>
                                <Checkbox
                                  edge="start"
                                  checked={isChecked}
                                  tabIndex={-1}
                                  disableRipple
                                  disabled={alreadyLinked}
                                  sx={{
                                    '&.Mui-checked': { color: shopifyColors.primary },
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: 1,
                                      flexWrap: 'wrap',
                                      mb: 0.5,
                                    }}
                                  >
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                      {warranty.warranty_name}
                                    </Typography>
                                    <Chip
                                      label={`${warranty.no_of_period} ${warranty.warranty_period}${warranty.no_of_period > 1 ? 's' : ''}`}
                                      size="small"
                                      sx={{
                                        bgcolor: shopifyColors.blue,
                                        color: '#fff',
                                        fontWeight: 500,
                                        fontSize: '11px',
                                      }}
                                    />
                                    {(warranty.price ?? 0) > 0 && (
                                      <Chip
                                        label={`AED ${warranty.price}`}
                                        size="small"
                                        variant="outlined"
                                        sx={{
                                          borderColor: shopifyColors.primary,
                                          color: shopifyColors.primary,
                                          fontSize: '11px',
                                        }}
                                      />
                                    )}
                                    {alreadyLinked && (
                                      <Chip
                                        label="Already linked"
                                        size="small"
                                        sx={{
                                          bgcolor: '#d1f4e0',
                                          color: '#00783e',
                                          fontWeight: 600,
                                          fontSize: '10px',
                                        }}
                                      />
                                    )}
                                  </Box>
                                }
                                secondary={
                                  <Box>
                                    <Typography
                                      variant="caption"
                                      sx={{ color: shopifyColors.textSecondary }}
                                    >
                                      {warranty.description}
                                    </Typography>
                                    {warranty.prod_name && (
                                      <Typography
                                        variant="caption"
                                        sx={{
                                          color: shopifyColors.textSecondary,
                                          display: 'block',
                                          fontStyle: 'italic',
                                        }}
                                      >
                                        Created for: {warranty.prod_name}
                                      </Typography>
                                    )}
                                  </Box>
                                }
                              />
                            </ListItemButton>
                          </ListItem>
                        );
                      })}
                    </List>
                  </Card>
                )}
              </>
            )}
          </Box>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          {/* Close */}
          <Button
            onClick={handleCloseWarrantyDialog}
            disabled={isAddingWarranty}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#d32f2f' },
            }}
          >
            Close
          </Button>

          {/* Cancel */}
          <Button
            onClick={handleCloseWarrantyDialog}
            disabled={isAddingWarranty}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#e07c10' },
            }}
          >
            Cancel
          </Button>

          {/* Link selected */}
          <Button
            onClick={handleSaveWarrantySelection}
            variant="contained"
            disabled={isAddingWarranty || selectedWarrantyIds.length === 0}
            startIcon={
              isAddingWarranty ? (
                <CircularProgress size={18} color="inherit" />
              ) : (
                <Shield />
              )
            }
            sx={{
              bgcolor: shopifyColors.blue,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#1e5bb0' },
            }}
          >
            {isAddingWarranty
              ? 'Linking…'
              : selectedWarrantyIds.length > 0
                ? `Link (${selectedWarrantyIds.length}) Warrant${selectedWarrantyIds.length === 1 ? 'y' : 'ies'}`
                : 'Link Warranties'}
          </Button>
        </DialogActions>
      </Dialog>



      {/* Bulk Order Dialog */}
      <Dialog
        open={bulkOrderDialogOpen}
        onClose={handleCloseBulkOrderDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <ShoppingBasket sx={{ color: '#1976d2' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Manage Bulk Order
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            {selectedProductForBulkOrder && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{
                  color: shopifyColors.textSecondary,
                  fontWeight: 600,
                  fontSize: '11px',
                  textTransform: 'uppercase'
                }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForBulkOrder.product_main_image ?
                      `https://fftestservice.sarsetech.com/images/${selectedProductForBulkOrder.product_main_image}` :
                      undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForBulkOrder.prod_short_name?.[0] ||
                      selectedProductForBulkOrder.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForBulkOrder.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Product ID: {selectedProductForBulkOrder.id || selectedProductForBulkOrder.product_id}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, display: 'block' }}>
                      Current Status: {selectedProductForBulkOrder.bulkorder === 1 ? 'Bulk Order Enabled' : 'Normal Order'}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <FormControlLabel
              control={
                <Switch
                  checked={bulkOrderStatus === 1}
                  onChange={(e) => setBulkOrderStatus(e.target.checked ? 1 : 0)}
                  color="primary"
                />
              }
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Enable Bulk Order
                  </Typography>
                  <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                    When enabled, this product will be available for bulk ordering with special pricing
                  </Typography>
                </Box>
              }
            />

            {bulkOrderStatus === 1 && (
              <Alert severity="info" sx={{ borderRadius: '6px' }}>
                <Typography variant="body2">
                  <strong>Note:</strong> Bulk order enabled products will have:
                  <Box component="ul" sx={{ mt: 1, pl: 2 }}>
                    <li>Special pricing for large quantities</li>
                    <li>Minimum order quantity requirements</li>
                    <li>Volume discounts may apply</li>
                    <li>Special shipping arrangements</li>
                  </Box>
                </Typography>
              </Alert>
            )}

            {bulkOrderStatus === 0 && selectedProductForBulkOrder?.bulkorder === 1 && (
              <Alert severity="warning" sx={{ borderRadius: '6px' }}>
                <Typography variant="body2">
                  <strong>Warning:</strong> Disabling bulk order will remove special pricing and
                  quantity requirements for this product.
                </Typography>
              </Alert>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseBulkOrderDialog}
            disabled={isSettingBulkOrder}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseBulkOrderDialog}
            disabled={isSettingBulkOrder}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveBulkOrderSettings}
            variant="contained"
            disabled={isSettingBulkOrder || !selectedProductForBulkOrder}
            startIcon={isSettingBulkOrder ? <CircularProgress size={20} /> : <Save />}
            sx={{
              bgcolor: '#1976d2',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#1565c0' }
            }}
          >
            {isSettingBulkOrder ? 'Saving...' : 'Save Bulk Order Settings'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Reward Product Dialog */}
      <Dialog
        open={rewardDialogOpen}
        onClose={handleCloseRewardDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CardGiftcard sx={{ color: shopifyColors.pink }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Manage Reward Points
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            {selectedProductForReward && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForReward.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForReward.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForReward.prod_short_name?.[0] || selectedProductForReward.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForReward.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Product ID: {selectedProductForReward.id || selectedProductForReward.product_id}
                    </Typography>
                    {selectedProductForReward.is_reward === 1 && (
                      <Typography variant="caption" sx={{
                        color: shopifyColors.pink,
                        fontWeight: 600,
                        display: 'block',
                        mt: 0.5
                      }}>
                        Currently a reward product ({selectedProductForReward.reward_points || 0} points)
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Box>
            )}

            <FormControlLabel
              control={
                <Switch
                  checked={rewardFormData.is_reward === 1}
                  onChange={handleRewardToggleChange}
                  color="secondary"
                />
              }
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Enable as Reward Product
                  </Typography>
                  <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                    When enabled, customers can redeem this product using reward points
                  </Typography>
                </Box>
              }
            />

            {rewardFormData.is_reward === 1 && (
              <Box sx={{ pl: 4 }}>
                <TextField
                  label="Reward Points Required *"
                  name="reward_points"
                  type="number"
                  fullWidth
                  value={rewardFormData.reward_points}
                  onChange={handleRewardInputChange}
                  error={!!rewardFormErrors.reward_points}
                  helperText={rewardFormErrors.reward_points || 'Number of points needed to redeem this product'}
                  InputProps={{
                    inputProps: { min: 1, max: 10000, step: 1 },
                    endAdornment: (
                      <InputAdornment position="end">
                        <Typography variant="body2" color="text.secondary">
                          points
                        </Typography>
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '6px',
                    }
                  }}
                />

                <Box sx={{ mt: 2, p: 2, bgcolor: '#fff0f7', borderRadius: '6px', border: `1px solid #f8bbd9` }}>
                  <Typography variant="caption" sx={{ color: shopifyColors.pink, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                    Reward Product Information
                  </Typography>
                  <Typography variant="body2" sx={{ color: shopifyColors.pink, mt: 0.5 }}>
                    Customers will be able to redeem this product for {rewardFormData.reward_points} reward points.
                    The product will appear in the reward catalog.
                  </Typography>
                </Box>
              </Box>
            )}

            {rewardFormData.is_reward === 0 && selectedProductForReward?.is_reward === 1 && (
              <Alert severity="warning" sx={{ borderRadius: '6px' }}>
                <Typography variant="body2">
                  <strong>Warning:</strong> Disabling reward status will remove this product from the reward catalog.
                  Customers will no longer be able to redeem it with points.
                </Typography>
              </Alert>
            )}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseRewardDialog}
            disabled={isSettingReward || isRemovingReward}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseRewardDialog}
            disabled={isSettingReward || isRemovingReward}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveRewardSettings}
            variant="contained"
            disabled={isSettingReward || isRemovingReward || !selectedProductForReward}
            startIcon={(isSettingReward || isRemovingReward) ? <CircularProgress size={20} /> : <CardGiftcard />}
            sx={{
              bgcolor: shopifyColors.pink,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#880e4f' }
            }}
          >
            {(isSettingReward || isRemovingReward)
              ? 'Saving...'
              : rewardFormData.is_reward === 1
                ? 'Save as Reward Product'
                : 'Remove from Rewards'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Open Box Delivery Dialog */}
      <Dialog
        open={openBoxDialogOpen}
        onClose={handleCloseOpenBoxDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Inventory sx={{ color: shopifyColors.openBox }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Manage Open Box Delivery
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={3} sx={{ mt: 2 }}>
            {selectedProductForOpenBox && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForOpenBox.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForOpenBox.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForOpenBox.prod_short_name?.[0] || selectedProductForOpenBox.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForOpenBox.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Product ID: {selectedProductForOpenBox.id || selectedProductForOpenBox.product_id}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, display: 'block' }}>
                      Price: {formatCurrencyAED(selectedProductForOpenBox.product_price || 0, selectedProductForOpenBox.currency)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <FormControlLabel
              control={
                <Switch
                  checked={openBoxFormData.open_box_delivery === 1}
                  onChange={handleOpenBoxToggleChange}
                  color="secondary"
                />
              }
              label={
                <Box>
                  <Typography variant="body1" sx={{ fontWeight: 600 }}>
                    Enable Open Box Delivery
                  </Typography>
                  <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                    When enabled, customers can choose open box delivery option
                  </Typography>
                </Box>
              }
            />

            {openBoxFormData.open_box_delivery === 1 && (
              <Box sx={{ pl: 4 }}>
                <TextField
                  label="Open Box Delivery Charge *"
                  name="open_box_charge"
                  type="number"
                  fullWidth
                  value={openBoxFormData.open_box_charge}
                  onChange={handleOpenBoxInputChange}
                  error={!!openBoxFormErrors.open_box_charge}
                  helperText={openBoxFormErrors.open_box_charge || 'Additional charge for open box delivery service'}
                  InputProps={{
                    startAdornment: <InputAdornment position="start">AED</InputAdornment>,
                    inputProps: { min: 0, step: 0.01 }
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '6px',
                    }
                  }}
                />

                {/* Price Preview with Open Box */}
                {selectedProductForOpenBox && (
                  <Box sx={{ mt: 2, p: 2, bgcolor: '#f3e5f5', borderRadius: '6px', border: `1px solid #e1bee7` }}>
                    <Typography variant="caption" sx={{
                      color: shopifyColors.openBox,
                      fontWeight: 600,
                      fontSize: '11px',
                      textTransform: 'uppercase'
                    }}>
                      Price Preview with Open Box
                    </Typography>

                    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                      {/* Original Retail Price */}
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                          Offer Price:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                          {formatCurrencyAED(selectedProductForOpenBox.product_retail_price || selectedProductForOpenBox.product_price || 0)}
                        </Typography>
                      </Box>

                      {/* Open Box Charge */}
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                          Open Box Charge:
                        </Typography>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.openBox }}>
                          {formatCurrencyAED(openBoxFormData.open_box_charge || 0)}
                        </Typography>
                      </Box>

                      {/* Divider */}
                      <Divider sx={{ my: 0.5 }} />

                      {/* Total */}
                      <Box sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                      }}>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                          Total:
                        </Typography>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: shopifyColors.openBox }}>
                          {(() => {
                            // Calculate total safely - Use retail price
                            const retailPrice = parseFloat(selectedProductForOpenBox.product_retail_price) ||
                              parseFloat(selectedProductForOpenBox.product_price) || 0;
                            const openBoxCharge = parseFloat(openBoxFormData.open_box_charge) || 0;
                            const total = retailPrice + openBoxCharge;

                            // Format the total, ensure it's a valid number
                            if (isNaN(total)) {
                              return formatCurrencyAED(0);
                            }
                            return formatCurrencyAED(total);
                          })()}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                )}
              </Box>
            )}

            <Alert severity="info" sx={{ borderRadius: '6px' }}>
              <Typography variant="body2">
                <strong>Note:</strong> Open box delivery allows customers to receive the product in an opened box.
                This is useful for products that customers want to inspect before purchase.
              </Typography>
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseOpenBoxDialog}
            disabled={isSettingOpenBox}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseOpenBoxDialog}
            disabled={isSettingOpenBox}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveOpenBoxSettings}
            variant="contained"
            disabled={isSettingOpenBox || !selectedProductForOpenBox}
            startIcon={isSettingOpenBox ? <CircularProgress size={20} /> : <Save />}
            sx={{
              bgcolor: shopifyColors.openBox,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#7b1fa2' }
            }}
          >
            {isSettingOpenBox ? 'Saving...' : 'Save Open Box Settings'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Flash Sale Dialog */}
      <Dialog
        open={flashSaleDialogOpen}
        onClose={handleCloseFlashSaleDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <LocalOffer sx={{ color: '#ff6f00' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Add Product to Flash Sale
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            {selectedProductForFlashSale && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForFlashSale.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForFlashSale.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForFlashSale.prod_short_name?.[0] || selectedProductForFlashSale.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForFlashSale.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Price: {formatCurrencyAED(selectedProductForFlashSale.product_price || 0, selectedProductForFlashSale.currency)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <TextField
              label="Start Date *"
              name="start_date"
              type="datetime-local"
              fullWidth
              value={flashSaleFormData.start_date}
              onChange={handleFlashSaleInputChange}
              error={!!flashSaleFormErrors.start_date}
              helperText={flashSaleFormErrors.start_date}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="End Date *"
              name="end_date"
              type="datetime-local"
              fullWidth
              value={flashSaleFormData.end_date}
              onChange={handleFlashSaleInputChange}
              error={!!flashSaleFormErrors.end_date}
              helperText={flashSaleFormErrors.end_date}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <FormControlLabel
              control={
                <Switch
                  checked={flashSaleFormData.active}
                  onChange={handleFlashSaleActiveChange}
                  color="primary"
                />
              }
              label="Active"
              sx={{ mt: 1 }}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseFlashSaleDialog}
            disabled={isAddingFlashSale}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseFlashSaleDialog}
            disabled={isAddingFlashSale}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddToFlashSale}
            variant="contained"
            disabled={isAddingFlashSale || !selectedProductForFlashSale}
            startIcon={isAddingFlashSale ? <CircularProgress size={20} /> : <LocalOffer />}
            sx={{
              bgcolor: '#ff6f00',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#e65100' }
            }}
          >
            {isAddingFlashSale ? 'Adding...' : 'Add to Flash Sale'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Product Return Limit Dialog */}
      <Dialog
        open={returnLimitDialogOpen}
        onClose={handleCloseReturnLimitDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AssignmentReturn sx={{ color: '#006fbb' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Set Product Return Limit
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            {selectedProductForReturnLimit && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForReturnLimit.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForReturnLimit.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForReturnLimit.prod_short_name?.[0] || selectedProductForReturnLimit.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForReturnLimit.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Product ID: {selectedProductForReturnLimit.id || selectedProductForReturnLimit.product_id}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <TextField
              label="Return Limit "
              type="number"
              fullWidth
              value={productReturnLimit}
              onChange={handleReturnLimitChange}
              error={productReturnLimit === '0' || productReturnLimit === ''}
              helperText="Number of limits customers have to return this product after purchase"
              InputProps={{
                inputProps: { min: 0 },
                endAdornment: (
                  <InputAdornment position="end">
                    <Typography variant="caption" color="text.secondary">
                      limits
                    </Typography>
                  </InputAdornment>
                ),
              }}
            />

            <Alert severity="info">
              <Typography variant="body2">
                <strong>Note:</strong> This return limit applies only to this specific product
                (Product ID: {selectedProductForReturnLimit?.id || selectedProductForReturnLimit?.product_id}).
              </Typography>
            </Alert>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseReturnLimitDialog}
            disabled={isSettingReturnLimit}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseReturnLimitDialog}
            disabled={isSettingReturnLimit}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveReturnLimit}
            variant="contained"
            disabled={isSettingReturnLimit || !selectedProductForReturnLimit || productReturnLimit === '0' || productReturnLimit === ''}
            startIcon={isSettingReturnLimit ? <CircularProgress size={20} /> : <Save />}
            sx={{
              bgcolor: '#006fbb',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#005aa0' }
            }}
          >
            {isSettingReturnLimit ? 'Saving...' : 'Save Return Limit'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Warehouse Stock Management Dialog */}
      <Dialog
        open={warehouseStockDialogOpen}
        onClose={handleCloseWarehouseStockDialog}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Inventory2 sx={{ color: shopifyColors.primary }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Manage Warehouse Stocks
              {selectedProductForWarehouse && (
                <Typography variant="caption" display="block" sx={{ color: shopifyColors.textSecondary, fontWeight: 500 }}>
                  Product ID: {selectedProductForWarehouse.product_id || selectedProductForWarehouse.id} |
                  Product: {selectedProductForWarehouse.prod_name}
                </Typography>
              )}
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          {selectedProductForWarehouse && (
            <Stack spacing={3} sx={{ mt: 2 }}>
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Avatar
                    src={selectedProductForWarehouse.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForWarehouse.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForWarehouse.prod_short_name?.[0] || selectedProductForWarehouse.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForWarehouse.prod_name}
                    </Typography>
                    <Typography variant="body2" sx={{ color: shopifyColors.textSecondary }}>
                      Product ID: {selectedProductForWarehouse.product_id || selectedProductForWarehouse.id}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, color: shopifyColors.textPrimary }}>
                  Warehouse Stock Distribution
                </Typography>

                {warehouses.length === 0 ? (
                  <Box sx={{ textAlign: 'center', py: 3 }}>
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ mt: 1, color: shopifyColors.textSecondary }}>
                      Loading warehouses...
                    </Typography>
                  </Box>
                ) : (
                  <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                      <TableHead>
                        <TableRow sx={{ bgcolor: '#fafbfb' }}>
                          <TableCell sx={{ fontWeight: 600, color: shopifyColors.textSecondary }}>Warehouse</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: shopifyColors.textSecondary }}>Status</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: shopifyColors.textSecondary }} align="right">Current Stock</TableCell>
                          <TableCell sx={{ fontWeight: 600, color: shopifyColors.textSecondary }} align="right">Update Stock</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {warehouses
                          .filter(warehouse => warehouse.status === 1)
                          .map((warehouse) => {
                            const existingStock = productWarehouses.find(
                              pw => pw.warehouse_id === warehouse.id
                            );
                            const currentStock = existingStock?.available_quantity || 0;

                            const updatedStock = warehouseStocks.find(
                              ws => ws.warehouse_id === warehouse.id
                            );
                            const displayStock = updatedStock ? updatedStock.available_quantity : currentStock;

                            return (
                              <TableRow key={warehouse.id} hover>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Store fontSize="small" sx={{ color: shopifyColors.textSecondary }} />
                                    <Typography variant="body2">
                                      {warehouse.name}
                                    </Typography>
                                  </Box>
                                  <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                    ID: {warehouse.id}
                                  </Typography>
                                </TableCell>
                                <TableCell>
                                  <Chip
                                    label="Active"
                                    size="small"
                                    sx={{
                                      bgcolor: '#d1f4e0',
                                      color: '#00783e',
                                      fontWeight: 500,
                                      fontSize: '11px',
                                      borderRadius: '4px'
                                    }}
                                  />
                                </TableCell>
                                <TableCell align="right">
                                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {currentStock}
                                  </Typography>
                                </TableCell>
                                <TableCell align="right">
                                  <TextField
                                    size="small"
                                    type="number"
                                    value={displayStock}
                                    onChange={(e) => handleWarehouseStockChange(
                                      warehouse.id,
                                      Math.max(0, parseInt(e.target.value) || 0)
                                    )}
                                    inputProps={{ min: 0 }}
                                    sx={{ width: 100 }}
                                    placeholder="Enter stock"
                                  />
                                </TableCell>
                              </TableRow>
                            );
                          })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                )}

                {warehouses.filter(w => w.status === 1).length === 0 && (
                  <Alert severity="warning" sx={{ mt: 2 }}>
                    No active warehouses found. Please activate at least one warehouse first.
                  </Alert>
                )}
              </Box>

              {warehouseStocks.length > 0 && (
                <Box sx={{ p: 2, bgcolor: '#f0f9f0', borderRadius: '6px', border: `1px solid #d1f4e0` }}>
                  <Typography variant="subtitle2" sx={{ fontWeight: 600, color: '#00783e', mb: 1 }}>
                    Stock Summary for {selectedProductForWarehouse.prod_name}
                  </Typography>
                  <Grid container spacing={2}>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>Total Warehouses:</strong> {warehouseStocks.length}
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body2">
                        <strong>Total Stock:</strong> {warehouseStocks.reduce((sum, stock) => sum + stock.available_quantity, 0)}
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              )}

              <Alert severity="info" sx={{ mt: 2 }}>
                <Typography variant="body2">
                  <strong>Note:</strong> Warehouse stock changes made here apply only to this specific product.
                </Typography>
              </Alert>
            </Stack>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseWarehouseStockDialog}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseWarehouseStockDialog}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSaveWarehouseStocks}
            variant="contained"
            disabled={warehouses.length === 0}
            startIcon={<Inventory2 />}
            sx={{
              bgcolor: shopifyColors.primary,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: shopifyColors.primaryHover }
            }}
          >
            Save Warehouse Stocks
          </Button>
        </DialogActions>
      </Dialog>

      {/* Deal of the Day Dialog */}
      <Dialog
        open={dealOfTheDayDialogOpen}
        onClose={handleCloseDealDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Whatshot sx={{ color: '#d32f2f' }} />
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              Add Product as Deal of the Day
            </Typography>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ mt: 2 }}>
            {selectedProductForDeal && (
              <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Selected Product
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Avatar
                    src={selectedProductForDeal.product_main_image ? `https://fftestservice.sarsetech.com/images/${selectedProductForDeal.product_main_image}` : undefined}
                    variant="rounded"
                    sx={{ width: 60, height: 60, borderRadius: '6px' }}
                  >
                    {selectedProductForDeal.prod_short_name?.[0] || selectedProductForDeal.prod_name?.[0] || 'P'}
                  </Avatar>
                  <Box>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {selectedProductForDeal.prod_name}
                    </Typography>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Original Price: {formatCurrencyAED(selectedProductForDeal.product_price || 0, selectedProductForDeal.currency)}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <TextField
              label="Discount (%)"
              name="discount"
              type="number"
              fullWidth
              value={dealFormData.discount}
              onChange={handleDealInputChange}
              error={!!dealFormErrors.discount}
              helperText={dealFormErrors.discount || 'Optional: Enter discount percentage (1-100) if you want to apply a discount'}
              InputProps={{
                inputProps: { min: 1, max: 100, step: 1 }
              }}
            />

            {selectedProductForDeal && dealFormData.discount && parseFloat(dealFormData.discount) > 0 && (
              <Box sx={{ p: 2, bgcolor: '#f0f9f0', borderRadius: '6px', border: `1px solid #d1f4e0` }}>
                <Typography variant="caption" sx={{ color: '#00783e', fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                  Price Preview
                </Typography>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                  <Box>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Original:
                    </Typography>
                    <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                      {formatCurrencyAED(selectedProductForDeal.product_price || 0)}
                    </Typography>
                  </Box>
                  <Typography variant="h6" sx={{ color: shopifyColors.textSecondary }}>→</Typography>
                  <Box>
                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                      Sale Price:
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 700, color: '#00783e' }}>
                      {formatCurrencyAED(
                        (selectedProductForDeal.product_price || 0) -
                        ((selectedProductForDeal.product_price || 0) * parseFloat(dealFormData.discount) / 100)
                      )}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            )}

            <TextField
              label="Start Date *"
              name="start_date"
              type="datetime-local"
              fullWidth
              value={dealFormData.start_date}
              onChange={handleDealInputChange}
              error={!!dealFormErrors.start_date}
              helperText={dealFormErrors.start_date}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <TextField
              label="End Date *"
              name="end_date"
              type="datetime-local"
              fullWidth
              value={dealFormData.end_date}
              onChange={handleDealInputChange}
              error={!!dealFormErrors.end_date}
              helperText={dealFormErrors.end_date}
              InputLabelProps={{
                shrink: true,
              }}
            />

            <FormControlLabel
              control={
                <Switch
                  checked={dealFormData.status === 1}
                  onChange={handleDealStatusChange}
                  color="primary"
                />
              }
              label="Active Status"
              sx={{ mt: 1 }}
            />
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
          <Button
            onClick={handleCloseDealDialog}
            disabled={isAddingDeal}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#f44336',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Close
          </Button>
          <Button
            onClick={handleCloseDealDialog}
            disabled={isAddingDeal}
            sx={{
              textTransform: 'none',
              fontWeight: 600,
              color: '#eeeeee',
              bgcolor: '#F78E12',
              borderRadius: '6px',
              px: 2.5
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleAddToDeal}
            variant="contained"
            disabled={isAddingDeal || !selectedProductForDeal}
            startIcon={isAddingDeal ? <CircularProgress size={20} /> : <Whatshot />}
            sx={{
              bgcolor: '#d32f2f',
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: '6px',
              px: 2.5,
              '&:hover': { bgcolor: '#b71c1c' }
            }}
          >
            {isAddingDeal ? 'Adding...' : 'Add as Deal of the Day'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Product Form Dialog */}
      <Dialog
        open={formOpen}
        onClose={handleFormClose}
        maxWidth="lg"
        fullWidth={true}
        PaperProps={{
          sx: {
            width: { xs: '95vw', sm: '90vw', md: '90vw' },
            maxWidth: '1200px',
            height: { xs: '95vh', md: '90vh' },
            maxHeight: productType === 'bundle' ? '95vh' : '800px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
            margin: { xs: 1, sm: 2 },
          }
        }}
      >
        <DialogTitle sx={{ pb: 1, borderBottom: `1px solid ${shopifyColors.border}` }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
            <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
              {isEditing || isEditingBundle ? `Edit ${productType === 'bundle' ? 'Bundle' : 'Product'}` : `Add New ${productType === 'bundle' ? 'Bundle' : 'Product'}`}
            </Typography>
            <IconButton
              onClick={handleFormClose}
              size="small"
              disabled={isFormSubmitting}
            >
              <Close />
            </IconButton>
          </Box>
        </DialogTitle>

        {/* Re-approval notice: a vendor editing any detail of an existing
            product sends it back into the admin approval queue, so make
            that explicit before they start changing things. */}
        {isVendor && isEditing && (
          <Alert severity="warning" sx={{ borderRadius: 0 }}>
            Saving these changes will send this product back to the admin for re-approval.
            It may be temporarily hidden from customers until it's approved again.
          </Alert>
        )}

        <form onSubmit={handleSubmit}>
          <DialogContent sx={{ pt: 1, overflow: 'auto' }}>
            <Tabs
              value={tabValue}
              onChange={handleTabChange}
              sx={{
                mb: 2,
                '& .MuiTab-root': {
                  minWidth: 'auto',
                  padding: { xs: '12px 8px', sm: '12px 16px' },
                  fontSize: { xs: '12px', sm: '14px' },
                }
              }}
              variant="scrollable"
              scrollButtons="auto"
            >
              <Tab
                label={isMobile ? "Basic" : "Basic Info"}
                icon={isMobile ? <Inventory /> : undefined}
                iconPosition="start"
                sx={{
                  color: (formErrors.product_name || formErrors.bundle_name ||
                    formErrors.product_short_name || formErrors.bundle_short_name ||
                    formErrors.cat_id) ? 'error.main' : 'inherit',
                  fontWeight: (formErrors.product_name || formErrors.bundle_name ||
                    formErrors.product_short_name || formErrors.bundle_short_name ||
                    formErrors.cat_id) ? 600 : 400,
                }}
              />
              <Tab
                label={isMobile ? "Pricing" : "Pricing"}
                icon={isMobile ? <AttachMoney /> : undefined}
                iconPosition="start"
                sx={{
                  color: (formErrors.product_price || formErrors.bundle_price ||
                    formErrors.product_retail_price || formErrors.bundle_retail_price) ? 'error.main' : 'inherit',
                  fontWeight: (formErrors.product_price || formErrors.bundle_price ||
                    formErrors.product_retail_price || formErrors.bundle_retail_price) ? 600 : 400,
                }}
              />
              {productType === 'single' && isEditing && (
                <Tab
                  label={isMobile ? "Properties" : "Additional Properties"}
                  icon={isMobile ? <Style /> : undefined}
                  iconPosition="start"
                />
              )}
              {productType === 'bundle' && (
                <Tab
                  label={isMobile ? "Bundle" : "Bundle Products"}
                  icon={isMobile ? <ShoppingBasket /> : undefined}
                  iconPosition="start"
                  sx={{
                    color: formErrors.products ? 'error.main' : 'inherit',
                    fontWeight: formErrors.products ? 600 : 400,
                  }}
                />
              )}

              <Tab label={isMobile ? "Delivery" : "Delivery Model"} icon={isMobile ? <LocalShipping /> : undefined} iconPosition="start" />
            </Tabs>

            {Object.keys(formErrors).length > 0 && (
              <Alert
                severity="error"
                sx={{ mb: 2 }}
                onClose={() => setFormErrors({})}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 600, mb: 1 }}>
                  Please fix the following errors:
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 2 }}>
                  {Object.entries(formErrors).map(([field, error]) => (
                    <li key={field}>
                      <Typography variant="body2">{error}</Typography>
                    </li>
                  ))}
                </Box>
              </Alert>
            )}

            {/* Basic Info Tab */}
            <TabPanel value={tabValue} index={0}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3 }}>
                <Box sx={{ flex: { xs: 'none', md: '0 0 33%' }, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                  {/* Image Upload Section */}
                  <Box sx={{ position: 'relative' }}>
                    <Avatar
                      key={editingProduct?.id ?? editingBundle?.id ?? (imagePreview || 'new')}
                      src={imagePreview}
                      sx={{
                        width: { xs: 220, sm: 260, md: 280 },
                        height: { xs: 220, sm: 260, md: 280 },
                        cursor: 'pointer',
                        border: selectedImage ? '3px solid #1976d2' : '3px dashed #ccc',
                        '&:hover': {
                          borderColor: '#1976d2',
                          opacity: 0.8,
                        }
                      }}
                      variant="rounded"
                      onClick={() => document.getElementById('image-upload')?.click()}
                    >
                      {!imagePreview && <PhotoCamera sx={{ fontSize: 80, color: '#666' }} />}
                    </Avatar>
                    {imagePreview && (
                      <IconButton
                        sx={{
                          position: 'absolute',
                          top: -8,
                          right: -8,
                          bgcolor: 'error.main',
                          color: 'white',
                          width: 28,
                          height: 28,
                          '&:hover': {
                            bgcolor: 'error.dark',
                          }
                        }}
                        onClick={handleRemoveImage}
                        disabled={isFormSubmitting}
                      >
                        <Close sx={{ fontSize: 18 }} />
                      </IconButton>
                    )}
                  </Box>

                  <input
                    id="image-upload"
                    type="file"
                    accept="image/*"
                    onChange={handleImageChange}
                    style={{ display: 'none' }}
                    disabled={isFormSubmitting}
                  />

                  <Button
                    variant="outlined"
                    startIcon={<PhotoCamera />}
                    onClick={() => document.getElementById('image-upload')?.click()}
                    disabled={isFormSubmitting}
                    sx={{ width: '100%' }}
                  >
                    {imagePreview ? 'Change Image' : 'Upload Image'}
                  </Button>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                    Recommended: {PRODUCT_IMAGE_RECOMMENDED} • JPG / PNG • max {PRODUCT_IMAGE_MAX_MB} MB
                  </Typography>

                  {/* Additional images section */}
                  {productType === 'single' && isEditing && (
                    <>
                      <Button
                        variant="outlined"
                        startIcon={<PhotoCamera />}
                        component="label"
                        disabled={isFormSubmitting}
                        sx={{ width: '100%' }}
                      >
                        {uploading ? <CircularProgress size={10} sx={{ color: '#4BA5EB' }} /> : 'Upload Additional Images / Video'}
                        <input
                          hidden
                          accept={ADDITIONAL_MEDIA_ACCEPT}
                          multiple
                          type="file"
                          onChange={handleAdditionalImagesChange}
                        />
                      </Button>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', textAlign: 'center' }}>
                        Images: {PRODUCT_IMAGE_RECOMMENDED} • JPG / PNG / WebP • max {PRODUCT_IMAGE_MAX_MB} MB each (up to 10 files)<br />
                        Videos: MP4 / MOV / AVI / MKV • max {PRODUCT_VIDEO_MAX_MB} MB
                      </Typography>

                      <Box
                        sx={{
                          mt: 2,
                          maxHeight: 200,
                          overflowY: "auto",
                          display: "flex",
                          flexWrap: "wrap",
                          gap: 4,
                          p: 2,
                          border: "1px dashed #ccc",
                          borderRadius: 2,
                          width: '100%',
                        }}
                      >
                        {additionalImages.length === 0 ? (
                          <Typography variant="caption" color="text.secondary">
                            No additional images uploaded yet
                          </Typography>
                        ) : (
                          additionalImages.map((img, idx) => (
                            <Box
                              key={idx}
                              sx={{
                                position: "relative",
                                width: 80,
                                height: 80,
                                flexShrink: 0,
                              }}
                            >
                              {isVideoFilename(img.filename) ? (
                                <Box sx={{ position: "relative", width: "100%", height: "100%" }}>
                                  <Box
                                    component="video"
                                    src={`https://fftestservice.sarsetech.com/images/${img.filename}#t=0.1`}
                                    muted
                                    preload="metadata"
                                    onClick={() => window.open(`https://fftestservice.sarsetech.com/images/${img.filename}`, '_blank')}
                                    sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: 1, bgcolor: '#000', cursor: 'pointer' }}
                                  />
                                  <PlayCircleOutline
                                    sx={{
                                      position: "absolute",
                                      top: "50%",
                                      left: "50%",
                                      transform: "translate(-50%, -50%)",
                                      fontSize: 32,
                                      color: "#fff",
                                      opacity: 0.9,
                                      pointerEvents: "none",
                                      filter: "drop-shadow(0 0 2px rgba(0,0,0,0.6))",
                                    }}
                                  />
                                </Box>
                              ) : (
                                <Avatar
                                  src={`https://fftestservice.sarsetech.com/images/${img.filename}`}
                                  variant="rounded"
                                  sx={{ width: "100%", height: "100%" }}
                                />
                              )}
                              <IconButton
                                size="small"
                                sx={{
                                  position: "absolute",
                                  top: -8,
                                  right: -8,
                                  bgcolor: "error.main",
                                  color: "white",
                                  "&:hover": { bgcolor: "error.dark" },
                                }}
                                onClick={async () => {
                                  try {
                                    if (!editingProduct?.id) return;
                                    setDeletingImageId(img.id);
                                    await deleteadditionalProductImage({
                                      product_id: editingProduct?.id,
                                      image_id: img.id,
                                    }).unwrap();

                                    setAdditionalImages((prev) =>
                                      prev.filter((_, i) => i !== idx)
                                    );
                                  } catch (err) {
                                    console.error("Failed to delete image:", err);
                                    toast.error("Failed to delete image");
                                  } finally {
                                    setDeletingImageId(null);
                                  }
                                }}
                              >
                                {deletingImageId === img.id ? <CircularProgress size={6} sx={{ color: '#fff' }} /> : <Close sx={{ fontSize: 14 }} />}
                              </IconButton>

                              <IconButton
                                size="small"
                                component="label"
                                sx={{
                                  position: "absolute",
                                  top: -8,
                                  left: -8,
                                  bgcolor: "primary.main",
                                  color: "white",
                                  "&:hover": { bgcolor: "primary.dark" },
                                }}
                              >
                                {updatingImageId === img.id ? <CircularProgress size={6} sx={{ color: '#fff' }} /> : <Edit sx={{ fontSize: 14 }} />}
                                <input
                                  type="file"
                                  hidden
                                  accept={ADDITIONAL_MEDIA_ACCEPT}
                                  onChange={async (e) => {
                                    if (!e.target.files?.[0] || !editingProduct?.id || !img.id) return;
                                    const pickedFile = e.target.files[0];
                                    const validationError = validateAdditionalMedia(pickedFile);
                                    if (validationError) {
                                      toast.error(validationError);
                                      e.target.value = '';
                                      return;
                                    }
                                    setUpdatingImageId(img.id);
                                    try {
                                      const file = pickedFile;
                                      const res = await updateadditionalProductImage({
                                        product_id: editingProduct.id,
                                        image_id: img.id,
                                        product_main_image: file,
                                      }).unwrap();

                                      toast.success("Image updated successfully");

                                      setAdditionalImages((prev) =>
                                        prev.map((image, i) =>
                                          i === idx ? { ...image, filename: res.data.mainImage } : image
                                        )
                                      );
                                    } catch (err) {
                                      console.error("Failed to update image:", err);
                                      toast.error("Failed to update image");
                                    } finally {
                                      setUpdatingImageId(null);
                                    }
                                  }}
                                />
                              </IconButton>
                            </Box>
                          ))
                        )}
                      </Box>
                    </>
                  )}
                </Box>

                <Box sx={{ flex: 1, width: '100%' }}>
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                    <TextField
                      name={productType === 'bundle' ? 'bundle_name' : 'product_name'}
                      label={productType === 'bundle' ? 'Bundle Name *' : 'Product Name *'}
                      value={productType === 'bundle' ? bundleFormData.bundle_name : formData.product_name}
                      onChange={handleInputChange}
                      error={!!formErrors[productType === 'bundle' ? 'bundle_name' : 'product_name']}
                      helperText={formErrors[productType === 'bundle' ? 'bundle_name' : 'product_name']}
                      fullWidth
                      required
                      placeholder={productType === 'bundle' ? "e.g., Summer Essentials Bundle" : "e.g., Wireless Headphones"}
                      variant="outlined"
                      disabled={isFormSubmitting}
                    />

                    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                      <TextField
                        name={productType === 'bundle' ? 'bundle_short_name' : 'product_short_name'}
                        label={productType === 'bundle' ? 'Short Name *' : 'Short Name'}
                        value={productType === 'bundle' ? bundleFormData.bundle_short_name : formData.product_short_name}
                        onChange={handleInputChange}
                        error={!!formErrors[productType === 'bundle' ? 'bundle_short_name' : 'product_short_name']}
                        helperText={
                          productType === 'bundle'
                            ? formErrors[productType === 'bundle' ? 'bundle_short_name' : 'product_short_name'] || 'Maximum 10 characters'
                            : (formErrors[productType === 'bundle' ? 'bundle_short_name' : 'product_short_name'] || 'Optional, maximum 10 characters')
                        }
                        fullWidth
                        required={productType === 'bundle'}
                        placeholder={productType === 'bundle' ? "e.g., SUM-BUN" : "e.g., WH-1000"}
                        inputProps={{ maxLength: 10 }}
                        variant="outlined"
                        disabled={isFormSubmitting}
                      />

                      <FormControl fullWidth error={!!formErrors.cat_id} disabled={isFormSubmitting}>
                        <InputLabel>Category *</InputLabel>
                        <Select
                          name="cat_id"
                          value={productType === 'bundle' ? bundleFormData.cat_id.toString() : formData.cat_id.toString()}
                          onChange={handleCategoryChange}
                          label="Category *"
                        >
                          <MenuItem value={0}>Select Category</MenuItem>
                          {categories.map((category) => (
                            <MenuItem key={category.cat_id || category.id} value={category.cat_id || category.id}>
                              {category.cat_name}
                            </MenuItem>
                          ))}
                        </Select>
                        {formErrors.cat_id && <FormHelperText>{formErrors.cat_id}</FormHelperText>}
                      </FormControl>
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
                      <FormControl
                        fullWidth
                        disabled={isFormSubmitting || !filteredSubCategories.length}
                      >
                        <InputLabel>Sub Category</InputLabel>
                        <Select
                          name="sub_cat_id"
                          value={productType === 'bundle' ? (bundleFormData.sub_cat_id?.toString() || '') : (formData.sub_cat_id?.toString() || '')}
                          onChange={handleSelectChange}
                          label="Sub Category"
                          MenuProps={{
                            PaperProps: {
                              style: {
                                maxHeight: 400,
                              },
                            },
                          }}
                        >
                          <MenuItem value="">
                            <em>Select Sub Category</em>
                          </MenuItem>
                          {paginatedSubCategories.map((subCategory: any) => (
                            <MenuItem
                              key={subCategory.sub_cat_id || subCategory.id}
                              value={subCategory.sub_cat_id || subCategory.id}
                            >
                              {subCategory.sub_cat_name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {filteredSubCategories.length === 0 ? (
                            'Please select a category first'
                          ) : (
                            `Showing ${startIndex + 1}-${Math.min(endIndex, filteredSubCategories.length)} of ${filteredSubCategories.length} subcategories`
                          )}
                        </FormHelperText>
                      </FormControl>

                      {/* Pagination Controls */}
                      {filteredSubCategories.length > subCategoriesPerPage && (
                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mt: 1,
                          p: 1.5,
                          bgcolor: '#f8f9fa',
                          borderRadius: 1,
                          border: '1px solid #e0e0e0',
                          width: '100%',
                        }}>
                          <Button
                            size="small"
                            variant="outlined"
                            disabled={subCategoryPage === 1}
                            onClick={handleSubCategoryPrevPage}
                            startIcon={<ArrowBack />}
                            sx={{
                              textTransform: 'none',
                              fontWeight: 500,
                              minWidth: 100
                            }}
                          >
                            Previous
                          </Button>

                          <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 2
                          }}>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              Page {subCategoryPage} of {totalSubCategoryPages}
                            </Typography>
                            <Chip
                              label={`${filteredSubCategories.length} total`}
                              size="small"
                              variant="outlined"
                              sx={{ fontWeight: 500 }}
                            />
                          </Box>

                          <Button
                            size="small"
                            variant="outlined"
                            disabled={subCategoryPage === totalSubCategoryPages}
                            onClick={handleSubCategoryNextPage}
                            endIcon={<ArrowForward />}
                            sx={{
                              textTransform: 'none',
                              fontWeight: 500,
                              minWidth: 100
                            }}
                          >
                            Next
                          </Button>
                        </Box>
                      )}
                    </Box>

                    {/* Unit Selection from API */}
                    {productType === 'single' && (
                      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                        <FormControl fullWidth disabled={isFormSubmitting}>
                          <InputLabel>Unit *</InputLabel>
                          <Select
                            name="product_unit"
                            value={formData.product_unit}
                            onChange={handleSelectChange}
                            label="Unit *"
                            MenuProps={{
                              PaperProps: {
                                style: {
                                  maxHeight: 400,
                                },
                              },
                            }}
                          >
                            <MenuItem value="">Select Unit</MenuItem>
                            {isLoadingUnits ? (
                              <MenuItem value="" disabled>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <CircularProgress size={16} />
                                  <Typography variant="body2">Loading units...</Typography>
                                </Box>
                              </MenuItem>
                            ) : units.length === 0 ? (
                              <MenuItem value="" disabled>
                                No units found. Please add units first.
                              </MenuItem>
                            ) : (
                              units.map((unit: any) => (
                                <MenuItem
                                  key={unit.unit_id || unit.id}
                                  value={unit.unit_short_name || unit.unit_name || ''}
                                >
                                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography variant="body2" sx={{ fontWeight: 500 }}>
                                      {unit.unit_name || 'N/A'}
                                    </Typography>
                                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                      {unit.unit_short_name || 'No short name'}
                                      {unit.unit_desc && ` • ${unit.unit_desc}`}
                                    </Typography>
                                  </Box>
                                </MenuItem>
                              ))
                            )}
                          </Select>
                          <FormHelperText>
                            {isLoadingUnits ? 'Loading units...' :
                              units.length === 0 ? 'No units available. Please add units first.' :
                                'Select the unit of measurement for this product'}
                          </FormHelperText>
                        </FormControl>

                        {/* Unit Management Info */}
                        {!isLoadingUnits && units.length > 0 && (
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                              {units.length} units available
                            </Typography>
                            <Tooltip title="Refresh units">
                              <IconButton
                                size="small"
                                onClick={() => refetchUnits()}
                                disabled={isLoadingUnits}
                                sx={{ ml: 1 }}
                              >
                                <Refresh fontSize="small" />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        )}

                        {units.length === 0 && !isLoadingUnits && (
                          <Alert severity="warning" sx={{ mt: 1 }}>
                            <Typography variant="body2">
                              No units found. Please add units first in the{' '}
                              <Button
                                component="a"
                                href="/admin/units"
                                size="small"
                                sx={{ textTransform: 'none', verticalAlign: 'baseline' }}
                              >
                                Unit Management
                              </Button>
                              {' '}section.
                            </Typography>
                          </Alert>
                        )}
                      </Box>
                    )}

                    {/* Quantity field */}
                    {productType === 'single' && (
                      <TextField
                        name="product_quantity"
                        label="Quantity per Unit"
                        type="number"
                        value={formData.product_quantity}
                        onChange={handleInputChange}
                        fullWidth
                        InputProps={{
                          inputProps: { min: 1 }
                        }}
                        variant="outlined"
                        disabled={isFormSubmitting}
                        helperText="Number of items per unit (e.g., 100 for 100g, 6 for 6-pack)"
                      />
                    )}

                    {/* Minimum Order Quantity field */}
                    {productType === 'single' && (
                      <TextField
                        name="min_quantity"
                        label="Minimum Order Quantity"
                        type="number"
                        value={formData.min_quantity ?? 10}
                        onChange={handleInputChange}
                        fullWidth
                        InputProps={{
                          inputProps: { min: 1 }
                        }}
                        variant="outlined"
                        disabled={isFormSubmitting}
                        helperText="Minimum quantity a customer must order (default 10)"
                      />
                    )}

                    {/* Open Box Delivery Section */}

                    {/* Open Box Delivery Dialog */}
                    <Dialog
                      open={openBoxDialogOpen}
                      onClose={handleCloseOpenBoxDialog}
                      maxWidth="sm"
                      fullWidth
                      PaperProps={{
                        sx: {
                          borderRadius: '8px',
                          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
                          margin: { xs: 1, sm: 2 },
                        }
                      }}
                    >
                      <DialogTitle sx={{ pb: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Inventory sx={{ color: shopifyColors.openBox }} />
                          <Typography variant="h6" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                            Manage Open Box Delivery
                          </Typography>
                        </Box>
                      </DialogTitle>
                      <DialogContent>
                        <Stack spacing={3} sx={{ mt: 2 }}>
                          {selectedProductForOpenBox && (
                            <Box sx={{ p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                              <Typography variant="caption" sx={{
                                color: shopifyColors.textSecondary,
                                fontWeight: 600,
                                fontSize: '11px',
                                textTransform: 'uppercase'
                              }}>
                                Selected Product
                              </Typography>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}>
                                <Avatar
                                  src={selectedProductForOpenBox.product_main_image ?
                                    `https://fftestservice.sarsetech.com/images/${selectedProductForOpenBox.product_main_image}` :
                                    undefined}
                                  variant="rounded"
                                  sx={{ width: 60, height: 60, borderRadius: '6px' }}
                                >
                                  {selectedProductForOpenBox.prod_short_name?.[0] ||
                                    selectedProductForOpenBox.prod_name?.[0] || 'P'}
                                </Avatar>
                                <Box>
                                  <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                                    {selectedProductForOpenBox.prod_name}
                                  </Typography>
                                  <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                    Product ID: {selectedProductForOpenBox.id || selectedProductForOpenBox.product_id}
                                  </Typography>
                                  {/* Show Retail Price instead of Original Price */}
                                  <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, display: 'block' }}>
                                    Offer Price: {formatCurrencyAED(
                                      selectedProductForOpenBox.product_retail_price ||
                                      selectedProductForOpenBox.product_price || 0,
                                      selectedProductForOpenBox.currency
                                    )}
                                  </Typography>
                                </Box>
                              </Box>
                            </Box>
                          )}

                          <FormControlLabel
                            control={
                              <Switch
                                checked={openBoxFormData.open_box_delivery === 1}
                                onChange={handleOpenBoxToggleChange}
                                color="secondary"
                              />
                            }
                            label={
                              <Box>
                                <Typography variant="body1" sx={{ fontWeight: 600 }}>
                                  Enable Open Box Delivery
                                </Typography>
                                <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                  When enabled, customers can choose open box delivery option
                                </Typography>
                              </Box>
                            }
                          />

                          {openBoxFormData.open_box_delivery === 1 && (
                            <Box sx={{ pl: 4 }}>
                              <TextField
                                label="Open Box Delivery Charge *"
                                name="open_box_charge"
                                type="number"
                                fullWidth
                                value={openBoxFormData.open_box_charge}
                                onChange={handleOpenBoxInputChange}
                                error={!!openBoxFormErrors.open_box_charge}
                                helperText={openBoxFormErrors.open_box_charge || 'Additional charge for open box delivery service'}
                                InputProps={{
                                  startAdornment: <InputAdornment position="start">AED</InputAdornment>,
                                  inputProps: { min: 0, step: 0.01 }
                                }}
                                sx={{
                                  '& .MuiOutlinedInput-root': {
                                    borderRadius: '6px',
                                  }
                                }}
                              />

                              {/* Price Preview with Open Box - UPDATED TO USE RETAIL PRICE */}
                              {selectedProductForOpenBox && (
                                <Box sx={{ mt: 2, p: 2, bgcolor: '#f3e5f5', borderRadius: '6px', border: `1px solid #e1bee7` }}>
                                  <Typography variant="caption" sx={{
                                    color: shopifyColors.openBox,
                                    fontWeight: 600,
                                    fontSize: '11px',
                                    textTransform: 'uppercase'
                                  }}>
                                    Price Preview with Open Box
                                  </Typography>

                                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mt: 1 }}>
                                    {/* Retail Price */}
                                    <Box sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                        Offer Price:
                                      </Typography>
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                                        {formatCurrencyAED(
                                          selectedProductForOpenBox.product_retail_price ||
                                          selectedProductForOpenBox.product_price || 0
                                        )}
                                      </Typography>
                                    </Box>

                                    {/* Open Box Charge */}
                                    <Box sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                        Open Box Charge:
                                      </Typography>
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.openBox }}>
                                        {formatCurrencyAED(openBoxFormData.open_box_charge || 0)}
                                      </Typography>
                                    </Box>

                                    {/* Divider */}
                                    <Divider sx={{ my: 0.5 }} />

                                    {/* Total */}
                                    <Box sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center'
                                    }}>
                                      <Typography variant="body2" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                                        Total:
                                      </Typography>
                                      <Typography variant="h6" sx={{ fontWeight: 700, color: shopifyColors.openBox }}>
                                        {(() => {
                                          // Calculate total safely - Use retail price
                                          const retailPrice = parseFloat(selectedProductForOpenBox.product_retail_price) ||
                                            parseFloat(selectedProductForOpenBox.product_price) || 0;
                                          const openBoxCharge = parseFloat(openBoxFormData.open_box_charge) || 0;
                                          const total = retailPrice + openBoxCharge;

                                          // Format the total, ensure it's a valid number
                                          if (isNaN(total)) {
                                            return formatCurrencyAED(0);
                                          }
                                          return formatCurrencyAED(total);
                                        })()}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Box>
                              )}
                            </Box>
                          )}

                          <Alert severity="info" sx={{ borderRadius: '6px' }}>
                            <Typography variant="body2">
                              <strong>Note:</strong> Open box delivery allows customers to receive the product in an opened box.
                              This is useful for products that customers want to inspect before purchase.
                            </Typography>
                          </Alert>
                        </Stack>
                      </DialogContent>
                      <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
                        <Button
                          onClick={handleCloseOpenBoxDialog}
                          disabled={isSettingOpenBox}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#eeeeee',
                            bgcolor: '#f44336',
                            borderRadius: '6px',
                            px: 2.5
                          }}
                        >
                          Close
                        </Button>
                        <Button
                          onClick={handleCloseOpenBoxDialog}
                          disabled={isSettingOpenBox}
                          sx={{
                            textTransform: 'none',
                            fontWeight: 600,
                            color: '#eeeeee',
                            bgcolor: '#F78E12',
                            borderRadius: '6px',
                            px: 2.5
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          onClick={handleSaveOpenBoxSettings}
                          variant="contained"
                          disabled={isSettingOpenBox || !selectedProductForOpenBox}
                          startIcon={isSettingOpenBox ? <CircularProgress size={20} /> : <Save />}
                          sx={{
                            bgcolor: shopifyColors.openBox,
                            textTransform: 'none',
                            fontWeight: 600,
                            borderRadius: '6px',
                            px: 2.5,
                            '&:hover': { bgcolor: '#7b1fa2' }
                          }}
                        >
                          {isSettingOpenBox ? 'Saving...' : 'Save Open Box Settings'}
                        </Button>
                      </DialogActions>
                    </Dialog>

                    <FormControl fullWidth error={!!formErrors.description}>
                      <InputLabel shrink>Description</InputLabel>
                      <Box sx={{ mt: 2 }}>
                        <ReactQuill
                          value={productType === 'bundle' ? bundleFormData.bundle_desc : formData.product_desc}
                          onChange={(value) => {
                            if (productType === 'bundle') {
                              setBundleFormData(prev => ({
                                ...prev,
                                bundle_desc: value
                              }));
                            } else {
                              setFormData(prev => ({
                                ...prev,
                                product_desc: value
                              }));
                            }

                            if (formErrors.description) {
                              setFormErrors(prev => ({ ...prev, description: '' }));
                            }
                          }}
                          modules={quillModules}
                          formats={quillFormats}
                          placeholder={`Enter ${productType === 'bundle' ? 'bundle' : 'product'} description (optional)`}
                          readOnly={isFormSubmitting}
                          style={{
                            height: '200px',
                            marginBottom: '50px'
                          }}
                        />
                      </Box>
                      {formErrors.description && (
                        <FormHelperText error>{formErrors.description}</FormHelperText>
                      )}
                    </FormControl>

                    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                      <FormControl fullWidth disabled={isFormSubmitting}>
                        <InputLabel>Status</InputLabel>
                        <Select
                          name="status"
                          value={productType === 'bundle' ? bundleFormData.status.toString() : formData.status.toString()}
                          onChange={handleSelectChange}
                          label="Status"
                        >
                          <MenuItem value={1}>Active</MenuItem>
                          <MenuItem value={0}>Inactive</MenuItem>
                          <MenuItem value={2}>Suspended</MenuItem>
                        </Select>
                      </FormControl>

                      <FormControl fullWidth disabled={isFormSubmitting}>
                        <InputLabel>Availability</InputLabel>
                        <Select
                          name="availability"
                          value={productType === 'bundle' ? bundleFormData.availability.toString() : formData.availability.toString()}
                          onChange={handleSelectChange}
                          label="Availability"
                        >
                          <MenuItem value={1}>In Stock</MenuItem>
                          <MenuItem value={0}>Out of Stock</MenuItem>
                          <MenuItem value={2}>Pre-order</MenuItem>
                        </Select>
                      </FormControl>
                    </Box>

                    {!isVendor && (
                    <TextField
                      name="popular_score"
                      label="Popular Score"
                      type="number"
                      value={productType === 'bundle' ? bundleFormData.popular_score : formData.popular_score}
                      onChange={handleInputChange}
                      onFocus={(e) => e.target.select()}
                      error={!!formErrors.popular_score}
                      helperText={formErrors.popular_score || 'Set a score between 0-100 to make this product popular'}
                      fullWidth
                      InputProps={{
                        inputProps: { min: 0, max: 100 },
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => {
                                if (productType === 'bundle') {
                                  setBundleFormData(prev => ({ ...prev, popular_score: 0 }));
                                } else {
                                  setFormData(prev => ({ ...prev, popular_score: 0 }));
                                }
                                if (formErrors.popular_score) {
                                  setFormErrors(prev => ({ ...prev, popular_score: '' }));
                                }
                              }}
                              edge="end"
                              size="small"
                              title="Reset to 0"
                              disabled={isFormSubmitting}
                            >
                              <Clear />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      variant="outlined"
                      disabled={isFormSubmitting}
                    />

                    )}

                    {/* Tax Fields */}
                    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                      <TextField
                        name="tax1_per"
                        label="Tax Percentage *"
                        type="number"
                        value={productType === 'bundle' ? (bundleFormData.tax1_per ?? globalTaxPer) : (formData.tax1_per ?? globalTaxPer)}
                        onChange={handleInputChange}
                        error={!!formErrors.tax1_per}
                        onFocus={(e) => e.target.select()}
                        helperText={
                          formErrors.tax1_per
                            || (isSuperAdmin
                              ? 'Tax percentage'
                              : 'Auto-fetched from Tax Settings. Contact Super Admin to change.')
                        }
                        fullWidth
                        required
                        InputProps={{
                          endAdornment: <InputAdornment position="end">%</InputAdornment>,
                        }}
                        variant="outlined"
                        disabled={isFormSubmitting || !isSuperAdmin}
                        inputProps={{ min: 0, max: 100, step: 0.01 }}
                      />
                    </Box>
                  </Box>
                </Box>
              </Box>
            </TabPanel>

            {/* Pricing Tab */}
            <TabPanel value={tabValue} index={1}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <TextField
                    name={productType === 'bundle' ? 'bundle_price' : 'product_price'}
                    label={productType === 'bundle' ? 'Bundle Price *' : 'Price *'}
                    type="number"
                    value={productType === 'bundle' ? bundleFormData.bundle_price : formData.product_price}
                    onChange={handleInputChange}
                    onFocus={(e) => e.target.select()}
                    error={!!formErrors[productType === 'bundle' ? 'bundle_price' : 'product_price']}
                    helperText={formErrors[productType === 'bundle' ? 'bundle_price' : 'product_price']}
                    fullWidth
                    required
                    InputProps={{
                      startAdornment: <InputAdornment position="start">د.إ</InputAdornment>,
                    }}
                    variant="outlined"
                    disabled={isFormSubmitting}
                  />

                  <TextField
                    name={productType === 'bundle' ? 'bundle_retail_price' : 'product_retail_price'}
                    label={productType === 'bundle' ? 'Bundle Retail Price *' : 'Discount Price *'}
                    type="number"
                    value={productType === 'bundle' ? bundleFormData.bundle_retail_price : formData.product_retail_price}
                    onChange={handleInputChange}
                    onFocus={(e) => e.target.select()}
                    error={!!formErrors[productType === 'bundle' ? 'bundle_retail_price' : 'product_retail_price']}
                    helperText={formErrors[productType === 'bundle' ? 'bundle_retail_price' : 'product_retail_price']}
                    fullWidth
                    required
                    InputProps={{
                      startAdornment: <InputAdornment position="start">د.إ</InputAdornment>,
                    }}
                    variant="outlined"
                    disabled={isFormSubmitting}
                  />
                </Box>

                <Box sx={{ display: 'flex', gap: 1, flexDirection: { xs: 'column', sm: 'row' } }}>
                  <FormControl fullWidth disabled={isFormSubmitting}>
                    <InputLabel>Currency</InputLabel>
                    <Select
                      name="currency"
                      value={productType === 'bundle' ? bundleFormData.currency : formData.currency}
                      onChange={handleSelectChange}
                      label="Currency"
                    >
                      <MenuItem value="USD">USD ($)</MenuItem>
                      <MenuItem value="AED">AED (د.إ)</MenuItem>
                      <MenuItem value="GBP">GBP (£)</MenuItem>
                      <MenuItem value="INR">INR (₹)</MenuItem>
                    </Select>
                  </FormControl>
                </Box>
              </Box>

              {/* Pricing Tab - COD Section */}
              <Card sx={{ mt: 2, border: `1px solid ${shopifyColors.border}`, borderRadius: '8px' }}>
                <CardContent>
                  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <Payments sx={{ color: shopifyColors.primary }} />
                      <Typography variant="subtitle1" sx={{ fontWeight: 600, color: shopifyColors.textPrimary }}>
                        Cash on Delivery (COD)
                      </Typography>
                    </Box>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={codEnabled === 1}
                          onChange={handleCodToggleChange}
                          sx={{
                            '& .Mui-checked': { color: shopifyColors.primary },
                            '& .Mui-checked + .MuiSwitch-track': { bgcolor: shopifyColors.primary }
                          }}
                        />
                      }
                      label={codEnabled === 1 ? 'Enabled' : 'Disabled'}
                      labelPlacement="start"
                    />
                  </Box>

                  {/* Show global COD settings for reference */}
                  {paymentMethodsResponse?.data && (
                    <Box sx={{ mt: 2, p: 2, bgcolor: '#fafbfb', borderRadius: '6px', border: `1px solid ${shopifyColors.border}` }}>
                      <Typography variant="caption" sx={{ color: shopifyColors.textSecondary, fontWeight: 600, fontSize: '11px', textTransform: 'uppercase' }}>
                        Global COD Settings
                      </Typography>
                      {(() => {
                        const codMethod = paymentMethodsResponse.data.find(
                          (method: PaymentMethod) => method.code === 'COD'
                        );
                        if (codMethod) {
                          return (
                            <Box sx={{ display: 'flex', gap: 2, mt: 1 }}>
                              <Chip
                                label={codMethod.status === 1 ? 'Active' : 'Inactive'}
                                size="small"
                                sx={{
                                  bgcolor: codMethod.status === 1 ? '#d1f4e0' : '#ffebee',
                                  color: codMethod.status === 1 ? '#00783e' : '#c62828',
                                  fontWeight: 600,
                                  fontSize: '11px'
                                }}
                              />
                              <Typography variant="body2" sx={{ color: shopifyColors.textSecondary }}>
                                Extra Charge: <strong>{formatCurrencyAED(Number(codMethod.extra_charge) || 0)}</strong>
                              </Typography>
                            </Box>
                          );
                        }
                        return (
                          <Typography variant="body2" sx={{ color: shopifyColors.warning, mt: 1 }}>
                            No COD payment method configured globally
                          </Typography>
                        );
                      })()}
                    </Box>
                  )}

                  
                </CardContent>
              </Card>
            </TabPanel>

            {/* Bundle Products Tab */}
            {productType === 'bundle' && (
              <TabPanel value={tabValue} index={2}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  <Typography variant="h6" gutterBottom>
                    Select Products for Bundle
                  </Typography>

                  {formErrors.products && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                      {formErrors.products}
                    </Alert>
                  )}

                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 3, height: '400px' }}>
                    {/* Available Products List */}
                    <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                      <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderBottom: '1px solid #e0e0e0' }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Available Products ({availableProducts.length})
                        </Typography>
                      </Box>
                      <Box sx={{ height: '350px', overflow: 'auto' }}>
                        <List>
                          {availableProducts.map((product) => (
                            <ListItem key={product.product_id || product.id} disablePadding>
                              <ListItemButton
                                onClick={() => handleProductSelection(product)}
                                selected={selectedProducts.some(p => p.product_id === (product.product_id || product.id))}
                              >
                                <ListItemIcon>
                                  <Checkbox
                                    edge="start"
                                    checked={selectedProducts.some(p => p.product_id === (product.product_id || product.id))}
                                    tabIndex={-1}
                                    disableRipple
                                  />
                                </ListItemIcon>
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flex: 1 }}>
                                  <Avatar
                                    src={product.product_main_image ? `https://fftestservice.sarsetech.com/images/${product.product_main_image}` : undefined}
                                    variant="rounded"
                                    sx={{ width: 40, height: 40 }}
                                  >
                                    {product.prod_short_name?.[0] || product.prod_name?.[0] || 'P'}
                                  </Avatar>
                                  <Box sx={{ flex: 1 }}>
                                    <Typography variant="body2" fontWeight="medium">
                                      {product.prod_name}
                                    </Typography>
                                    <Typography variant="caption" color="text.secondary">
                                      {formatCurrencyAED(product.product_price || 0, product.currency)}
                                    </Typography>
                                  </Box>
                                </Box>
                              </ListItemButton>
                            </ListItem>
                          ))}
                        </List>
                      </Box>
                    </Box>

                    {/* Selected Products with Quantities */}
                    <Box sx={{ flex: 1, border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
                      <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderBottom: '1px solid #e0e0e5' }}>
                        <Typography variant="subtitle1" fontWeight="bold">
                          Selected Products ({selectedProducts.length})
                        </Typography>
                      </Box>
                      <Box sx={{ height: '350px', overflow: 'auto' }}>
                        {selectedProducts.length === 0 ? (
                          <Box sx={{ p: 3, textAlign: 'center' }}>
                            <Typography variant="body2" color="text.secondary">
                              No products selected. Choose products from the left panel.
                            </Typography>
                          </Box>
                        ) : (
                          <List>
                            {selectedProducts.map((bundleProduct) => (
                              <ListItem key={bundleProduct.product_id} disablePadding>
                                <Box sx={{ p: 2, width: '100%' }}>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 1 }}>
                                    <Avatar
                                      src={bundleProduct.product_main_image ? `https://fftestservice.sarsetech.com/images/${bundleProduct.product_main_image}` : undefined}
                                      variant="rounded"
                                      sx={{ width: 40, height: 40 }}
                                    >
                                      {bundleProduct.product_name?.[0] || 'P'}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography variant="body2" fontWeight="medium">
                                        {bundleProduct.product_name}
                                      </Typography>
                                      <Typography variant="caption" color="text.secondary">
                                        {formatCurrencyAED(bundleProduct.product_price || 0, bundleFormData.currency)}
                                      </Typography>
                                    </Box>
                                    <IconButton
                                      size="small"
                                      color="error"
                                      onClick={() => handleProductSelection({
                                        product_id: bundleProduct.product_id,
                                        prod_name: bundleProduct.product_name,
                                        product_price: bundleProduct.product_price,
                                        product_main_image: bundleProduct.product_main_image,
                                      } as Product)}
                                    >
                                      <Delete />
                                    </IconButton>
                                  </Box>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <Typography variant="body2">Quantity:</Typography>
                                    <TextField
                                      size="small"
                                      type="number"
                                      value={productQuantities[bundleProduct.product_id] || 1}
                                      onChange={(e) => handleProductQuantityChange(
                                        bundleProduct.product_id,
                                        Math.max(1, parseInt(e.target.value) || 1)
                                      )}
                                      inputProps={{ min: 1 }}
                                      sx={{ width: 80 }}
                                    />
                                  </Box>
                                </Box>
                              </ListItem>
                            ))}
                          </List>
                        )}
                      </Box>
                    </Box>
                  </Box>

                  {/* Bundle Summary */}
                  {selectedProducts.length > 0 && (
                    <Box sx={{ p: 2, bgcolor: '#f8f9fa', borderRadius: 1 }}>
                      <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Bundle Summary
                      </Typography>
                      <Box sx={{ display: 'flex', gap: 3, flexWrap: 'wrap' }}>
                        <Typography variant="body2">
                          <strong>Total Products:</strong> {selectedProducts.length}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Total Items:</strong> {selectedProducts.reduce((sum, product) => sum + (productQuantities[product.product_id] || 1), 0)}
                        </Typography>
                        <Typography variant="body2">
                          <strong>Individual Total:</strong> {formatCurrencyAED(
                            selectedProducts.reduce((sum, product) =>
                              sum + (product.product_price || 0) * (productQuantities[product.product_id] || 1), 0
                            ),
                            bundleFormData.currency
                          )}
                        </Typography>
                        <Typography variant="body2" color="primary">
                          <strong>Bundle Price:</strong> {formatCurrencyAED(bundleFormData.bundle_price, bundleFormData.currency)}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Box>
              </TabPanel>
            )}

            {/* Additional Property Tab - only show when editing single product */}
            {productType === 'single' && isEditing && (
              <TabPanel value={tabValue} index={2}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                  {/* ADDITIONAL PRICES PACKS SECTION */}
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <AttachMoney />
                        <Typography variant="subtitle1">Additional Price Packs</Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <PricePackManager productId={editingProduct?.id || 0} />
                    </AccordionDetails>
                  </Accordion>

                  {/* SIZE MANAGEMENT SECTION */}
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Style />
                        <Typography variant="subtitle1">Size Management</Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <SizeManager
                        productId={editingProduct?.id || 0}
                        sizes={productSizes}
                        onRefresh={refetchProductSizes}
                      />
                    </AccordionDetails>
                  </Accordion>

                  {/* COLOR MANAGEMENT SECTION */}
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Palette />
                        <Typography variant="subtitle1">Color Management</Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <ColorManager
                        productId={editingProduct?.id || 0}
                        colors={productColors}
                        onRefresh={refetchProductColors}
                      />
                    </AccordionDetails>
                  </Accordion>

                  {/* ADDITIONAL PROPERTIES SECTION */}
                  <Accordion>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Style />
                        <Typography variant="subtitle1">Additional Properties</Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                      <PropertyManager productId={editingProduct?.id || 0} />
                    </AccordionDetails>
                  </Accordion>
                </Box>
              </TabPanel>
            )}

            {/* Shipping Model Tab */}
            {/*      <TabPanel value={tabValue} index={productType === 'bundle' ? 3 : (isEditing ? 3 : 2)}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Shipping Model Configuration
                </Typography>

                {shippingModels.length > 0 ? (
                  <FormControl fullWidth disabled={isFormSubmitting}>
                    <InputLabel>Shipping Model</InputLabel>
                    <Select
                      name="shipping_model"
                      value={productType === 'bundle' ? (bundleFormData.shipping_model?.toString() || '1') : (formData.shipping_model?.toString() || '1')}
                      onChange={handleSelectChange}
                      label="Shipping Model"
                    >
                      {shippingModels.map((model) => (
                        <MenuItem key={model.id} value={model.id}>
                          {model.model_name}
                        </MenuItem>
                      ))}
                    </Select>
                    <FormHelperText>
                      Select the shipping model for this {productType === 'bundle' ? 'bundle' : 'product'}
                    </FormHelperText>
                  </FormControl>
                ) : (
                  <Box sx={{ textAlign: 'center', py: 3 }}>
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ mt: 1 }}>
                      Loading shipping models...
                    </Typography>
                  </Box>
                )}

                <Box sx={{ mt: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    Shipping models define how shipping charges are calculated for this {productType === 'bundle' ? 'bundle' : 'product'}.
                  </Typography>
                </Box>
              </Box>
            </TabPanel>  */}

            {/* Delivery Model Tab - FIXED WITH SELECTABLE DEFAULT OPTION */}
            <TabPanel value={tabValue} index={productType === 'bundle' ? 3 : (isEditing ? 3 : 2)}>
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
                <Typography variant="h6" gutterBottom>
                  Delivery Model Configuration
                </Typography>

                <Typography variant="body2" color="text.secondary" gutterBottom>
                  Select the delivery models available for this {productType === 'bundle' ? 'bundle' : 'product'}.
                  {defaultDeliveryModel && (
                    <Alert severity="info" sx={{ mt: 2, mb: 1 }}>
                      <Typography variant="body2">
                        <strong>Default Delivery Method:</strong> {defaultDeliveryModel.model_name} - This method is automatically included
                        for all products. You can manually select or unselect it below.
                      </Typography>
                    </Alert>
                  )}
                </Typography>

                {availableDeliveryModels.length === 0 ? (
                  <Box sx={{ textAlign: 'center', py: 3 }}>
                    <CircularProgress size={24} />
                    <Typography variant="body2" sx={{ mt: 1, color: shopifyColors.textSecondary }}>
                      Loading delivery methods...
                    </Typography>
                  </Box>
                ) : (
                  <FormControl fullWidth disabled={isFormSubmitting} component="fieldset">
                    <FormLabel component="legend" sx={{ mb: 2, color: 'text.primary', fontWeight: 600 }}>
                      Available Delivery Models
                    </FormLabel>

                    <Box sx={{
                      border: '1px solid rgba(0, 0, 0, 0.23)',
                      borderRadius: '4px',
                      p: 2,
                      maxHeight: '300px',
                      overflow: 'auto',
                      '&:hover': {
                        borderColor: 'rgba(0, 0, 0, 0.87)',
                      }
                    }}>
                      <FormGroup>
                        {availableDeliveryModels.map((model) => {
                          const isDefault = model.is_default === 1;

                          // ✅ Single source of truth — no length > 0 guards
                          // Editing  → always tempDeliveryModels / tempBundleDeliveryModels (loaded from junction table API)
                          // Adding   → always formData.delivery_model / bundleFormData.delivery_model
                          let currentModels: number[] = [];
                          if (productType === 'bundle') {
                            currentModels = isEditingBundle
                              ? tempBundleDeliveryModels.map(Number).filter(n => !isNaN(n))
                              : (Array.isArray(bundleFormData.delivery_model)
                                ? bundleFormData.delivery_model.map(Number).filter(n => !isNaN(n))
                                : []);
                          } else {
                            currentModels = isEditing
                              ? tempDeliveryModels.map(Number).filter(n => !isNaN(n))
                              : (Array.isArray(formData.delivery_model)
                                ? formData.delivery_model.map(Number).filter(n => !isNaN(n))
                                : []);
                          }

                          const isSelected = currentModels.includes(model.id);

                          return (
                            <FormControlLabel
                              key={model.id}
                              control={
                                <Checkbox
                                  checked={isSelected}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;

                                    if (productType === 'bundle') {
                                      if (isEditingBundle) {
                                        // Editing bundle – use tempBundleDeliveryModels with functional update
                                        setTempBundleDeliveryModels(prev => {
                                          if (isChecked) {
                                            return prev.includes(model.id) ? prev : [...prev, model.id];
                                          } else {
                                            return prev.filter(id => id !== model.id);
                                          }
                                        });
                                      } else {
                                        // New bundle – update bundleFormData.delivery_model with functional update
                                        setBundleFormData(prev => {
                                          // Ensure we work with an array of numbers
                                          const current = Array.isArray(prev.delivery_model)
                                            ? prev.delivery_model.map(item => Number(item)).filter(id => !isNaN(id))
                                            : [];
                                          if (isChecked) {
                                            return current.includes(model.id)
                                              ? prev
                                              : { ...prev, delivery_model: [...current, model.id] };
                                          } else {
                                            return { ...prev, delivery_model: current.filter(id => id !== model.id) };
                                          }
                                        });
                                      }
                                    } else {
                                      if (isEditing) {
                                        // Editing product – use tempDeliveryModels with functional update
                                        setTempDeliveryModels(prev => {
                                          if (isChecked) {
                                            return prev.includes(model.id) ? prev : [...prev, model.id];
                                          } else {
                                            return prev.filter(id => id !== model.id);
                                          }
                                        });
                                      } else {
                                        // New product – update formData.delivery_model with functional update
                                        setFormData(prev => {
                                          const current = Array.isArray(prev.delivery_model)
                                            ? prev.delivery_model.map(item => Number(item)).filter(id => !isNaN(id))
                                            : [];
                                          if (isChecked) {
                                            return current.includes(model.id)
                                              ? prev
                                              : { ...prev, delivery_model: [...current, model.id] };
                                          } else {
                                            return { ...prev, delivery_model: current.filter(id => id !== model.id) };
                                          }
                                        });
                                      }
                                    }
                                  }}
                                  disabled={isFormSubmitting}
                                />
                              }
                              label={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
                                  <Box sx={{ flex: 1 }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                      <Typography variant="body2" sx={{
                                        fontWeight: isDefault ? 600 : 400,
                                        color: isDefault ? shopifyColors.primary : 'inherit'
                                      }}>
                                        {model.model_name}
                                      </Typography>
                                      {isDefault && (
                                        <Chip
                                          label="Default"
                                          size="small"
                                          sx={{
                                            bgcolor: shopifyColors.warning,
                                            color: '#000',
                                            fontWeight: 500,
                                            fontSize: '0.7rem',
                                            height: '18px'
                                          }}
                                        />
                                      )}
                                    </Box>
                                    <Typography variant="caption" sx={{ color: shopifyColors.textSecondary }}>
                                      {model.delivery_type === 0
                                        ? `${model.hours} hour${model.hours > 1 ? 's' : ''} delivery`
                                        : `${model.days} day${model.days > 1 ? 's' : ''} delivery`
                                      }
                                      {model.display_text && ` • ${model.display_text}`}
                                    </Typography>
                                  </Box>
                                  <Chip
                                    label={model.delivery_charge || 'FREE'}
                                    size="small"
                                    variant="outlined"
                                    sx={{
                                      borderColor: shopifyColors.primary,
                                      color: shopifyColors.primary,
                                      fontWeight: 500,
                                      fontSize: '0.75rem'
                                    }}
                                  />
                                </Box>
                              }
                              sx={{
                                mb: 2,
                                '&:hover': {
                                  bgcolor: 'rgba(0, 0, 0, 0.04)',
                                  borderRadius: '4px',
                                  px: 1
                                }
                              }}
                            />
                          );
                        })}
                      </FormGroup>
                    </Box>

                    <FormHelperText>
                      {(() => {
                        // ✅ Same single source logic as checkboxes
                        let currentModels: number[] = [];
                        if (productType === 'bundle') {
                          currentModels = isEditingBundle
                            ? tempBundleDeliveryModels.map(Number).filter(n => !isNaN(n))
                            : (Array.isArray(bundleFormData.delivery_model)
                              ? bundleFormData.delivery_model.map(Number).filter(n => !isNaN(n))
                              : []);
                        } else {
                          currentModels = isEditing
                            ? tempDeliveryModels.map(Number).filter(n => !isNaN(n))
                            : (Array.isArray(formData.delivery_model)
                              ? formData.delivery_model.map(Number).filter(n => !isNaN(n))
                              : []);
                        }

                        // Check if default is selected
                        const hasDefault = defaultDeliveryModel ? currentModels.includes(defaultDeliveryModel.id) : false;
                        const selectedCount = currentModels.length;

                        return (
                          <Box>
                            <Typography variant="caption">
                              {selectedCount} delivery method{selectedCount !== 1 ? 's' : ''} selected
                              {!hasDefault && defaultDeliveryModel && (
                                <Typography component="span" variant="caption" sx={{
                                  color: shopifyColors.warning,
                                  fontWeight: 500,
                                  ml: 1
                                }}>
                                  (Default method not selected)
                                </Typography>
                              )}
                            </Typography>
                            <Typography variant="caption" sx={{ display: 'block', color: shopifyColors.textSecondary, mt: 0.5 }}>
                              Tip: The default delivery method is recommended but optional
                            </Typography>
                          </Box>
                        );
                      })()}
                    </FormHelperText>
                  </FormControl>
                )}

                {/* Information Note */}
                <Box sx={{ mt: 2 }}>
                  <Alert severity="info" sx={{ borderRadius: '6px' }}>
                    <Typography variant="body2">
                      <strong>Important:</strong> You can select or unselect any delivery method, including the default.
                      If no delivery methods are selected, the default method will be used automatically.
                    </Typography>
                  </Alert>
                </Box>

                {/* Action buttons for delivery methods */}
                <Box sx={{ display: 'flex', gap: 1, mt: 1 }}>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      // Select all delivery methods
                      if (productType === 'bundle') {
                        if (isEditingBundle) {
                          setTempBundleDeliveryModels(availableDeliveryModels.map(model => model.id));
                        } else {
                          setBundleFormData(prev => ({
                            ...prev,
                            delivery_model: availableDeliveryModels.map(model => model.id)
                          }));
                        }
                      } else {
                        if (isEditing) {
                          setTempDeliveryModels(availableDeliveryModels.map(model => model.id));
                        } else {
                          setFormData(prev => ({
                            ...prev,
                            delivery_model: availableDeliveryModels.map(model => model.id)
                          }));
                        }
                      }
                    }}
                    disabled={isFormSubmitting}
                  >
                    Select All
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      // Deselect all delivery methods
                      if (productType === 'bundle') {
                        if (isEditingBundle) {
                          setTempBundleDeliveryModels([]);
                        } else {
                          setBundleFormData(prev => ({
                            ...prev,
                            delivery_model: []
                          }));
                        }
                      } else {
                        if (isEditing) {
                          setTempDeliveryModels([]);
                        } else {
                          setFormData(prev => ({
                            ...prev,
                            delivery_model: []
                          }));
                        }
                      }
                    }}
                    disabled={isFormSubmitting}
                  >
                    Deselect All
                  </Button>
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={() => {
                      // Select only default
                      if (defaultDeliveryModel) {
                        if (productType === 'bundle') {
                          if (isEditingBundle) {
                            setTempBundleDeliveryModels([defaultDeliveryModel.id]);
                          } else {
                            setBundleFormData(prev => ({
                              ...prev,
                              delivery_model: [defaultDeliveryModel.id]
                            }));
                          }
                        } else {
                          if (isEditing) {
                            setTempDeliveryModels([defaultDeliveryModel.id]);
                          } else {
                            setFormData(prev => ({
                              ...prev,
                              delivery_model: [defaultDeliveryModel.id]
                            }));
                          }
                        }
                      }
                    }}
                    disabled={isFormSubmitting || !defaultDeliveryModel}
                  >
                    Select Default Only
                  </Button>
                </Box>
              </Box>
            </TabPanel>
          </DialogContent>

          <DialogActions sx={{ p: 3, pt: 1, gap: 1 }}>
            <Button
              onClick={handleFormClose}
              disabled={isFormSubmitting}
              variant="outlined"
              sx={{ width: { xs: '100%', sm: 'auto' }, color: '#eeeeee', bgcolor: '#f44336' }}
            >
              Close
            </Button>
            <Button
              onClick={handleFormClose}
              disabled={isFormSubmitting}
              variant="outlined"
              sx={{ width: { xs: '100%', sm: 'auto' }, color: '#eeeeee', bgcolor: '#F78E12' }}
            >
              Cancel
            </Button>
            {tabValue < getLastTabIndex() ? (
              <Button
                type="button"
                variant="contained"
                onClick={handleNextTab}
                disabled={isFormSubmitting}
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                Next
              </Button>
            ) : (
              <Button
                type="submit"
                variant="contained"
                disabled={isFormSubmitting ||
                  (productType === 'bundle'
                    ? !bundleFormData.bundle_name?.trim() || !bundleFormData.bundle_short_name.trim() || !bundleFormData.cat_id || selectedProducts.length === 0
                    : !formData.product_name?.trim() || !formData.product_short_name.trim() || !formData.cat_id || formData.product_stock < 0
                  )
                }
                sx={{ width: { xs: '100%', sm: 'auto' } }}
              >
                {isFormSubmitting ? (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <CircularProgress size={20} color="inherit" />
                    {isEditing || isEditingBundle ? 'Updating...' : 'Adding...'}
                  </Box>
                ) : (
                  isEditing || isEditingBundle ? `Update ${productType === 'bundle' ? 'Bundle' : 'Product'}` : `Add ${productType === 'bundle' ? 'Bundle' : 'Product'}`
                )}
              </Button>
            )}
          </DialogActions>
        </form>
      </Dialog>

      {/* Snackbar for notifications */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{
            width: '100%',
            borderRadius: '6px',
            fontWeight: 500
          }}
          variant="filled"
        >
          {snackbar.message}
        </Alert>
      </Snackbar>


      {/* Return Limit Snackbar */}
      <Snackbar
        open={returnLimitSnackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseReturnLimitSnackbar}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}   // ← add this line
      >
        <Alert
          onClose={handleCloseReturnLimitSnackbar}
          severity={returnLimitSnackbar.severity}
          sx={{
            width: '100%',
            borderRadius: '6px',
            fontWeight: 500,
          }}
          variant="filled"
        >
          {returnLimitSnackbar.message}
        </Alert>
      </Snackbar>

      {/* Product Tax Snackbar */}
      <Snackbar
        open={productTaxSnackbar.open}
        autoHideDuration={5000}
        onClose={handleCloseProductTaxSnackbar}
      >
        <Alert
          onClose={handleCloseProductTaxSnackbar}
          severity={productTaxSnackbar.severity}
          sx={{
            width: '100%',
            borderRadius: '6px',
            fontWeight: 500,
          }}
          variant="filled"
        >
          {productTaxSnackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default ProductManagement;